webpackJsonp([1],{

/***/ 15:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAArCAYAAACTkhN2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABFVJREFUeNrslm1MW2UUx/+2MGhX1jt56ZAhLGwJoMzijJ2EbGvmwA8mDDV+4QMSX2LUZNmyaYwuQHydM6YkfnAxscXXRKcZmZqMDcUxNsc2bAXtYm3oNhl2s3DJsNgJ4nOe3Usul9v23shHT3Jzb5/nnN/9P+ee5zwF/jcNuymdw50F7Y+w22Z2laqmIuz6bvBKq88wnEHb2G2HzbZMcNbkI9dhwbrKlXwu9PMEYtFp+E9exdTUdZENdbCXtKWFM6iT3bz5Dqvz/qYy1DVWIi83D1aLBZlZWdzn70QC8elpiOIEvj44hC8/CuNqNO5nUy3sJX5NuAT+dkPNKuHx5+5C1fryeWAyi8fjOP9TCO/uO4tzJ3+nVbjlF5gVYIHdfqitKxJ2v+pGxW3lMGdkpP1omZmZKCxahaq7V2Ls0nj2xfC1+wqXuzvH/uz9y6Tw85aW2YWn99aipHSN4cqgmCefvweMQR/eO58WpnoLpWOfz41NW1041hXEmy92Y1Kc1gW2CxbsfrkO9zZU4MjhfrQ91UfDbnndzSwdKK8qhdls5mByXp6Thdpt61KC/acvITo6yWPqH7gd1a612FATovw3y2nZfofLgYICB/9Bip2uYrTvOIyD3rNJwd6OE9jT8hn3lVdJjPUb8znTJFWIUL2xmKuWzVFkxzufN+HA/uN4bc9Xi8A09vGBAe5DvrIRw7W5hB4FUk5Vgpvz7IsAZRUOfHj0UZwfinLY1LUEv+iZxmiOfNSWm7+C3+drzZxh1lw6qdrZvg1PNL7PgWTBH8fwVufDCxQrbZm0N+ZL8TrbdVp24miI5/XZV+rZB3fwi553NX+KI18Ma8bILFLOd9PohfFF9U3Be5/pwktvN/BKUFqOPZvPkannQsErN5SzrUpb1h84M8p7hmzhYJSXFy1fHSwDP+l5jPuQr2zEGBoY5VUq57zz+57Lzu1NMRQW3sI3xfHuEK9124psXsvJjHzIt7jkRsf8YzyGU8cuc6YM9wUDsdb+b4JCw0O5vLw8bT0YxEXd2/+N9x7kqvu6hxEJT1I2fAv6d33V/rmBU+fmEonE3MzMjKGLYiiWGNJZAGXj8rCeLL6+qw+BwWHMzs7qVk2+FEOxjEEnlGdBy6UWyVqlRZxIbBk+E0VB8T8s91ZYrNaU4PFYDAP9AXheOE3pgPLAUB8WtFtHaNey4w1bG2/Fpro1WFu5GjZbzgLopChi5Jcx9jFH0PXBr/JwLwO7Ux1zlK9W5Rjr0VhdZuPnKBmdn7+Fp2SlSqtOesyp1Rs8L3wM3KIcMKk9pE210yBYM8ak5Sn9F4kYgHdIotLDJWs3oNqjNZEUbkC9pup0yvWoT6o6LVyHel8y1XqU8+6WKiWpAvXAPdLy1Ua7MfKf4NKyDxlckW7lyZZ/aEngUr+IqFIiLpVytfouPQFG4L1JnpfGWMccYdecXv8Mg3y/kYZmFB6gv+N6nU0G4ZTrC3qd/xVgAEZr8gov9EPsAAAAAElFTkSuQmCC"

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAuCAMAAABteatCAAAAXVBMVEUAAAD/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/Qzj/////cmr/0M3/8/P/ioP/6Ob/W1H/oZz/lY//T0T/xMH/Zl3/fnb/ubT/3Nr/rahfugKkAAAADnRSTlMAQN/vgJ9gIBC/MM9wUN4yg0kAAAF9SURBVDjLlZXZloMgDEBptetMSQibuPT/P3MqaoPYhbmPnluyEFIROdV7+Zaf41nM/FbyI/vd5B3kV46jV8sCHmee8m840ubRs8CNV0DqAVDQK1OIKtEcKW1lpPXG6FS8JjGNQpmgjbIs7vg7eLmm6andippQbvDU5iICewmOmrXYkJcvCWot3pVkbNKahrpUtGDZawlcWnsqurDywHj+IWEimu4Z1huI9It671m0sGg9PCG93AOLOJfSEcSrntVeRmAWOUUNQVscsX5gk5DFqcre6gEmgsbx3Ji62ojtAIzpPAHlYlj6opxH1C7QeCoSIIfmYobQWX1XD4JrOwUw6ChC3p4mbY5xnQFQ3B5ueGzOKkk1NNxwvkKMCT7w97moaRgJs6Gw6WzHPiEPxWbMGHTIY1Y0uMVPofRxlT7XwgXQ/H+lFC+p4rVXvEhLV3P5si//+2BuL+TLVbyirrKQN/GGU1pXVXPILbvL4h1O4jPHfUxuJ75yrmV1FDl/8PZee1Cd0rIAAAAASUVORK5CYII="

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car.658fe23.png";

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_materials__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_materials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_materials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifications__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_toastr__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mini_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mini_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_notification__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_progressbar__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_progressbar__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_progressbar___default.a, {
  color: 'rgb(255, 102, 0)',
  failedColor: 'red',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
});

window.http = __WEBPACK_IMPORTED_MODULE_11_axios___default.a.create({
  // baseURL: 'https://mensajeros.guepardos.co/api/v2/'
  baseURL: 'http://localhost:3005/api/v2/'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyAXR2_IBAefo-cZesOHbhdpWNPk4V08U7o',
    libraries: 'geometry,places'
  }
});

var toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};

__WEBPACK_IMPORTED_MODULE_9_mini_toastr___default.a.init({ types: toastTypes });

function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb;

  return __WEBPACK_IMPORTED_MODULE_9_mini_toastr___default.a[type](message, title, timeout, cb);
}

var options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_notifications___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_materials___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_6_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_json_to_csv__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_json_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */






var jStat = __webpack_require__(308).jStat;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'servicio',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 13,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mostrarClientes: false,
      startDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),
      endDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(30, 'day').format('YYYY-MM-DD'),
      messengers: [],
      messengerSelected: null,
      minEntries: 1,
      filteredServices: [],
      eficiencias: [],
      grandTotal: 0,
      mostrarTabla: false,
      mostrarLoader: false,
      regreso: false,
      csvData: [],
      muestras: [],
      devEst: 0,
      optimo: 0,
      normal: 0,
      serviciosOptimos: [],
      serviciosNormales: [],
      serviciosIneficientes: [],
      serviciosDeficientes: [],
      clienteSeleccionado: null,
      limite: 15,
      ineficiente: 0,
      ineficienteEntrega: 0,
      optimoEntrega: 0,
      normalEntrega: 0,
      formatNumber: {
        separador: '.', // separador para los miles
        sepDecimal: ',', // separador para los decimales
        formatear: function formatear(num) {
          num += '';
          var splitStr = num.split('.');
          var splitLeft = splitStr[0];
          var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
          var regx = /(\d+)(\d{3})/;
          while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
          }
          return this.simbol + splitLeft + splitRight;
        },
        new: function _new(num, simbol) {
          this.simbol = simbol || '';
          return this.formatear(Math.round(num / 100) * 100);
        }
      },
      clientes: [],
      cliente: ''
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/mensajerosEficiencia').then(function (response) {
      _this.messengers = response.data.map(function (item, index) {
        return {
          text: item.nombre,
          id: item.id,
          value: index + 1
        };
      });
      _this.messengers.unshift({
        text: 'Todos los mensajeros',
        id: '000000',
        value: 0
      });
    });
    __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__["loaded"].then(function () {
      _this.$refs.mapEficiencia.$mapCreated.then(function () {
        var src = 'https://storage.googleapis.com/gpds-geo-zonas/MunicipiosDelAreaMetro.kml';
        var kmlLayer = new google.maps.KmlLayer(src, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: _this.$refs.mapEficiencia.$mapObject
        });
      });
    });
  },

  methods: {
    generarReporte: function generarReporte() {
      var _this2 = this;

      this.mostrarTabla = false;
      this.mostrarLoader = true;
      if (this.clienteSeleccionado) {
        return this.consultarPorCliente();
      }
      this.$Progress.start();
      var sDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.startDate).utc().toISOString();
      var eDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.endDate).utc().toISOString();
      var objectQuery = {
        startDate: sDate,
        endDate: eDate
      };
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('https://mensajeria.guepardos.co/api/v2/serviciosEficiencia', objectQuery).then(function (response) {
        if (!_this2.messengerSelected || _this2.messengerSelected === '000000') {
          _this2.filteredServices = response.data.filter(function (item) {
            if (item.tarifa) {
              if (item.tarifa.numEntregas) {
                if (item.tarifa.numEntregas === Number(_this2.minEntries) && item.idaVuelta === _this2.regreso) {
                  return item;
                }
              }
            }
          });
          if (_this2.filteredServices.length < 30) {
            _this2.$Progress.finish();
            _this2.mostrarLoader = false;
            _this2.errorBusqueda();
            return;
          } else if (_this2.filteredServices.length >= 30 && _this2.filteredServices.length < 50) {
            _this2.pasanWarning();
          }
          return _this2.drawMarkers();
        }
        _this2.filteredServices = response.data.filter(function (item) {
          return item.mensajeroId === _this2.messengerSelected;
        });
        _this2.filteredServices = response.data.filter(function (item) {
          if (item.tarifa) {
            if (item.tarifa.numEntregas) {
              if (item.tarifa.numEntregas === Number(_this2.minEntries) && item.idaVuelta === _this2.regreso) {
                return item;
              }
            }
          }
        });
        if (_this2.filteredServices.length < 30) {
          _this2.$Progress.finish();
          _this2.mostrarLoader = false;
          _this2.errorBusqueda();
          return;
        } else if (_this2.filteredServices.length >= 30 && _this2.filteredServices.length < 50) {
          _this2.pasanWarning();
        }
        _this2.drawMarkers();
        _this2.$Progress.finish();
      }).catch(function (error) {
        console.log(error);
        _this2.mostrarLoader = false;
        _this2.$Progress.finish();
      });
    },
    consultarPorCliente: function consultarPorCliente() {
      var _this3 = this;

      this.$Progress.start();
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('http://localhost:3005/api/v2/serviciosEficiencia/' + this.clienteSeleccionado.id).then(function (response) {
        _this3.$Progress.finish();
        _this3.filteredServices = response.data;
        var numEntregas = response.data.reduce(function (a, b) {
          if (b.tarifa) {
            if (b.tarifa.numEntregas) {
              return a + b.tarifa.numEntregas;
            }
          }
          return a;
        }, 0);
        _this3.minEntries = Math.round(numEntregas / response.data.length);
        if (_this3.filteredServices.length < 30) {
          _this3.mostrarLoader = false;
          _this3.errorBusqueda();
          return;
        } else if (_this3.filteredServices.length >= 30 && _this3.filteredServices.length < 50) {
          _this3.pasanWarning();
        }
        return _this3.drawMarkers();
      });
    },
    drawMarkers: function drawMarkers() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var index, servicio, indexEntrega, entrega;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.markers = [];
                _this4.muestras = [];
                if (_this4.minEntries === 1) {
                  _this4.limite = 30;
                }
                if (_this4.clienteSeleccionado) {
                  _this4.limite = 10000;
                }
                for (index = 0; index < _this4.filteredServices.length; index++) {
                  servicio = _this4.filteredServices[index];

                  servicio.total = 0;
                  if (servicio.tarifa.distancia) {
                    servicio.total = servicio.tarifa.distancia / servicio.tarifa.numEntregas;
                    if (servicio.total <= _this4.limite && servicio.total > 1) {
                      _this4.muestras.push(servicio.total);
                    }
                  }
                  for (indexEntrega = 0; indexEntrega < servicio.tarifa.numEntregas; indexEntrega++) {
                    entrega = servicio.fechaHoraEntregas[indexEntrega];

                    if (entrega) {
                      _this4.markers.push({
                        position: {
                          lat: parseFloat(entrega.coordenadas.latitude),
                          lng: parseFloat(entrega.coordenadas.longitude)
                        },
                        id: servicio.id,
                        infoText: '<strong>Nombre: </strong>' + servicio.nombre + '<br><strong>Fecha: </strong>' + servicio.fecha + '<br><strong>Eficiencia: </strong>' + parseFloat(servicio.total).toFixed(2) + ' km',
                        icon: __webpack_require__(31)
                      });
                    }
                  }
                }
                _this4.filteredServices = _this4.filteredServices.filter(function (item) {
                  return item.total > 0;
                });
                _this4.grandTotal = _this4.grandTotal / _this4.filteredServices.length;
                _this4.grandTotal = parseFloat(_this4.grandTotal).toFixed(2);
                _this4.calcularPrecio();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    calcularPrecio: function calcularPrecio() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this5.muestras);
                _this5.grandTotal = jStat.median(_this5.muestras);
                _this5.devEst = jStat.stdev(_this5.muestras);
                _this5.devEst = parseFloat(_this5.devEst).toFixed(4);
                _context2.next = 6;
                return _this5.calcularPrecioTabla(Number(_this5.grandTotal) - Number(_this5.devEst));

              case 6:
                _this5.optimo = _context2.sent;
                _context2.next = 9;
                return _this5.calcularPrecioTabla(Number(_this5.grandTotal));

              case 9:
                _this5.normal = _context2.sent;
                _context2.next = 12;
                return _this5.calcularPrecioTabla(Number(_this5.grandTotal) + Number(_this5.devEst));

              case 12:
                _this5.ineficiente = _context2.sent;

                _this5.optimoEntrega = _this5.optimo / _this5.minEntries;
                _this5.normalEntrega = _this5.normal / _this5.minEntries;
                _this5.ineficienteEntrega = _this5.ineficiente / _this5.minEntries;
                _this5.serviciosOptimos = _this5.filteredServices.filter(function (item) {
                  return item.total < Math.round(_this5.grandTotal) - Math.round(_this5.devEst);
                });
                _this5.serviciosNormales = _this5.filteredServices.filter(function (item) {
                  return item.total > Math.round(_this5.grandTotal) - Math.round(_this5.devEst) && item.total <= Math.round(_this5.grandTotal);
                });
                _this5.serviciosIneficientes = _this5.filteredServices.filter(function (item) {
                  return item.total > Number(Math.round(_this5.grandTotal));
                });
                _this5.serviciosDeficientes = _this5.filteredServices.filter(function (item) {
                  return item.total > Number(Math.round(_this5.grandTotal) + Math.round(_this5.devEst));
                });
                _this5.serviciosOptimos = _this5.serviciosOptimos.filter(function (item) {
                  return item.fechaHoraEntregas.filter(function (o) {
                    return !o.regreso;
                  }).length === Number(_this5.minEntries);
                });
                _this5.serviciosNormales = _this5.serviciosNormales.filter(function (item) {
                  return item.fechaHoraEntregas.filter(function (o) {
                    return !o.regreso;
                  }).length === Number(_this5.minEntries);
                });
                _this5.serviciosIneficientes = _this5.serviciosIneficientes.filter(function (item) {
                  return item.fechaHoraEntregas.filter(function (o) {
                    return !o.regreso;
                  }).length === Number(_this5.minEntries);
                });
                _this5.serviciosDeficientes = _this5.serviciosDeficientes.filter(function (item) {
                  return item.fechaHoraEntregas.filter(function (o) {
                    return !o.regreso;
                  }).length === Number(_this5.minEntries);
                });
                _this5.serviciosIneficientes = _this5.serviciosIneficientes.filter(function (item) {
                  return item.total <= _this5.limite;
                });
                _this5.mostrarLoader = false;
                _this5.mostrarTabla = true;

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    lastFive: function lastFive(str) {
      return str.slice(0, 5);
    },
    calcularPrecioTabla: function calcularPrecioTabla(kilometros) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var totalKilometros, valKil, valParadas, total;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                kilometros = Math.abs(kilometros);
                totalKilometros = kilometros * Number(_this6.minEntries);

                totalKilometros = Math.round(totalKilometros);
                _context3.next = 5;
                return _this6.consultarValorKilometros(totalKilometros);

              case 5:
                valKil = _context3.sent;

                valKil = valKil[0].valorKm * totalKilometros;
                _context3.next = 9;
                return _this6.consultarParadas(Number(_this6.minEntries));

              case 9:
                valParadas = _context3.sent;

                valParadas = valParadas[0].valorParada * Number(_this6.minEntries);
                total = valKil + valParadas;
                return _context3.abrupt('return', total);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    consultarValorKilometros: function consultarValorKilometros(km) {
      var kilometros = Math.round(km);
      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/kilometrosValue/' + kilometros).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return error;
      });
    },
    consultarParadas: function consultarParadas(parada) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/paradasValue/' + parada).then(function (response) {
        _this7.$Progress.finish();
        return response.data;
      }).catch(function (error) {
        return error;
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    seleccionarCliente: function seleccionarCliente(item) {
      this.clienteSeleccionado = item;
      this.cliente = item.nombre;
      this.mostrarClientes = false;
    }
  },
  watch: {
    cliente: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      var _this8 = this;

      var obj = {
        nombre: this.cliente
      };
      if (!this.cliente) {
        this.clienteSeleccionado = null;
        return;
      }
      if (this.clienteSeleccionado) {
        if (this.clienteSeleccionado.nombre === this.cliente) {
          return;
        }
      }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('http://localhost:3005/api/v2/clientes', obj).then(function (response) {
        _this8.clientes = [];
        _this8.clientes = response.data;
        if (_this8.clientes.length > 0) {
          _this8.mostrarClientes = true;
        }
      }).catch(function (error) {
        return console.log(error.response);
      });
    }, 1000)
  },
  components: {
    VueJsonToCsv: __WEBPACK_IMPORTED_MODULE_2_vue_json_to_csv___default.a
  },
  notifications: {
    errorBusqueda: {
      title: 'Su búsqueda arrojo muy pocos datos:',
      message: '-Por favor aumente el rango de fechas. \n  -Modifique el numero de entregas',
      type: 'error',
      timeout: 9000
    },
    pasanWarning: {
      title: 'Cantidad de datos muy precisos:',
      message: '-podria ser mejor aumentar el rango de fechas',
      type: 'info',
      timeout: 9000
    }
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home'
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapa',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      GET_SERVICE_URL: 'https://evocloud-guepardos.appspot.com/api/Servicios/',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      servicio: {},
      mensajero: {},
      recogido: [],
      entregas: [],
      finalizado: [],
      waypts: [],
      lastPosition: [],
      totalEntregas: 0,
      kilometrosCirculo: 2.5,
      entregasDirecciones: [],
      estado: '',
      id: '',
      dibujarCirculos: true,
      mostrarMensajeRecogida: true
    };
  },
  mounted: function mounted() {
    this.getData();
    this.interval = setInterval(function () {
      this.getData();
    }.bind(this), 10000);
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var vm = this;
      vm.$http.get(vm.GET_SERVICE_URL + vm.$route.params.id).then(function (data) {
        vm.servicio = data.body;
        vm.id = _this.servicio.id.substr(-6);
        vm.finalizado = vm._.find(vm.servicio.fechaHoraEstados, function (o) {
          if (o.estado === 3) {
            return o;
          }
        });
        if (vm.finalizado) {
          clearInterval(vm.interval);
        }
        vm.dibujarPuntos();
        vm.$http.get(vm.GET_SERVICE_URL + vm.$route.params.id + '/Mensajero/').then(function (data) {
          vm.mensajero = data.body;
          vm.$http.get('http://backend.guepardos.co:3001/api/locations?filter[where][mensajeroId][like]=' + vm.servicio.mensajeroId + '&filter[limit]=1&filter[order]=fecha%20DESC').then(function (data) {
            if (data.body.length > 0) {
              vm.lastPosition = data.body[0].metadata.coords;
            }
          });
        });
      }, function () {
        clearInterval(vm.interval);
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
      });
    },
    dibujarPuntos: function dibujarPuntos() {
      var vm = this;
      vm.$refs.myMap.$mapCreated.then(function () {
        var geocoder = new google.maps.Geocoder();
        vm.markers = [];
        vm.recogido = vm._.find(vm.servicio.fechaHoraEstados, function (o) {
          if (o.estado === 1) {
            return o;
          }
        });
        if (vm.recogido) {
          if (vm.recogido.coordenadas.latitude === 0 && vm.recogido.coordenadas.longitude === 0) {
            vm.dinujarRecogida(vm.servicio.geoR.lat, vm.servicio.geoR.lng, true);
          } else {
            vm.dinujarRecogida(vm.recogido.coordenadas.latitude, vm.recogido.coordenadas.longitude, false);
          }
        } else {
          if (vm.mostrarMensajeRecogida) {
            vm.$notify({
              group: 'foo',
              title: 'Información',
              type: 'warning',
              text: 'El servicio ha sido asigando y está en proceso de ser recogido.',
              duration: -1
            });
          }
          vm.dinujarRecogida(vm.servicio.geoR.lat, vm.servicio.geoR.lng, true);
        }
        vm.mostrarMensajeRecogida = false;
        if (vm.servicio.fechaHoraEntregas.length > 0) {
          vm.entregas = vm.servicio.fechaHoraEntregas;
          vm.totalEntregas = vm.entregas.length;
          vm._.forEach(vm.entregas, function (entrega, index) {
            vm.markers.push({
              position: {
                lat: entrega.coordenadas.latitude,
                lng: entrega.coordenadas.longitude
              },
              infoText: 'Entrega ' + (index + 1),
              icon: __webpack_require__(15)
            });
          });
        } else {
          if (vm._.find(vm.servicio.fechaHoraEstados, function (o) {
            if (o.estado === 2) {
              return o;
            }
          })) {
            vm.entregas.push(vm._.find(vm.servicio.fechaHoraEstados, function (o) {
              if (o.estado === 2) {
                return o;
              }
            }));
            vm.totalEntregas = 1;
            if (vm.entregas[0].coordenadas.latitude === 0 && vm.entregas[0].coordenadas.longitude === 0) {
              vm.entregas[0].coordenadas.latitude = vm.servicio.geoE.lat;
              vm.entregas[0].coordenadas.longitude = vm.servicio.geoE.lng;
            }
            vm.markers.push({
              position: {
                lat: vm.entregas[0].coordenadas.latitude,
                lng: vm.entregas[0].coordenadas.longitude
              },
              infoText: 'Entrega',
              icon: __webpack_require__(15)
            });
          }
        }
        if (vm.finalizado) {
          vm.getRoute();
        } else {
          vm.markers.push({
            position: {
              lat: parseFloat(vm.lastPosition.latitude),
              lng: parseFloat(vm.lastPosition.longitude)
            },
            infoText: 'Mensajero: ' + vm.mensajero.nombre,
            icon: __webpack_require__(19)
          });
        }
        var index = vm.servicio.fechaHoraEstados.length;
        var estado = 0;
        if (index !== 0) {
          estado = vm.servicio.fechaHoraEstados[index - 1].estado;
        }
        if (estado === 0) {
          vm.estado = 'Asignado';
        } else if (estado === 1) {
          if (vm.servicio.fechaHoraEntregas.length > 0) {
            vm.estado = 'Entregado';
          } else {
            if (vm.servicio.hasOwnProperty('modificaciones')) {
              if (vm.servicio.modificaciones.hasOwnProperty('entregadoPor')) {
                vm.estado = 'Entregado';
                var marker = {
                  position: {
                    lat: 6.2269243,
                    lng: -75.5682957
                  },
                  infoText: 'Un operario ha registrado esta entrega.',
                  icon: __webpack_require__(15)
                };
                vm.markers.push(marker);
                marker.direccion = 'Central Guepardos';
                marker.index = vm.markers.length - 1;
                vm.entregasDirecciones = [];
                vm.entregasDirecciones.push(marker);
              } else {
                vm.estado = 'Recogido';
              }
            } else {
              vm.estado = 'Recogido';
            }
          }
        } else if (estado === 2) {
          vm.estado = 'Entregado';
        } else if (estado === 3) {
          vm.estado = 'Finalizado';
        }
      });
    },
    dinujarRecogida: function dinujarRecogida(lat, lng, tipo) {
      var vm = this;
      if (tipo) {
        vm.infoText = 'Punto de Recogida';
      } else {
        vm.infoText = 'Recogida';
      }
      vm.markers.push({
        position: {
          lat: lat,
          lng: lng
        },
        infoText: vm.infoText,
        icon: __webpack_require__(30)
      });
      var center = { lat: lat, lng: lng };
      vm.center = { lat: lat, lng: lng };
      if (vm.dibujarCirculos) {
        vm.dibujarCirculos = false;
        vm.$refs.myMap.resizePreserveCenter();
        var cityCircle1 = new google.maps.Circle({
          strokeColor: '#02C3BD',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#02C3BD',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: 5 * 1000
        });
        var cityCircle2 = new google.maps.Circle({
          strokeColor: '#00B9AE',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#00B9AE',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: 12 * 1000
        });
        var cityCircle3 = new google.maps.Circle({
          strokeColor: '#009F93',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#009F93',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: 18 * 1000
        });
        var cityCircle4 = new google.maps.Circle({
          strokeColor: '#037171',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#037171',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: 24 * 1000
        });
        var cityCircle5 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: 29 * 1000
        });
      }
    },
    getRoute: function getRoute() {
      var vm = this;
      vm.directionsService = new google.maps.DirectionsService();
      vm.directionsDisplay = new google.maps.DirectionsRenderer({
        'draggable': false,
        suppressMarkers: true
      });
      vm.directionsDisplay.setMap(vm.$refs.myMap.$mapObject);
      vm._.forEach(vm.entregas, function (entrega, index) {
        vm.waypts.push({
          location: { 'lat': entrega.coordenadas.latitude, 'lng': entrega.coordenadas.longitude },
          stopover: true
        });
      });
      vm.directionsService.route({
        origin: new google.maps.LatLng(vm.recogido.coordenadas.latitude, vm.recogido.coordenadas.longitude),
        destination: new google.maps.LatLng(vm.entregas[vm.entregas.length - 1].coordenadas.latitude, vm.entregas[vm.entregas.length - 1].coordenadas.longitude),
        waypoints: vm.waypts,
        optimizeWaypoints: true,
        travelMode: 'DRIVING'
      }, function (response, status) {
        if (status === 'OK') {
          vm.directionsDisplay.setDirections(response);
          vm.$refs.myMap.resizePreserveCenter();
        } else {
          console.log('Directions request failed due to ' + status);
        }
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  },
  notifications: {
    notificacionRecogido: {
      title: 'Información',
      message: 'El servicio ha sido asigando y está en proceso de ser recogido.',
      type: 'info',
      timeout: 9000
    },
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    },
    notificacionBadPosition: {
      title: 'Información',
      message: 'El servicio cuenta con problemas en la geolocalización.',
      type: 'info',
      timeout: 9000
    }
  }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapa',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      URL: 'http://backend.guepardos.co:3000/api',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajero: {},
      puntos: []
    };
  },
  mounted: function mounted() {
    this.getData();
    this.interval = setInterval(function () {
      this.getData();
    }.bind(this), 10000);
  },

  methods: {
    getData: function getData() {
      var vm = this;
      var url = vm.URL;
      vm.$http.get('https://mensajeria.guepardos.co/api/v2/mensajero/' + vm.$route.params.id).then(function (data) {
        vm.mensajero = data.body;
        var query = {};
        if (vm.$route.query.inicio && vm.$route.query.fin) {
          query.where = {
            fecha: {
              between: [__WEBPACK_IMPORTED_MODULE_4_moment___default()(vm.$route.query.inicio).utc().toISOString(), __WEBPACK_IMPORTED_MODULE_4_moment___default()(vm.$route.query.fin).utc().toISOString()]
            },
            mensajeroId: {
              like: vm.$route.params.id
            }
          };
          query.order = 'fecha ASC';
          url = 'https://mensajeria.guepardos.co/api/v2/locations';
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, query).then(function (data) {
            vm.puntos = data.data;
            vm.dibujarMultiplePuntos();
          }).catch(function (error) {
            return console.log(error);
          });
        } else {
          query.where = {
            mensajeroId: {
              like: vm.$route.params.id
            }
          };
          query.limit = 1;
          query.order = 'fecha DESC';
          query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(query);
          url = 'https://mensajeria.guepardos.co/api/v2/messengerPosition/' + vm.$route.params.id;
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (data) {
            if (data.data.length === 1) {
              vm.lastPosition = data.data[0].metadata.coords;
              vm.dibujarPuntos();
            }
          });
        }
      });
    },
    dibujarPuntos: function dibujarPuntos() {
      var vm = this;
      vm.markers = [];
      vm.center = new google.maps.LatLng(parseFloat(vm.lastPosition.latitude), parseFloat(vm.lastPosition.longitude));
      vm.markers.push({
        position: {
          lat: parseFloat(vm.lastPosition.latitude),
          lng: parseFloat(vm.lastPosition.longitude)
        },
        infoText: 'Mensajero: ' + vm.mensajero.nombre,
        icon: __webpack_require__(19)
      });
    },
    dibujarMultiplePuntos: function dibujarMultiplePuntos() {
      var vm = this;
      vm.markers = [];
      vm.center = new google.maps.LatLng(parseFloat(vm.puntos[0].metadata.coords.latitude), parseFloat(vm.puntos[0].metadata.coords.longitude));
      var index = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(vm.puntos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var punto = _step.value;

          var fecha = __WEBPACK_IMPORTED_MODULE_4_moment___default()(punto.fecha).format('YYYY-MM-DD HH:mm:ss');
          if (index === 0) {
            vm.markers.push({
              position: {
                lat: parseFloat(punto.metadata.coords.latitude),
                lng: parseFloat(punto.metadata.coords.longitude)
              },
              infoText: 'Mensajero: ' + vm.mensajero.nombre + ' - ' + fecha,
              icon: __webpack_require__(204)
            });
          } else if (index === vm.puntos.length - 1) {
            vm.markers.push({
              position: {
                lat: parseFloat(punto.metadata.coords.latitude),
                lng: parseFloat(punto.metadata.coords.longitude)
              },
              infoText: 'Mensajero: ' + vm.mensajero.nombre + ' - ' + fecha,
              icon: __webpack_require__(317)
            });
          } else {
            vm.markers.push({
              position: {
                lat: parseFloat(punto.metadata.coords.latitude),
                lng: parseFloat(punto.metadata.coords.longitude)
              },
              infoText: 'Mensajero: ' + vm.mensajero.nombre + ' - ' + fecha,
              icon: __webpack_require__(315)
            });
          }
          index++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  },
  notifications: {
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    }
  }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapa',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      URL: 'https://evocloud-guepardos.appspot.com/api',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajerosData: [],
      serviciosData: [],
      todosMensajeros: []
    };
  },
  mounted: function mounted() {
    var vm = this;
    this.getData();
    this.interval = setInterval(function () {
      this.getData();
    }.bind(this), 10000);
    vm.$http.get('http://evocloud-guepardos.appspot.com/api/Mensajeros').then(function (data) {
      vm.todosMensajeros = data;
    });
  },

  methods: {
    getData: function getData() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://localhost:3005/api/v2/geopointsMensajeros').then(function (data) {
        vm.mensajerosData = data.data;
        /* axios.get('https://mensajeria.guepardos.co/api/v2/serviciosMapaMensajeros')
        .then(data => {
          vm.serviciosData = data.body
        }) */
        vm.dibujarMensajeros();
      });
    },
    dibujarMensajeros: function dibujarMensajeros() {
      var vm = this;
      vm.markers = [];
      vm._.forEach(vm.mensajerosData, function (mensajero) {
        vm.markers.push({
          position: {
            lat: parseFloat(mensajero.ultimaPosicion.point.lat),
            lng: parseFloat(mensajero.ultimaPosicion.point.lng)
          },
          infoText: mensajero.nombre + ' - Placa: ' + mensajero.placa + ' - Celular: ' + mensajero.celular,
          icon: __webpack_require__(19)
        });
      });
      vm._.forEach(vm.serviciosData, function (servicio) {
        var mensajero = vm.getMensajero(servicio.mensajeroId);
        var estado = vm.getEstado(servicio.estadoServicio);
        vm.markers.push({
          position: {
            lat: parseFloat(servicio.geoR.lat),
            lng: parseFloat(servicio.geoR.lng)
          },
          infoText: servicio.nombre + ' - estado: ' + estado,
          icon: __webpack_require__(15)
        });
      });
    },
    getMensajero: function getMensajero(idMensajero) {
      var vm = this;
      var mensajero = vm._.find(vm.todosMensajeros, { 'id': idMensajero });
      if (!mensajero) {
        mensajero = '-';
      } else {
        mensajero = mensajero.nombre;
      }
      return mensajero;
    },
    getEstado: function getEstado(estado) {
      var estadoServicio = '-';
      if (estado === 99) {
        estadoServicio = 'Pendiente';
      } else if (estado === 0) {
        estadoServicio = 'Asignado';
      } else if (estado === 1) {
        estadoServicio = 'Recogido';
      } else if (estado === 2) {
        estadoServicio = 'Entregado';
      } else if (estado === 3) {
        estadoServicio = 'finalizado';
      }
      return estadoServicio;
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_AreaMetro_json__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_AreaMetro_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_AreaMetro_json__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
__webpack_require__(295);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'servicio',
  data: function data() {
    return {
      areaMetroJson: __WEBPACK_IMPORTED_MODULE_9__assets_AreaMetro_json___default.a,
      nav: {
        edge: 'right'
      },
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 13,
      rangoTrimestres: 0,
      todasFechas: true,
      mensajePredefinido: 1,
      infoWinOpen: false,
      currentMidx: null,
      prueba: false,
      celular: null,
      zonasSelected: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajeros: [],
      usuarios: [],
      itemsPredefinido: [{
        text: 'Ningun mensaje',
        id: 1
      }, {
        text: 'Usuarios nuevos',
        id: 2
      }, {
        text: 'Usuarios mediana antigüedad',
        id: 3
      }, {
        text: 'Usuarios antiguos',
        id: 4
      }, {
        text: 'Ultimo servicio reciente',
        id: 5
      }, {
        text: 'Ultimo servicio mediana antigüedad',
        id: 6
      }, {
        text: 'Ultimo servicio antiguo',
        id: 7
      }],
      user: {},
      maxCount: 160,
      remainingCount: 160,
      message: '',
      trimestre: 1,
      trimestreServicio: 0,
      kmlAreaMetropolitana: null,
      hasError: false,
      itemsZonas: [{
        name: 'Zona Laureles',
        value: 1
      }, {
        name: 'Zona Centro',
        value: 2
      }, {
        name: 'Zona Poblado',
        value: 3
      }, {
        name: 'Zona Envigado',
        value: 4
      }, {
        name: 'Area Metropolitana',
        value: 5
      }],
      zonaLaureles: [{
        lng: -75.579747,
        lat: 6.2508963
      }, {
        lng: -75.5808198,
        lat: 6.2515682
      }, {
        lng: -75.5814207,
        lat: 6.2521654
      }, {
        lng: -75.5820644,
        lat: 6.2526453
      }, {
        lng: -75.5829442,
        lat: 6.2528906
      }, {
        lng: -75.5839419,
        lat: 6.2529653
      }, {
        lng: -75.5850363,
        lat: 6.2526667
      }, {
        lng: -75.5858624,
        lat: 6.2526453
      }, {
        lng: -75.5865061,
        lat: 6.253072
      }, {
        lng: -75.5869138,
        lat: 6.2531999
      }, {
        lng: -75.5895317,
        lat: 6.2531573
      }, {
        lng: -75.5907762,
        lat: 6.2534452
      }, {
        lng: -75.5920851,
        lat: 6.2539891
      }, {
        lng: -75.5930722,
        lat: 6.2545117
      }, {
        lng: -75.593909,
        lat: 6.2556849
      }, {
        lng: -75.5950999,
        lat: 6.2551516
      }, {
        lng: -75.5964625,
        lat: 6.2548957
      }, {
        lng: -75.5972028,
        lat: 6.2546824
      }, {
        lng: -75.5977714,
        lat: 6.2543731
      }, {
        lng: -75.5983829,
        lat: 6.2535412
      }, {
        lng: -75.5990911,
        lat: 6.2523467
      }, {
        lng: -75.5997562,
        lat: 6.2513762
      }, {
        lng: -75.5998099,
        lat: 6.2508856
      }, {
        lng: -75.5997241,
        lat: 6.2502137
      }, {
        lng: -75.6003463,
        lat: 6.2501924
      }, {
        lng: -75.6009471,
        lat: 6.250491
      }, {
        lng: -75.6019664,
        lat: 6.2505443
      }, {
        lng: -75.6022775,
        lat: 6.2499578
      }, {
        lng: -75.6023741,
        lat: 6.2493499
      }, {
        lng: -75.6024814,
        lat: 6.248358
      }, {
        lng: -75.6025887,
        lat: 6.2468116
      }, {
        lng: -75.6027174,
        lat: 6.2450305
      }, {
        lng: -75.6028354,
        lat: 6.2425562
      }, {
        lng: -75.6029427,
        lat: 6.2403484
      }, {
        lng: -75.60305,
        lat: 6.2382154
      }, {
        lng: -75.6031251,
        lat: 6.2372555
      }, {
        lng: -75.6027281,
        lat: 6.2364769
      }, {
        lng: -75.6022775,
        lat: 6.2358797
      }, {
        lng: -75.6022024,
        lat: 6.2341199
      }, {
        lng: -75.6021595,
        lat: 6.2318695
      }, {
        lng: -75.6020737,
        lat: 6.2311869
      }, {
        lng: -75.6015158,
        lat: 6.2311122
      }, {
        lng: -75.5981684,
        lat: 6.2313042
      }, {
        lng: -75.5945528,
        lat: 6.2314535
      }, {
        lng: -75.5914736,
        lat: 6.2315815
      }, {
        lng: -75.5893385,
        lat: 6.2314749
      }, {
        lng: -75.5880404,
        lat: 6.2315069
      }, {
        lng: -75.5828047,
        lat: 6.2316349
      }, {
        lng: -75.5791676,
        lat: 6.2317202
      }, {
        lng: -75.5775905,
        lat: 6.2318162
      }, {
        lng: -75.5768502,
        lat: 6.2316349
      }, {
        lng: -75.575906,
        lat: 6.2314322
      }, {
        lng: -75.5759275,
        lat: 6.2321788
      }, {
        lng: -75.5760241,
        lat: 6.2336293
      }, {
        lng: -75.5760777,
        lat: 6.2344185
      }, {
        lng: -75.5766678,
        lat: 6.2364449
      }, {
        lng: -75.5770433,
        lat: 6.2376181
      }, {
        lng: -75.5777621,
        lat: 6.2396552
      }, {
        lng: -75.5785561,
        lat: 6.2419376
      }, {
        lng: -75.5795646,
        lat: 6.2449452
      }, {
        lng: -75.5802727,
        lat: 6.2469395
      }, {
        lng: -75.5805516,
        lat: 6.2478781
      }, {
        lng: -75.5804658,
        lat: 6.2487633
      }, {
        lng: -75.5800903,
        lat: 6.2494992
      }, {
        lng: -75.5797255,
        lat: 6.2505977
      }, {
        lng: -75.579747,
        lat: 6.2508963
      }],
      zonaCentro: [{
        lng: -75.575273,
        lat: 6.2462356
      }, {
        lng: -75.5685997,
        lat: 6.243868
      }, {
        lng: -75.5673981,
        lat: 6.243484
      }, {
        lng: -75.5658317,
        lat: 6.2429508
      }, {
        lng: -75.5642223,
        lat: 6.2422682
      }, {
        lng: -75.563364,
        lat: 6.2415856
      }, {
        lng: -75.5628705,
        lat: 6.2417989
      }, {
        lng: -75.5624843,
        lat: 6.2421189
      }, {
        lng: -75.5619907,
        lat: 6.2423962
      }, {
        lng: -75.5612826,
        lat: 6.2423962
      }, {
        lng: -75.5606604,
        lat: 6.2418842
      }, {
        lng: -75.5601239,
        lat: 6.2421189
      }, {
        lng: -75.5593514,
        lat: 6.2411377
      }, {
        lng: -75.5586219,
        lat: 6.2403271
      }, {
        lng: -75.5570555,
        lat: 6.2429508
      }, {
        lng: -75.5561113,
        lat: 6.2447425
      }, {
        lng: -75.5564547,
        lat: 6.2453611
      }, {
        lng: -75.5569696,
        lat: 6.2461077
      }, {
        lng: -75.5579996,
        lat: 6.2466622
      }, {
        lng: -75.5579138,
        lat: 6.2470249
      }, {
        lng: -75.5563045,
        lat: 6.2494778
      }, {
        lng: -75.5566692,
        lat: 6.2498191
      }, {
        lng: -75.5583215,
        lat: 6.2513549
      }, {
        lng: -75.5625057,
        lat: 6.2548743
      }, {
        lng: -75.5655313,
        lat: 6.2567514
      }, {
        lng: -75.5689859,
        lat: 6.2574766
      }, {
        lng: -75.5707884,
        lat: 6.2577965
      }, {
        lng: -75.5717325,
        lat: 6.2571353
      }, {
        lng: -75.5731487,
        lat: 6.2564527
      }, {
        lng: -75.5750155,
        lat: 6.2542344
      }, {
        lng: -75.575273,
        lat: 6.2462356
      }],
      zonaPoblado: [{
        lng: -75.5745971,
        lat: 6.2328934
      }, {
        lng: -75.5750906,
        lat: 6.2328827
      }, {
        lng: -75.5751872,
        lat: 6.2324348
      }, {
        lng: -75.5752945,
        lat: 6.2314109
      }, {
        lng: -75.5756164,
        lat: 6.2286592
      }, {
        lng: -75.5761743,
        lat: 6.2251182
      }, {
        lng: -75.5764103,
        lat: 6.2231238
      }, {
        lng: -75.5765069,
        lat: 6.2226118
      }, {
        lng: -75.5769682,
        lat: 6.2194334
      }, {
        lng: -75.5773973,
        lat: 6.2162124
      }, {
        lng: -75.5777729,
        lat: 6.21345
      }, {
        lng: -75.5781054,
        lat: 6.2109862
      }, {
        lng: -75.5786419,
        lat: 6.2072958
      }, {
        lng: -75.5788028,
        lat: 6.2061012
      }, {
        lng: -75.5789852,
        lat: 6.2047679
      }, {
        lng: -75.5791783,
        lat: 6.2035733
      }, {
        lng: -75.5793071,
        lat: 6.2025814
      }, {
        lng: -75.5794358,
        lat: 6.2016534
      }, {
        lng: -75.5796075,
        lat: 6.2005975
      }, {
        lng: -75.579747,
        lat: 6.1997975
      }, {
        lng: -75.5799079,
        lat: 6.1990403
      }, {
        lng: -75.5802298,
        lat: 6.197963
      }, {
        lng: -75.5807662,
        lat: 6.1965764
      }, {
        lng: -75.5812383,
        lat: 6.1951791
      }, {
        lng: -75.5805945,
        lat: 6.1949658
      }, {
        lng: -75.5789101,
        lat: 6.1946991
      }, {
        lng: -75.5780196,
        lat: 6.1944005
      }, {
        lng: -75.5773222,
        lat: 6.1938245
      }, {
        lng: -75.5767322,
        lat: 6.1937392
      }, {
        lng: -75.5764318,
        lat: 6.1939952
      }, {
        lng: -75.5762172,
        lat: 6.1947098
      }, {
        lng: -75.5757236,
        lat: 6.1952218
      }, {
        lng: -75.5752194,
        lat: 6.1962137
      }, {
        lng: -75.5748761,
        lat: 6.1957231
      }, {
        lng: -75.5746722,
        lat: 6.1953391
      }, {
        lng: -75.5741465,
        lat: 6.1950724
      }, {
        lng: -75.5733526,
        lat: 6.1946778
      }, {
        lng: -75.5727518,
        lat: 6.1944111
      }, {
        lng: -75.5722797,
        lat: 6.1939312
      }, {
        lng: -75.5719042,
        lat: 6.1936218
      }, {
        lng: -75.5710888,
        lat: 6.1932272
      }, {
        lng: -75.5707455,
        lat: 6.1932485
      }, {
        lng: -75.5700588,
        lat: 6.1935898
      }, {
        lng: -75.5698335,
        lat: 6.1935258
      }, {
        lng: -75.5693936,
        lat: 6.1932805
      }, {
        lng: -75.5686426,
        lat: 6.1928325
      }, {
        lng: -75.5684066,
        lat: 6.1925979
      }, {
        lng: -75.5679882,
        lat: 6.1922139
      }, {
        lng: -75.5675483,
        lat: 6.1919153
      }, {
        lng: -75.5668938,
        lat: 6.1916806
      }, {
        lng: -75.5660033,
        lat: 6.1913606
      }, {
        lng: -75.5656707,
        lat: 6.1910193
      }, {
        lng: -75.5653059,
        lat: 6.190582
      }, {
        lng: -75.5650806,
        lat: 6.1899847
      }, {
        lng: -75.565027,
        lat: 6.1895047
      }, {
        lng: -75.5650806,
        lat: 6.188918
      }, {
        lng: -75.5648875,
        lat: 6.188566
      }, {
        lng: -75.5646515,
        lat: 6.18831
      }, {
        lng: -75.5642974,
        lat: 6.1878941
      }, {
        lng: -75.5639005,
        lat: 6.1874781
      }, {
        lng: -75.5632997,
        lat: 6.1869128
      }, {
        lng: -75.5629349,
        lat: 6.1867634
      }, {
        lng: -75.5623555,
        lat: 6.1868274
      }, {
        lng: -75.5617654,
        lat: 6.1868701
      }, {
        lng: -75.5615079,
        lat: 6.1873714
      }, {
        lng: -75.5610144,
        lat: 6.1891847
      }, {
        lng: -75.5608106,
        lat: 6.190038
      }, {
        lng: -75.5604136,
        lat: 6.1912433
      }, {
        lng: -75.5598021,
        lat: 6.1922139
      }, {
        lng: -75.5595875,
        lat: 6.1926619
      }, {
        lng: -75.5599844,
        lat: 6.1934832
      }, {
        lng: -75.559845,
        lat: 6.1936858
      }, {
        lng: -75.559212,
        lat: 6.1938352
      }, {
        lng: -75.5591476,
        lat: 6.1940698
      }, {
        lng: -75.558815,
        lat: 6.1950938
      }, {
        lng: -75.5578172,
        lat: 6.196491
      }, {
        lng: -75.5563903,
        lat: 6.198443
      }, {
        lng: -75.5559611,
        lat: 6.1991256
      }, {
        lng: -75.5557144,
        lat: 6.1996376
      }, {
        lng: -75.555768,
        lat: 6.1999575
      }, {
        lng: -75.5563259,
        lat: 6.2011628
      }, {
        lng: -75.5563903,
        lat: 6.2014721
      }, {
        lng: -75.5563474,
        lat: 6.2019628
      }, {
        lng: -75.5561435,
        lat: 6.2023041
      }, {
        lng: -75.5556285,
        lat: 6.2034453
      }, {
        lng: -75.5555642,
        lat: 6.204096
      }, {
        lng: -75.5554783,
        lat: 6.2051199
      }, {
        lng: -75.5554032,
        lat: 6.2058558
      }, {
        lng: -75.5549204,
        lat: 6.2067198
      }, {
        lng: -75.5548883,
        lat: 6.2074451
      }, {
        lng: -75.5548668,
        lat: 6.2092263
      }, {
        lng: -75.5543947,
        lat: 6.2102929
      }, {
        lng: -75.5542338,
        lat: 6.2108368
      }, {
        lng: -75.5545342,
        lat: 6.2113488
      }, {
        lng: -75.5560041,
        lat: 6.2122874
      }, {
        lng: -75.5566907,
        lat: 6.212714
      }, {
        lng: -75.5570233,
        lat: 6.213226
      }, {
        lng: -75.5574739,
        lat: 6.2139939
      }, {
        lng: -75.5578494,
        lat: 6.2144525
      }, {
        lng: -75.558697,
        lat: 6.2146872
      }, {
        lng: -75.5597699,
        lat: 6.2149112
      }, {
        lng: -75.5608642,
        lat: 6.2151565
      }, {
        lng: -75.5617011,
        lat: 6.2153271
      }, {
        lng: -75.5625379,
        lat: 6.2155511
      }, {
        lng: -75.563525,
        lat: 6.2159564
      }, {
        lng: -75.5641043,
        lat: 6.2164364
      }, {
        lng: -75.5643189,
        lat: 6.2168737
      }, {
        lng: -75.5642867,
        lat: 6.217375
      }, {
        lng: -75.5641901,
        lat: 6.2179829
      }, {
        lng: -75.5643725,
        lat: 6.2182282
      }, {
        lng: -75.5647051,
        lat: 6.2182176
      }, {
        lng: -75.5655849,
        lat: 6.2181536
      }, {
        lng: -75.5658746,
        lat: 6.2182602
      }, {
        lng: -75.5660784,
        lat: 6.2184522
      }, {
        lng: -75.5660892,
        lat: 6.2190495
      }, {
        lng: -75.5662286,
        lat: 6.2195934
      }, {
        lng: -75.5664217,
        lat: 6.220244
      }, {
        lng: -75.5660999,
        lat: 6.2206067
      }, {
        lng: -75.5655527,
        lat: 6.2208626
      }, {
        lng: -75.565424,
        lat: 6.22114
      }, {
        lng: -75.5653596,
        lat: 6.2214493
      }, {
        lng: -75.5651987,
        lat: 6.2225052
      }, {
        lng: -75.5649948,
        lat: 6.2235717
      }, {
        lng: -75.565027,
        lat: 6.224073
      }, {
        lng: -75.5651665,
        lat: 6.2247663
      }, {
        lng: -75.5651665,
        lat: 6.2252675
      }, {
        lng: -75.5648339,
        lat: 6.2258222
      }, {
        lng: -75.5648661,
        lat: 6.2262701
      }, {
        lng: -75.5651128,
        lat: 6.2266221
      }, {
        lng: -75.5664754,
        lat: 6.2265687
      }, {
        lng: -75.5667436,
        lat: 6.2268887
      }, {
        lng: -75.5670655,
        lat: 6.2269847
      }, {
        lng: -75.5673444,
        lat: 6.2268887
      }, {
        lng: -75.5676019,
        lat: 6.2269527
      }, {
        lng: -75.5679452,
        lat: 6.226814
      }, {
        lng: -75.5685139,
        lat: 6.226814
      }, {
        lng: -75.5685031,
        lat: 6.2270167
      }, {
        lng: -75.5685568,
        lat: 6.227262
      }, {
        lng: -75.568825,
        lat: 6.227486
      }, {
        lng: -75.5686963,
        lat: 6.2278059
      }, {
        lng: -75.5688465,
        lat: 6.2282432
      }, {
        lng: -75.5688143,
        lat: 6.2287658
      }, {
        lng: -75.5686533,
        lat: 6.2298857
      }, {
        lng: -75.5688679,
        lat: 6.2312509
      }, {
        lng: -75.5697691,
        lat: 6.2311869
      }, {
        lng: -75.5702841,
        lat: 6.2313469
      }, {
        lng: -75.5710566,
        lat: 6.2316242
      }, {
        lng: -75.5721617,
        lat: 6.2320508
      }, {
        lng: -75.5730629,
        lat: 6.2324561
      }, {
        lng: -75.5742431,
        lat: 6.2329254
      }, {
        lng: -75.5745971,
        lat: 6.2328934
      }],
      zonaEnvigado: [{
        lng: -75.5817494,
        lat: 6.1936965
      }, {
        lng: -75.5820322,
        lat: 6.1929499
      }, {
        lng: -75.5823326,
        lat: 6.1916699
      }, {
        lng: -75.5825686,
        lat: 6.1904113
      }, {
        lng: -75.5830836,
        lat: 6.1888327
      }, {
        lng: -75.5833411,
        lat: 6.188214
      }, {
        lng: -75.5838346,
        lat: 6.1875954
      }, {
        lng: -75.5851007,
        lat: 6.1866994
      }, {
        lng: -75.5865598,
        lat: 6.1855901
      }, {
        lng: -75.587976,
        lat: 6.1842462
      }, {
        lng: -75.5891132,
        lat: 6.1828169
      }, {
        lng: -75.5908298,
        lat: 6.1801716
      }, {
        lng: -75.5916238,
        lat: 6.1789129
      }, {
        lng: -75.5924928,
        lat: 6.1776863
      }, {
        lng: -75.593555,
        lat: 6.176577
      }, {
        lng: -75.5950356,
        lat: 6.175489
      }, {
        lng: -75.5972457,
        lat: 6.173953
      }, {
        lng: -75.5970204,
        lat: 6.1737183
      }, {
        lng: -75.5968273,
        lat: 6.1736117
      }, {
        lng: -75.5955935,
        lat: 6.1727157
      }, {
        lng: -75.5946386,
        lat: 6.1719797
      }, {
        lng: -75.5945098,
        lat: 6.1717237
      }, {
        lng: -75.5944669,
        lat: 6.1714143
      }, {
        lng: -75.5945742,
        lat: 6.1712757
      }, {
        lng: -75.5950356,
        lat: 6.1708597
      }, {
        lng: -75.5953896,
        lat: 6.1704543
      }, {
        lng: -75.5953467,
        lat: 6.1701877
      }, {
        lng: -75.5952179,
        lat: 6.1698677
      }, {
        lng: -75.5949605,
        lat: 6.169601
      }, {
        lng: -75.594542,
        lat: 6.1691957
      }, {
        lng: -75.5940592,
        lat: 6.1689823
      }, {
        lng: -75.5931902,
        lat: 6.1686837
      }, {
        lng: -75.5913234,
        lat: 6.1682677
      }, {
        lng: -75.5902612,
        lat: 6.168001
      }, {
        lng: -75.5904329,
        lat: 6.1677023
      }, {
        lng: -75.5904973,
        lat: 6.167489
      }, {
        lng: -75.5909586,
        lat: 6.1670196
      }, {
        lng: -75.5908835,
        lat: 6.166785
      }, {
        lng: -75.5907333,
        lat: 6.1664223
      }, {
        lng: -75.5909264,
        lat: 6.1656116
      }, {
        lng: -75.5908513,
        lat: 6.1651316
      }, {
        lng: -75.5905294,
        lat: 6.1645663
      }, {
        lng: -75.5900145,
        lat: 6.1651743
      }, {
        lng: -75.5896497,
        lat: 6.164769
      }, {
        lng: -75.5891991,
        lat: 6.1642036
      }, {
        lng: -75.5886304,
        lat: 6.1648116
      }, {
        lng: -75.5876756,
        lat: 6.1655796
      }, {
        lng: -75.5871499,
        lat: 6.1649716
      }, {
        lng: -75.5866241,
        lat: 6.1643636
      }, {
        lng: -75.586313,
        lat: 6.1637876
      }, {
        lng: -75.5856049,
        lat: 6.1618569
      }, {
        lng: -75.5854762,
        lat: 6.1619102
      }, {
        lng: -75.585165,
        lat: 6.1621129
      }, {
        lng: -75.5848861,
        lat: 6.1625289
      }, {
        lng: -75.5847037,
        lat: 6.1624969
      }, {
        lng: -75.5843604,
        lat: 6.1621556
      }, {
        lng: -75.5840278,
        lat: 6.1618462
      }, {
        lng: -75.5838025,
        lat: 6.1616436
      }, {
        lng: -75.5834699,
        lat: 6.1616649
      }, {
        lng: -75.5831909,
        lat: 6.1616969
      }, {
        lng: -75.582633,
        lat: 6.1621022
      }, {
        lng: -75.5820537,
        lat: 6.1630516
      }, {
        lng: -75.5816031,
        lat: 6.1639156
      }, {
        lng: -75.5814314,
        lat: 6.1638729
      }, {
        lng: -75.5808842,
        lat: 6.1638516
      }, {
        lng: -75.5808842,
        lat: 6.1644063
      }, {
        lng: -75.5808735,
        lat: 6.1649183
      }, {
        lng: -75.5805838,
        lat: 6.1647903
      }, {
        lng: -75.5802834,
        lat: 6.164929
      }, {
        lng: -75.5801976,
        lat: 6.1652276
      }, {
        lng: -75.5802512,
        lat: 6.1657076
      }, {
        lng: -75.579865,
        lat: 6.1659423
      }, {
        lng: -75.5792212,
        lat: 6.165857
      }, {
        lng: -75.5786955,
        lat: 6.165633
      }, {
        lng: -75.5779874,
        lat: 6.165537
      }, {
        lng: -75.5775797,
        lat: 6.1658676
      }, {
        lng: -75.5770111,
        lat: 6.1662836
      }, {
        lng: -75.5763888,
        lat: 6.1659956
      }, {
        lng: -75.5757987,
        lat: 6.1654943
      }, {
        lng: -75.5750585,
        lat: 6.1650143
      }, {
        lng: -75.5745006,
        lat: 6.1648863
      }, {
        lng: -75.5742967,
        lat: 6.1651423
      }, {
        lng: -75.5738568,
        lat: 6.1655583
      }, {
        lng: -75.5739212,
        lat: 6.165985
      }, {
        lng: -75.5738783,
        lat: 6.166337
      }, {
        lng: -75.573771,
        lat: 6.1666143
      }, {
        lng: -75.5738676,
        lat: 6.1668383
      }, {
        lng: -75.5738676,
        lat: 6.167393
      }, {
        lng: -75.5734599,
        lat: 6.1672756
      }, {
        lng: -75.5724621,
        lat: 6.167393
      }, {
        lng: -75.5718076,
        lat: 6.167489
      }, {
        lng: -75.5713141,
        lat: 6.167393
      }, {
        lng: -75.5707991,
        lat: 6.1673183
      }, {
        lng: -75.5701876,
        lat: 6.1670623
      }, {
        lng: -75.5692971,
        lat: 6.1669983
      }, {
        lng: -75.5687606,
        lat: 6.1681503
      }, {
        lng: -75.5683959,
        lat: 6.168961
      }, {
        lng: -75.5684388,
        lat: 6.169633
      }, {
        lng: -75.5685782,
        lat: 6.169985
      }, {
        lng: -75.5685997,
        lat: 6.1704863
      }, {
        lng: -75.5684924,
        lat: 6.171393
      }, {
        lng: -75.5680203,
        lat: 6.1717023
      }, {
        lng: -75.5679238,
        lat: 6.1720543
      }, {
        lng: -75.5679131,
        lat: 6.1724597
      }, {
        lng: -75.5676663,
        lat: 6.1728117
      }, {
        lng: -75.5671942,
        lat: 6.1729823
      }, {
        lng: -75.5665827,
        lat: 6.1730997
      }, {
        lng: -75.566293,
        lat: 6.1732703
      }, {
        lng: -75.5662179,
        lat: 6.173633
      }, {
        lng: -75.5664754,
        lat: 6.1739317
      }, {
        lng: -75.5667758,
        lat: 6.1743476
      }, {
        lng: -75.5670333,
        lat: 6.1748276
      }, {
        lng: -75.5669904,
        lat: 6.1755423
      }, {
        lng: -75.5673015,
        lat: 6.1761183
      }, {
        lng: -75.5676448,
        lat: 6.1765876
      }, {
        lng: -75.567441,
        lat: 6.177281
      }, {
        lng: -75.5673444,
        lat: 6.1780809
      }, {
        lng: -75.5676877,
        lat: 6.1790943
      }, {
        lng: -75.5676019,
        lat: 6.1792756
      }, {
        lng: -75.5673552,
        lat: 6.1794356
      }, {
        lng: -75.5671191,
        lat: 6.1793289
      }, {
        lng: -75.5667436,
        lat: 6.1791156
      }, {
        lng: -75.5661857,
        lat: 6.1794036
      }, {
        lng: -75.5661321,
        lat: 6.1796169
      }, {
        lng: -75.5662608,
        lat: 6.1805236
      }, {
        lng: -75.5656385,
        lat: 6.1802782
      }, {
        lng: -75.5655313,
        lat: 6.1803849
      }, {
        lng: -75.5653274,
        lat: 6.1806836
      }, {
        lng: -75.5654025,
        lat: 6.1810782
      }, {
        lng: -75.5651343,
        lat: 6.1811529
      }, {
        lng: -75.5644906,
        lat: 6.1821555
      }, {
        lng: -75.5647373,
        lat: 6.1822942
      }, {
        lng: -75.5647373,
        lat: 6.1825075
      }, {
        lng: -75.5649304,
        lat: 6.1827209
      }, {
        lng: -75.5653596,
        lat: 6.1829022
      }, {
        lng: -75.5657566,
        lat: 6.1831369
      }, {
        lng: -75.5660784,
        lat: 6.1834142
      }, {
        lng: -75.5664647,
        lat: 6.1834248
      }, {
        lng: -75.5665612,
        lat: 6.1835528
      }, {
        lng: -75.566411,
        lat: 6.1841928
      }, {
        lng: -75.5662286,
        lat: 6.1851848
      }, {
        lng: -75.5664432,
        lat: 6.1855261
      }, {
        lng: -75.5666792,
        lat: 6.1856435
      }, {
        lng: -75.5678058,
        lat: 6.1857715
      }, {
        lng: -75.5686748,
        lat: 6.1858141
      }, {
        lng: -75.569061,
        lat: 6.1856221
      }, {
        lng: -75.5693936,
        lat: 6.1856648
      }, {
        lng: -75.5702198,
        lat: 6.1858888
      }, {
        lng: -75.5709064,
        lat: 6.1858675
      }, {
        lng: -75.5714965,
        lat: 6.1858461
      }, {
        lng: -75.5717325,
        lat: 6.1859314
      }, {
        lng: -75.572741,
        lat: 6.1864114
      }, {
        lng: -75.5736423,
        lat: 6.1869128
      }, {
        lng: -75.5742967,
        lat: 6.1873607
      }, {
        lng: -75.5745113,
        lat: 6.1877341
      }, {
        lng: -75.5747688,
        lat: 6.1883634
      }, {
        lng: -75.5750155,
        lat: 6.1886194
      }, {
        lng: -75.5753803,
        lat: 6.1889074
      }, {
        lng: -75.5763674,
        lat: 6.1895473
      }, {
        lng: -75.5771399,
        lat: 6.1897927
      }, {
        lng: -75.5770218,
        lat: 6.1902193
      }, {
        lng: -75.5766785,
        lat: 6.1912326
      }, {
        lng: -75.5775046,
        lat: 6.1917446
      }, {
        lng: -75.5779552,
        lat: 6.1920326
      }, {
        lng: -75.5782878,
        lat: 6.1921926
      }, {
        lng: -75.5785405,
        lat: 6.1922246
      }, {
        lng: -75.5789911,
        lat: 6.1919472
      }, {
        lng: -75.5795382,
        lat: 6.1913606
      }, {
        lng: -75.5799352,
        lat: 6.1907313
      }, {
        lng: -75.5802249,
        lat: 6.1906886
      }, {
        lng: -75.5800854,
        lat: 6.1912006
      }, {
        lng: -75.5799888,
        lat: 6.1920646
      }, {
        lng: -75.5798601,
        lat: 6.1926406
      }, {
        lng: -75.5800854,
        lat: 6.1929499
      }, {
        lng: -75.5803546,
        lat: 6.1930565
      }, {
        lng: -75.5807408,
        lat: 6.1931845
      }, {
        lng: -75.5812344,
        lat: 6.1934619
      }, {
        lng: -75.5817494,
        lat: 6.1936965
      }],
      zonaMetro: [{
        lng: -75.4590797,
        lat: 6.3850773
      }, {
        lng: -75.4607105,
        lat: 6.3853332
      }, {
        lng: -75.4627705,
        lat: 6.3853332
      }, {
        lng: -75.4658604,
        lat: 6.384992
      }, {
        lng: -75.4694653,
        lat: 6.3843096
      }, {
        lng: -75.4722977,
        lat: 6.3840537
      }, {
        lng: -75.4751301,
        lat: 6.383286
      }, {
        lng: -75.4780483,
        lat: 6.3823477
      }, {
        lng: -75.4807949,
        lat: 6.3822624
      }, {
        lng: -75.481739,
        lat: 6.3831154
      }, {
        lng: -75.4825115,
        lat: 6.3843949
      }, {
        lng: -75.482769,
        lat: 6.3855038
      }, {
        lng: -75.4826832,
        lat: 6.386442
      }, {
        lng: -75.4839706,
        lat: 6.3874656
      }, {
        lng: -75.4855156,
        lat: 6.3866979
      }, {
        lng: -75.4866314,
        lat: 6.3855038
      }, {
        lng: -75.4877472,
        lat: 6.384139
      }, {
        lng: -75.489378,
        lat: 6.3834566
      }, {
        lng: -75.4909229,
        lat: 6.3836272
      }, {
        lng: -75.4904938,
        lat: 6.3825183
      }, {
        lng: -75.4905796,
        lat: 6.3809829
      }, {
        lng: -75.4909229,
        lat: 6.3797887
      }, {
        lng: -75.492382,
        lat: 6.3796181
      }, {
        lng: -75.4940128,
        lat: 6.3796181
      }, {
        lng: -75.492897,
        lat: 6.3782534
      }, {
        lng: -75.4921246,
        lat: 6.3772298
      }, {
        lng: -75.4927254,
        lat: 6.3764621
      }, {
        lng: -75.4936695,
        lat: 6.3751826
      }, {
        lng: -75.4946995,
        lat: 6.3757797
      }, {
        lng: -75.4953003,
        lat: 6.3745855
      }, {
        lng: -75.4982185,
        lat: 6.3757797
      }, {
        lng: -75.500021,
        lat: 6.3746708
      }, {
        lng: -75.5021667,
        lat: 6.3734766
      }, {
        lng: -75.5031967,
        lat: 6.3726236
      }, {
        lng: -75.50457,
        lat: 6.3719412
      }, {
        lng: -75.5044842,
        lat: 6.3700645
      }, {
        lng: -75.5031967,
        lat: 6.3689556
      }, {
        lng: -75.5044842,
        lat: 6.3673349
      }, {
        lng: -75.5059433,
        lat: 6.3663113
      }, {
        lng: -75.5073166,
        lat: 6.3656289
      }, {
        lng: -75.5079174,
        lat: 6.3646906
      }, {
        lng: -75.5087757,
        lat: 6.3633257
      }, {
        lng: -75.5104065,
        lat: 6.3618756
      }, {
        lng: -75.5123806,
        lat: 6.3609373
      }, {
        lng: -75.5135822,
        lat: 6.3612785
      }, {
        lng: -75.5148697,
        lat: 6.3600843
      }, {
        lng: -75.5158138,
        lat: 6.360852
      }, {
        lng: -75.5163288,
        lat: 6.3592312
      }, {
        lng: -75.516758,
        lat: 6.3563309
      }, {
        lng: -75.5171871,
        lat: 6.3534306
      }, {
        lng: -75.5182171,
        lat: 6.3511274
      }, {
        lng: -75.5176163,
        lat: 6.3485683
      }, {
        lng: -75.5177021,
        lat: 6.346521
      }, {
        lng: -75.5201054,
        lat: 6.3456679
      }, {
        lng: -75.5219078,
        lat: 6.3440472
      }, {
        lng: -75.5235386,
        lat: 6.3432794
      }, {
        lng: -75.5254269,
        lat: 6.342341
      }, {
        lng: -75.5241394,
        lat: 6.3401231
      }, {
        lng: -75.5255988,
        lat: 6.3386736
      }, {
        lng: -75.5272293,
        lat: 6.3382464
      }, {
        lng: -75.5303192,
        lat: 6.3383317
      }, {
        lng: -75.5328083,
        lat: 6.3387582
      }, {
        lng: -75.5340958,
        lat: 6.3390141
      }, {
        lng: -75.5337524,
        lat: 6.340379
      }, {
        lng: -75.5326366,
        lat: 6.3415733
      }, {
        lng: -75.5325508,
        lat: 6.3427676
      }, {
        lng: -75.5336666,
        lat: 6.3439618
      }, {
        lng: -75.5338383,
        lat: 6.3452414
      }, {
        lng: -75.5351257,
        lat: 6.3464357
      }, {
        lng: -75.5368423,
        lat: 6.3479712
      }, {
        lng: -75.5374432,
        lat: 6.3492507
      }, {
        lng: -75.5384731,
        lat: 6.3490801
      }, {
        lng: -75.5383015,
        lat: 6.3468622
      }, {
        lng: -75.5387306,
        lat: 6.3454973
      }, {
        lng: -75.5392456,
        lat: 6.3464357
      }, {
        lng: -75.5404472,
        lat: 6.3469475
      }, {
        lng: -75.541563,
        lat: 6.3474593
      }, {
        lng: -75.542078,
        lat: 6.3489948
      }, {
        lng: -75.5428505,
        lat: 6.3477153
      }, {
        lng: -75.544138,
        lat: 6.3483124
      }, {
        lng: -75.5462837,
        lat: 6.3489095
      }, {
        lng: -75.548172,
        lat: 6.349592
      }, {
        lng: -75.5493736,
        lat: 6.3500185
      }, {
        lng: -75.5504036,
        lat: 6.3507862
      }, {
        lng: -75.5511761,
        lat: 6.3518099
      }, {
        lng: -75.5520344,
        lat: 6.3518099
      }, {
        lng: -75.5530643,
        lat: 6.3501038
      }, {
        lng: -75.5546093,
        lat: 6.3496773
      }, {
        lng: -75.5555534,
        lat: 6.3499332
      }, {
        lng: -75.5558109,
        lat: 6.3507862
      }, {
        lng: -75.5573559,
        lat: 6.3510421
      }, {
        lng: -75.558815,
        lat: 6.3511274
      }, {
        lng: -75.5592442,
        lat: 6.3496773
      }, {
        lng: -75.5606174,
        lat: 6.3501891
      }, {
        lng: -75.5606174,
        lat: 6.3515539
      }, {
        lng: -75.559845,
        lat: 6.3530041
      }, {
        lng: -75.5604458,
        lat: 6.3553073
      }, {
        lng: -75.5619049,
        lat: 6.3538571
      }, {
        lng: -75.5626774,
        lat: 6.3522364
      }, {
        lng: -75.5644798,
        lat: 6.3518099
      }, {
        lng: -75.5661106,
        lat: 6.3523217
      }, {
        lng: -75.5664539,
        lat: 6.3537718
      }, {
        lng: -75.5661964,
        lat: 6.356075
      }, {
        lng: -75.5668831,
        lat: 6.3572693
      }, {
        lng: -75.5690289,
        lat: 6.3573546
      }, {
        lng: -75.5710888,
        lat: 6.3566722
      }, {
        lng: -75.5725479,
        lat: 6.355222
      }, {
        lng: -75.5712605,
        lat: 6.3528335
      }, {
        lng: -75.5701447,
        lat: 6.3509568
      }, {
        lng: -75.5692005,
        lat: 6.3487389
      }, {
        lng: -75.5698872,
        lat: 6.3472887
      }, {
        lng: -75.5718613,
        lat: 6.347374
      }, {
        lng: -75.5736637,
        lat: 6.3477153
      }, {
        lng: -75.5749512,
        lat: 6.3468622
      }, {
        lng: -75.574522,
        lat: 6.3458386
      }, {
        lng: -75.5742645,
        lat: 6.3449002
      }, {
        lng: -75.5757236,
        lat: 6.3444737
      }, {
        lng: -75.5769253,
        lat: 6.3436206
      }, {
        lng: -75.5777836,
        lat: 6.341488
      }, {
        lng: -75.5773544,
        lat: 6.3393554
      }, {
        lng: -75.5718613,
        lat: 6.3391847
      }, {
        lng: -75.5711746,
        lat: 6.3379905
      }, {
        lng: -75.5722046,
        lat: 6.3368815
      }, {
        lng: -75.5740929,
        lat: 6.3364549
      }, {
        lng: -75.5764103,
        lat: 6.3358578
      }, {
        lng: -75.5746937,
        lat: 6.3344076
      }, {
        lng: -75.5726337,
        lat: 6.3334692
      }, {
        lng: -75.5687714,
        lat: 6.3319337
      }, {
        lng: -75.5667114,
        lat: 6.3317631
      }, {
        lng: -75.5659389,
        lat: 6.3305688
      }, {
        lng: -75.5655098,
        lat: 6.3286067
      }, {
        lng: -75.5661964,
        lat: 6.3280095
      }, {
        lng: -75.5683422,
        lat: 6.3269005
      }, {
        lng: -75.5700588,
        lat: 6.3263034
      }, {
        lng: -75.5704021,
        lat: 6.3246825
      }, {
        lng: -75.5697155,
        lat: 6.3229764
      }, {
        lng: -75.5691147,
        lat: 6.3216967
      }, {
        lng: -75.5685139,
        lat: 6.3205024
      }, {
        lng: -75.5673981,
        lat: 6.3210143
      }, {
        lng: -75.5661964,
        lat: 6.3205877
      }, {
        lng: -75.5673981,
        lat: 6.3191375
      }, {
        lng: -75.5681705,
        lat: 6.3162369
      }, {
        lng: -75.5702305,
        lat: 6.3160663
      }, {
        lng: -75.5705738,
        lat: 6.3147014
      }, {
        lng: -75.5728912,
        lat: 6.3142748
      }, {
        lng: -75.5746078,
        lat: 6.3147867
      }, {
        lng: -75.5776119,
        lat: 6.3153838
      }, {
        lng: -75.5805302,
        lat: 6.3163223
      }, {
        lng: -75.5849934,
        lat: 6.317346
      }, {
        lng: -75.5867958,
        lat: 6.3169194
      }, {
        lng: -75.5886841,
        lat: 6.3154692
      }, {
        lng: -75.5891991,
        lat: 6.3143601
      }, {
        lng: -75.5879116,
        lat: 6.3128245
      }, {
        lng: -75.58671,
        lat: 6.3117155
      }, {
        lng: -75.5873108,
        lat: 6.3104359
      }, {
        lng: -75.5862808,
        lat: 6.3094974
      }, {
        lng: -75.5859375,
        lat: 6.3070234
      }, {
        lng: -75.5849075,
        lat: 6.3052319
      }, {
        lng: -75.5837059,
        lat: 6.3041228
      }, {
        lng: -75.5845642,
        lat: 6.3026725
      }, {
        lng: -75.5869675,
        lat: 6.3025872
      }, {
        lng: -75.5885124,
        lat: 6.3029285
      }, {
        lng: -75.5890274,
        lat: 6.3015635
      }, {
        lng: -75.5877399,
        lat: 6.3000279
      }, {
        lng: -75.5866241,
        lat: 6.2980657
      }, {
        lng: -75.5863667,
        lat: 6.2964447
      }, {
        lng: -75.5876541,
        lat: 6.2949091
      }, {
        lng: -75.5885983,
        lat: 6.2941413
      }, {
        lng: -75.5896282,
        lat: 6.2952503
      }, {
        lng: -75.5909157,
        lat: 6.2961888
      }, {
        lng: -75.5923748,
        lat: 6.2961888
      }, {
        lng: -75.5941772,
        lat: 6.2967007
      }, {
        lng: -75.5950356,
        lat: 6.2972125
      }, {
        lng: -75.5964088,
        lat: 6.2967007
      }, {
        lng: -75.5977821,
        lat: 6.2957622
      }, {
        lng: -75.5975246,
        lat: 6.2949944
      }, {
        lng: -75.596838,
        lat: 6.2933734
      }, {
        lng: -75.5969238,
        lat: 6.2918378
      }, {
        lng: -75.5990696,
        lat: 6.2906434
      }, {
        lng: -75.6000996,
        lat: 6.289449
      }, {
        lng: -75.6013012,
        lat: 6.2883399
      }, {
        lng: -75.6031895,
        lat: 6.2882546
      }, {
        lng: -75.6043053,
        lat: 6.2892784
      }, {
        lng: -75.6053352,
        lat: 6.2914965
      }, {
        lng: -75.6062794,
        lat: 6.29107
      }, {
        lng: -75.6078243,
        lat: 6.2900462
      }, {
        lng: -75.6082535,
        lat: 6.2909847
      }, {
        lng: -75.6088543,
        lat: 6.2920084
      }, {
        lng: -75.6091976,
        lat: 6.2936294
      }, {
        lng: -75.6098843,
        lat: 6.2956769
      }, {
        lng: -75.6119442,
        lat: 6.2948238
      }, {
        lng: -75.6123734,
        lat: 6.2932881
      }, {
        lng: -75.6155491,
        lat: 6.2906434
      }, {
        lng: -75.6154633,
        lat: 6.2898756
      }, {
        lng: -75.6151199,
        lat: 6.2888518
      }, {
        lng: -75.6150341,
        lat: 6.2876574
      }, {
        lng: -75.613575,
        lat: 6.2862924
      }, {
        lng: -75.6124592,
        lat: 6.2870602
      }, {
        lng: -75.6108284,
        lat: 6.2876574
      }, {
        lng: -75.6103134,
        lat: 6.2868043
      }, {
        lng: -75.6102276,
        lat: 6.2854392
      }, {
        lng: -75.6097984,
        lat: 6.2841595
      }, {
        lng: -75.6091976,
        lat: 6.2828798
      }, {
        lng: -75.6102276,
        lat: 6.2827945
      }, {
        lng: -75.6121159,
        lat: 6.2827092
      }, {
        lng: -75.6134033,
        lat: 6.2831357
      }, {
        lng: -75.61409,
        lat: 6.2845008
      }, {
        lng: -75.6150341,
        lat: 6.2844155
      }, {
        lng: -75.6152058,
        lat: 6.2827945
      }, {
        lng: -75.6164932,
        lat: 6.2826238
      }, {
        lng: -75.6175232,
        lat: 6.2835623
      }, {
        lng: -75.6189823,
        lat: 6.2835623
      }, {
        lng: -75.6213856,
        lat: 6.2839889
      }, {
        lng: -75.6224155,
        lat: 6.2836476
      }, {
        lng: -75.624733,
        lat: 6.2828798
      }, {
        lng: -75.6269646,
        lat: 6.2824532
      }, {
        lng: -75.6291103,
        lat: 6.2819413
      }, {
        lng: -75.630827,
        lat: 6.282112
      }, {
        lng: -75.630827,
        lat: 6.2831357
      }, {
        lng: -75.6302261,
        lat: 6.2847567
      }, {
        lng: -75.6307411,
        lat: 6.2858658
      }, {
        lng: -75.633316,
        lat: 6.2844155
      }, {
        lng: -75.6347752,
        lat: 6.2829651
      }, {
        lng: -75.6367493,
        lat: 6.2820266
      }, {
        lng: -75.6375217,
        lat: 6.2827945
      }, {
        lng: -75.63941,
        lat: 6.2833064
      }, {
        lng: -75.6408691,
        lat: 6.2827092
      }, {
        lng: -75.6419849,
        lat: 6.2819413
      }, {
        lng: -75.643959,
        lat: 6.2822826
      }, {
        lng: -75.6448174,
        lat: 6.2810882
      }, {
        lng: -75.6432724,
        lat: 6.2792112
      }, {
        lng: -75.6415558,
        lat: 6.2773343
      }, {
        lng: -75.6402683,
        lat: 6.2762252
      }, {
        lng: -75.6388092,
        lat: 6.2752014
      }, {
        lng: -75.6370926,
        lat: 6.2744335
      }, {
        lng: -75.6363201,
        lat: 6.2729831
      }, {
        lng: -75.633831,
        lat: 6.2726419
      }, {
        lng: -75.6321144,
        lat: 6.2719593
      }, {
        lng: -75.6312561,
        lat: 6.2706796
      }, {
        lng: -75.6299686,
        lat: 6.268376
      }, {
        lng: -75.6275654,
        lat: 6.2675228
      }, {
        lng: -75.6267929,
        lat: 6.2681201
      }, {
        lng: -75.6266212,
        lat: 6.2711062
      }, {
        lng: -75.6279945,
        lat: 6.2723859
      }, {
        lng: -75.6279945,
        lat: 6.2735804
      }, {
        lng: -75.6261921,
        lat: 6.2748601
      }, {
        lng: -75.6248188,
        lat: 6.2745188
      }, {
        lng: -75.6224155,
        lat: 6.2750307
      }, {
        lng: -75.6217289,
        lat: 6.2760545
      }, {
        lng: -75.6203556,
        lat: 6.2757986
      }, {
        lng: -75.6197548,
        lat: 6.2748601
      }, {
        lng: -75.6195831,
        lat: 6.2732391
      }, {
        lng: -75.617609,
        lat: 6.2724712
      }, {
        lng: -75.618124,
        lat: 6.2713621
      }, {
        lng: -75.6194115,
        lat: 6.2705943
      }, {
        lng: -75.6188107,
        lat: 6.2692292
      }, {
        lng: -75.619669,
        lat: 6.2677788
      }, {
        lng: -75.6193256,
        lat: 6.2665843
      }, {
        lng: -75.6178665,
        lat: 6.2654752
      }, {
        lng: -75.6164074,
        lat: 6.2643661
      }, {
        lng: -75.6163216,
        lat: 6.2632569
      }, {
        lng: -75.6169224,
        lat: 6.2620625
      }, {
        lng: -75.618124,
        lat: 6.2621478
      }, {
        lng: -75.619669,
        lat: 6.2626597
      }, {
        lng: -75.6211281,
        lat: 6.2624037
      }, {
        lng: -75.6219864,
        lat: 6.2635129
      }, {
        lng: -75.6231022,
        lat: 6.2636835
      }, {
        lng: -75.6243038,
        lat: 6.2624891
      }, {
        lng: -75.6238747,
        lat: 6.2606974
      }, {
        lng: -75.6230164,
        lat: 6.2590763
      }, {
        lng: -75.6233597,
        lat: 6.2575406
      }, {
        lng: -75.6246471,
        lat: 6.2582231
      }, {
        lng: -75.6263638,
        lat: 6.2600148
      }, {
        lng: -75.6272221,
        lat: 6.2614652
      }, {
        lng: -75.6286812,
        lat: 6.2630863
      }, {
        lng: -75.628767,
        lat: 6.2612946
      }, {
        lng: -75.629282,
        lat: 6.2601001
      }, {
        lng: -75.6302261,
        lat: 6.2596735
      }, {
        lng: -75.6319427,
        lat: 6.2594176
      }, {
        lng: -75.6315136,
        lat: 6.2575406
      }, {
        lng: -75.6293678,
        lat: 6.2566874
      }, {
        lng: -75.6297112,
        lat: 6.2557489
      }, {
        lng: -75.6312561,
        lat: 6.2557489
      }, {
        lng: -75.6322861,
        lat: 6.2550663
      }, {
        lng: -75.6322002,
        lat: 6.2537012
      }, {
        lng: -75.6311703,
        lat: 6.2525067
      }, {
        lng: -75.6294537,
        lat: 6.252592
      }, {
        lng: -75.6289387,
        lat: 6.2513975
      }, {
        lng: -75.6312561,
        lat: 6.250715
      }, {
        lng: -75.6334877,
        lat: 6.2510563
      }, {
        lng: -75.6355476,
        lat: 6.2512269
      }, {
        lng: -75.6370068,
        lat: 6.2503737
      }, {
        lng: -75.6372643,
        lat: 6.2487526
      }, {
        lng: -75.6355476,
        lat: 6.2482407
      }, {
        lng: -75.635376,
        lat: 6.2473022
      }, {
        lng: -75.6364059,
        lat: 6.2464489
      }, {
        lng: -75.6352901,
        lat: 6.2449985
      }, {
        lng: -75.6337452,
        lat: 6.245681
      }, {
        lng: -75.6315136,
        lat: 6.2466196
      }, {
        lng: -75.6300545,
        lat: 6.2465343
      }, {
        lng: -75.628252,
        lat: 6.2449132
      }, {
        lng: -75.6261921,
        lat: 6.2454251
      }, {
        lng: -75.6244755,
        lat: 6.2445719
      }, {
        lng: -75.6229305,
        lat: 6.2432067
      }, {
        lng: -75.6219006,
        lat: 6.2415003
      }, {
        lng: -75.6208706,
        lat: 6.2427801
      }, {
        lng: -75.6190681,
        lat: 6.2430361
      }, {
        lng: -75.6182098,
        lat: 6.2420122
      }, {
        lng: -75.6166649,
        lat: 6.2426095
      }, {
        lng: -75.6164074,
        lat: 6.2417563
      }, {
        lng: -75.6160641,
        lat: 6.239026
      }, {
        lng: -75.6137466,
        lat: 6.2386847
      }, {
        lng: -75.61203,
        lat: 6.2369782
      }, {
        lng: -75.6119442,
        lat: 6.2354424
      }, {
        lng: -75.6129742,
        lat: 6.2357837
      }, {
        lng: -75.6164074,
        lat: 6.2368929
      }, {
        lng: -75.6194115,
        lat: 6.2372342
      }, {
        lng: -75.6227589,
        lat: 6.2366369
      }, {
        lng: -75.6250763,
        lat: 6.235613
      }, {
        lng: -75.6279945,
        lat: 6.2345892
      }, {
        lng: -75.6302261,
        lat: 6.2343332
      }, {
        lng: -75.6329727,
        lat: 6.2353571
      }, {
        lng: -75.6347752,
        lat: 6.2349305
      }, {
        lng: -75.6337452,
        lat: 6.2343332
      }, {
        lng: -75.6342602,
        lat: 6.233224
      }, {
        lng: -75.6365776,
        lat: 6.23348
      }, {
        lng: -75.6382942,
        lat: 6.2328827
      }, {
        lng: -75.6370068,
        lat: 6.2319441
      }, {
        lng: -75.6340027,
        lat: 6.2321148
      }, {
        lng: -75.6310844,
        lat: 6.2322001
      }, {
        lng: -75.6300545,
        lat: 6.2319441
      }, {
        lng: -75.6275654,
        lat: 6.2314322
      }, {
        lng: -75.6261921,
        lat: 6.2317735
      }, {
        lng: -75.6239605,
        lat: 6.2321148
      }, {
        lng: -75.6229305,
        lat: 6.2333093
      }, {
        lng: -75.6208706,
        lat: 6.2350158
      }, {
        lng: -75.6177807,
        lat: 6.2348451
      }, {
        lng: -75.6174374,
        lat: 6.2337359
      }, {
        lng: -75.6168365,
        lat: 6.2320295
      }, {
        lng: -75.6159782,
        lat: 6.2304083
      }, {
        lng: -75.6152916,
        lat: 6.2289578
      }, {
        lng: -75.6145191,
        lat: 6.2275926
      }, {
        lng: -75.6131458,
        lat: 6.2265687
      }, {
        lng: -75.6123734,
        lat: 6.2246916
      }, {
        lng: -75.6128025,
        lat: 6.2229851
      }, {
        lng: -75.6148624,
        lat: 6.2226438
      }, {
        lng: -75.6170082,
        lat: 6.2228998
      }, {
        lng: -75.6198406,
        lat: 6.2234117
      }, {
        lng: -75.6223297,
        lat: 6.223753
      }, {
        lng: -75.624733,
        lat: 6.2246063
      }, {
        lng: -75.6260204,
        lat: 6.2253742
      }, {
        lng: -75.6274796,
        lat: 6.2250329
      }, {
        lng: -75.629282,
        lat: 6.2243503
      }, {
        lng: -75.6320286,
        lat: 6.2241797
      }, {
        lng: -75.6329727,
        lat: 6.2244356
      }, {
        lng: -75.634346,
        lat: 6.2244356
      }, {
        lng: -75.6344318,
        lat: 6.2232411
      }, {
        lng: -75.6360626,
        lat: 6.2226438
      }, {
        lng: -75.6369209,
        lat: 6.2231558
      }, {
        lng: -75.6383801,
        lat: 6.2225585
      }, {
        lng: -75.6392384,
        lat: 6.2218759
      }, {
        lng: -75.6405258,
        lat: 6.2223878
      }, {
        lng: -75.6408691,
        lat: 6.221108
      }, {
        lng: -75.6401825,
        lat: 6.2195721
      }, {
        lng: -75.6386375,
        lat: 6.2199987
      }, {
        lng: -75.6372643,
        lat: 6.22034
      }, {
        lng: -75.6378651,
        lat: 6.2190601
      }, {
        lng: -75.6372643,
        lat: 6.2176096
      }, {
        lng: -75.6354618,
        lat: 6.2176949
      }, {
        lng: -75.633831,
        lat: 6.2187188
      }, {
        lng: -75.6335735,
        lat: 6.2201694
      }, {
        lng: -75.6325436,
        lat: 6.2209373
      }, {
        lng: -75.6310844,
        lat: 6.2217052
      }, {
        lng: -75.6293678,
        lat: 6.2215346
      }, {
        lng: -75.627737,
        lat: 6.2210226
      }, {
        lng: -75.6259346,
        lat: 6.2213639
      }, {
        lng: -75.6241322,
        lat: 6.2223878
      }, {
        lng: -75.6230164,
        lat: 6.2209373
      }, {
        lng: -75.6220722,
        lat: 6.2211933
      }, {
        lng: -75.6219864,
        lat: 6.2221319
      }, {
        lng: -75.6198406,
        lat: 6.2219612
      }, {
        lng: -75.6200123,
        lat: 6.22034
      }, {
        lng: -75.6176949,
        lat: 6.2197427
      }, {
        lng: -75.6160641,
        lat: 6.2199987
      }, {
        lng: -75.6134892,
        lat: 6.2195721
      }, {
        lng: -75.6109142,
        lat: 6.2190601
      }, {
        lng: -75.6096268,
        lat: 6.2186335
      }, {
        lng: -75.6091118,
        lat: 6.216671
      }, {
        lng: -75.6077385,
        lat: 6.2159031
      }, {
        lng: -75.6061935,
        lat: 6.2161591
      }, {
        lng: -75.6047344,
        lat: 6.2155618
      }, {
        lng: -75.6052494,
        lat: 6.2141112
      }, {
        lng: -75.6059361,
        lat: 6.2131726
      }, {
        lng: -75.6067085,
        lat: 6.2123194
      }, {
        lng: -75.6068802,
        lat: 6.2110395
      }, {
        lng: -75.6057644,
        lat: 6.2101009
      }, {
        lng: -75.6067944,
        lat: 6.209077
      }, {
        lng: -75.6086826,
        lat: 6.2095036
      }, {
        lng: -75.6102276,
        lat: 6.2100156
      }, {
        lng: -75.6095409,
        lat: 6.2082237
      }, {
        lng: -75.6073093,
        lat: 6.2074557
      }, {
        lng: -75.6061935,
        lat: 6.2064318
      }, {
        lng: -75.6083393,
        lat: 6.2063465
      }, {
        lng: -75.6095409,
        lat: 6.2052372
      }, {
        lng: -75.6073093,
        lat: 6.2044693
      }, {
        lng: -75.6060219,
        lat: 6.202848
      }, {
        lng: -75.6036186,
        lat: 6.2022507
      }, {
        lng: -75.6031895,
        lat: 6.2011415
      }, {
        lng: -75.6018162,
        lat: 6.1996056
      }, {
        lng: -75.6017303,
        lat: 6.2002882
      }, {
        lng: -75.6006145,
        lat: 6.2005442
      }, {
        lng: -75.5997562,
        lat: 6.2016534
      }, {
        lng: -75.5983829,
        lat: 6.2030187
      }, {
        lng: -75.597353,
        lat: 6.2026774
      }, {
        lng: -75.5956364,
        lat: 6.2015681
      }, {
        lng: -75.5950356,
        lat: 6.2004588
      }, {
        lng: -75.5961514,
        lat: 6.1996909
      }, {
        lng: -75.5967522,
        lat: 6.1982403
      }, {
        lng: -75.597353,
        lat: 6.1967044
      }, {
        lng: -75.597868,
        lat: 6.1954244
      }, {
        lng: -75.5994129,
        lat: 6.1950831
      }, {
        lng: -75.600872,
        lat: 6.1949125
      }, {
        lng: -75.6025887,
        lat: 6.1945711
      }, {
        lng: -75.6042194,
        lat: 6.1939738
      }, {
        lng: -75.6055927,
        lat: 6.1940592
      }, {
        lng: -75.606966,
        lat: 6.1949125
      }, {
        lng: -75.6084251,
        lat: 6.1949125
      }, {
        lng: -75.6086826,
        lat: 6.1935472
      }, {
        lng: -75.609026,
        lat: 6.1922672
      }, {
        lng: -75.6101418,
        lat: 6.1914139
      }, {
        lng: -75.6121159,
        lat: 6.1909873
      }, {
        lng: -75.6141758,
        lat: 6.1913286
      }, {
        lng: -75.6163216,
        lat: 6.1922672
      }, {
        lng: -75.6174374,
        lat: 6.1933765
      }, {
        lng: -75.6182957,
        lat: 6.1918406
      }, {
        lng: -75.6176949,
        lat: 6.1902193
      }, {
        lng: -75.6179523,
        lat: 6.1890247
      }, {
        lng: -75.6175232,
        lat: 6.1873181
      }, {
        lng: -75.6153774,
        lat: 6.1864648
      }, {
        lng: -75.6128883,
        lat: 6.1830515
      }, {
        lng: -75.6134892,
        lat: 6.1805769
      }, {
        lng: -75.613575,
        lat: 6.1778463
      }, {
        lng: -75.6153774,
        lat: 6.1747743
      }, {
        lng: -75.6187253,
        lat: 6.1736647
      }, {
        lng: -75.6213856,
        lat: 6.1729823
      }, {
        lng: -75.6236172,
        lat: 6.1727263
      }, {
        lng: -75.6262779,
        lat: 6.1735797
      }, {
        lng: -75.6302261,
        lat: 6.1753716
      }, {
        lng: -75.6345177,
        lat: 6.1760543
      }, {
        lng: -75.6351185,
        lat: 6.1774196
      }, {
        lng: -75.6361485,
        lat: 6.1783583
      }, {
        lng: -75.6370068,
        lat: 6.1799796
      }, {
        lng: -75.6376934,
        lat: 6.1820275
      }, {
        lng: -75.6390667,
        lat: 6.1835635
      }, {
        lng: -75.6392384,
        lat: 6.1848435
      }, {
        lng: -75.639925,
        lat: 6.1865501
      }, {
        lng: -75.6413841,
        lat: 6.1866354
      }, {
        lng: -75.643959,
        lat: 6.1881714
      }, {
        lng: -75.6441307,
        lat: 6.18911
      }, {
        lng: -75.6453323,
        lat: 6.1900487
      }, {
        lng: -75.6469631,
        lat: 6.1894513
      }, {
        lng: -75.6486797,
        lat: 6.1894513
      }, {
        lng: -75.6501389,
        lat: 6.190134
      }, {
        lng: -75.6519413,
        lat: 6.190646
      }, {
        lng: -75.6535721,
        lat: 6.1909873
      }, {
        lng: -75.6546021,
        lat: 6.1914993
      }, {
        lng: -75.6564903,
        lat: 6.1912433
      }, {
        lng: -75.6559753,
        lat: 6.1889394
      }, {
        lng: -75.6565762,
        lat: 6.1877447
      }, {
        lng: -75.6580353,
        lat: 6.1879154
      }, {
        lng: -75.6591511,
        lat: 6.1887687
      }, {
        lng: -75.6618977,
        lat: 6.1887687
      }, {
        lng: -75.6629276,
        lat: 6.1877447
      }, {
        lng: -75.6619835,
        lat: 6.1861234
      }, {
        lng: -75.6625843,
        lat: 6.1853555
      }, {
        lng: -75.6626701,
        lat: 6.1839902
      }, {
        lng: -75.662756,
        lat: 6.1828809
      }, {
        lng: -75.6618118,
        lat: 6.1804062
      }, {
        lng: -75.6593227,
        lat: 6.1796383
      }, {
        lng: -75.661726,
        lat: 6.174689
      }, {
        lng: -75.6599236,
        lat: 6.1738357
      }, {
        lng: -75.6576061,
        lat: 6.172897
      }, {
        lng: -75.6540871,
        lat: 6.172641
      }, {
        lng: -75.651083,
        lat: 6.173665
      }, {
        lng: -75.6488514,
        lat: 6.1727263
      }, {
        lng: -75.6474781,
        lat: 6.1717023
      }, {
        lng: -75.645504,
        lat: 6.1714463
      }, {
        lng: -75.6443024,
        lat: 6.170849
      }, {
        lng: -75.6456757,
        lat: 6.1699957
      }, {
        lng: -75.6454182,
        lat: 6.169057
      }, {
        lng: -75.6445599,
        lat: 6.1679476
      }, {
        lng: -75.6443024,
        lat: 6.1663263
      }, {
        lng: -75.6446457,
        lat: 6.1650463
      }, {
        lng: -75.6457615,
        lat: 6.1663263
      }, {
        lng: -75.6464481,
        lat: 6.167521
      }, {
        lng: -75.6486797,
        lat: 6.1682037
      }, {
        lng: -75.6497955,
        lat: 6.1665823
      }, {
        lng: -75.6491089,
        lat: 6.1645343
      }, {
        lng: -75.6491089,
        lat: 6.1625716
      }, {
        lng: -75.6488514,
        lat: 6.1602675
      }, {
        lng: -75.6493664,
        lat: 6.1578782
      }, {
        lng: -75.6498814,
        lat: 6.1555741
      }, {
        lng: -75.6513405,
        lat: 6.1540381
      }, {
        lng: -75.6533146,
        lat: 6.1529287
      }, {
        lng: -75.6552029,
        lat: 6.152758
      }, {
        lng: -75.656662,
        lat: 6.1524167
      }, {
        lng: -75.6570911,
        lat: 6.1508806
      }, {
        lng: -75.6558895,
        lat: 6.1500272
      }, {
        lng: -75.6532287,
        lat: 6.151478
      }, {
        lng: -75.6504822,
        lat: 6.1519046
      }, {
        lng: -75.6473064,
        lat: 6.1519046
      }, {
        lng: -75.6454182,
        lat: 6.1505393
      }, {
        lng: -75.6430149,
        lat: 6.1499419
      }, {
        lng: -75.6418133,
        lat: 6.1490032
      }, {
        lng: -75.6408691,
        lat: 6.1496859
      }, {
        lng: -75.6387234,
        lat: 6.1492592
      }, {
        lng: -75.6381225,
        lat: 6.1480645
      }, {
        lng: -75.6360626,
        lat: 6.1474671
      }, {
        lng: -75.6365776,
        lat: 6.1463578
      }, {
        lng: -75.6377792,
        lat: 6.1450777
      }, {
        lng: -75.638895,
        lat: 6.1435416
      }, {
        lng: -75.6385517,
        lat: 6.1419202
      }, {
        lng: -75.6372642,
        lat: 6.1410668
      }, {
        lng: -75.6362343,
        lat: 6.1392747
      }, {
        lng: -75.6371784,
        lat: 6.1387627
      }, {
        lng: -75.6388092,
        lat: 6.1392747
      }, {
        lng: -75.6401825,
        lat: 6.1389334
      }, {
        lng: -75.6403541,
        lat: 6.1375679
      }, {
        lng: -75.6398392,
        lat: 6.1359465
      }, {
        lng: -75.6388092,
        lat: 6.1343251
      }, {
        lng: -75.6371784,
        lat: 6.1331303
      }, {
        lng: -75.6370926,
        lat: 6.1304848
      }, {
        lng: -75.6364918,
        lat: 6.1281806
      }, {
        lng: -75.6371784,
        lat: 6.1263031
      }, {
        lng: -75.6363201,
        lat: 6.1248523
      }, {
        lng: -75.6363201,
        lat: 6.1233162
      }, {
        lng: -75.6354618,
        lat: 6.1224628
      }, {
        lng: -75.6352043,
        lat: 6.1199879
      }, {
        lng: -75.6362343,
        lat: 6.1189638
      }, {
        lng: -75.6375217,
        lat: 6.1189638
      }, {
        lng: -75.6388092,
        lat: 6.1200732
      }, {
        lng: -75.6397533,
        lat: 6.1210973
      }, {
        lng: -75.6407833,
        lat: 6.1203292
      }, {
        lng: -75.6398392,
        lat: 6.1192198
      }, {
        lng: -75.6389809,
        lat: 6.1184517
      }, {
        lng: -75.6373501,
        lat: 6.1162329
      }, {
        lng: -75.6380367,
        lat: 6.1155501
      }, {
        lng: -75.6378651,
        lat: 6.1144407
      }, {
        lng: -75.6371784,
        lat: 6.1129045
      }, {
        lng: -75.6381225,
        lat: 6.1127338
      }, {
        lng: -75.6392383,
        lat: 6.1132459
      }, {
        lng: -75.6402683,
        lat: 6.1128192
      }, {
        lng: -75.6413841,
        lat: 6.1128192
      }, {
        lng: -75.6418991,
        lat: 6.111795
      }, {
        lng: -75.6433582,
        lat: 6.1118804
      }, {
        lng: -75.6432724,
        lat: 6.1106002
      }, {
        lng: -75.6427574,
        lat: 6.108808
      }, {
        lng: -75.6425857,
        lat: 6.1059917
      }, {
        lng: -75.6432724,
        lat: 6.1047969
      }, {
        lng: -75.6451607,
        lat: 6.1047969
      }, {
        lng: -75.6454182,
        lat: 6.1036874
      }, {
        lng: -75.6442165,
        lat: 6.1031753
      }, {
        lng: -75.6431866,
        lat: 6.1018952
      }, {
        lng: -75.6434441,
        lat: 6.1001883
      }, {
        lng: -75.6443882,
        lat: 6.0989081
      }, {
        lng: -75.6452465,
        lat: 6.0977133
      }, {
        lng: -75.6451607,
        lat: 6.0967745
      }, {
        lng: -75.644989,
        lat: 6.0952383
      }, {
        lng: -75.6462765,
        lat: 6.0933607
      }, {
        lng: -75.6468773,
        lat: 6.0916537
      }, {
        lng: -75.6468773,
        lat: 6.0893494
      }, {
        lng: -75.6453323,
        lat: 6.0875571
      }, {
        lng: -75.644474,
        lat: 6.0861916
      }, {
        lng: -75.6425857,
        lat: 6.0857648
      }, {
        lng: -75.6426716,
        lat: 6.0834605
      }, {
        lng: -75.6435299,
        lat: 6.0805586
      }, {
        lng: -75.6430149,
        lat: 6.0787663
      }, {
        lng: -75.6416416,
        lat: 6.0775715
      }, {
        lng: -75.6389809,
        lat: 6.0784249
      }, {
        lng: -75.6365776,
        lat: 6.0797905
      }, {
        lng: -75.6347752,
        lat: 6.0802172
      }, {
        lng: -75.6346893,
        lat: 6.0790224
      }, {
        lng: -75.634861,
        lat: 6.0765473
      }, {
        lng: -75.6337452,
        lat: 6.0751817
      }, {
        lng: -75.6314278,
        lat: 6.0755231
      }, {
        lng: -75.6297111,
        lat: 6.0776568
      }, {
        lng: -75.6290245,
        lat: 6.0799612
      }, {
        lng: -75.6295395,
        lat: 6.0818389
      }, {
        lng: -75.629797,
        lat: 6.0831191
      }, {
        lng: -75.629282,
        lat: 6.0841432
      }, {
        lng: -75.6294536,
        lat: 6.0857648
      }, {
        lng: -75.627737,
        lat: 6.0851674
      }, {
        lng: -75.6254196,
        lat: 6.0851674
      }, {
        lng: -75.623703,
        lat: 6.0841432
      }, {
        lng: -75.6240463,
        lat: 6.0856795
      }, {
        lng: -75.6234455,
        lat: 6.0867036
      }, {
        lng: -75.6212997,
        lat: 6.0865329
      }, {
        lng: -75.6212139,
        lat: 6.0874718
      }, {
        lng: -75.6241321,
        lat: 6.0886666
      }, {
        lng: -75.6252479,
        lat: 6.0903735
      }, {
        lng: -75.6264496,
        lat: 6.0925925
      }, {
        lng: -75.6261063,
        lat: 6.0937874
      }, {
        lng: -75.6249046,
        lat: 6.0949822
      }, {
        lng: -75.6238747,
        lat: 6.0961771
      }, {
        lng: -75.6215572,
        lat: 6.0963477
      }, {
        lng: -75.6219005,
        lat: 6.0977986
      }, {
        lng: -75.6210422,
        lat: 6.098396
      }, {
        lng: -75.6213856,
        lat: 6.0996762
      }, {
        lng: -75.619154,
        lat: 6.1007003
      }, {
        lng: -75.6190681,
        lat: 6.1019805
      }, {
        lng: -75.6204414,
        lat: 6.1020659
      }, {
        lng: -75.6222439,
        lat: 6.1024926
      }, {
        lng: -75.6243038,
        lat: 6.1005297
      }, {
        lng: -75.6267929,
        lat: 6.0990788
      }, {
        lng: -75.6300545,
        lat: 6.0971159
      }, {
        lng: -75.6328869,
        lat: 6.0960917
      }, {
        lng: -75.6350326,
        lat: 6.0955796
      }, {
        lng: -75.6352043,
        lat: 6.0977986
      }, {
        lng: -75.6354618,
        lat: 6.0995909
      }, {
        lng: -75.635891,
        lat: 6.1024072
      }, {
        lng: -75.6356335,
        lat: 6.1052236
      }, {
        lng: -75.6351185,
        lat: 6.1071865
      }, {
        lng: -75.6347752,
        lat: 6.1110269
      }, {
        lng: -75.6340027,
        lat: 6.1137579
      }, {
        lng: -75.6321144,
        lat: 6.11427
      }, {
        lng: -75.6299686,
        lat: 6.1146113
      }, {
        lng: -75.630312,
        lat: 6.1162328
      }, {
        lng: -75.6307411,
        lat: 6.1181957
      }, {
        lng: -75.6309128,
        lat: 6.1193905
      }, {
        lng: -75.6300545,
        lat: 6.1222067
      }, {
        lng: -75.6302261,
        lat: 6.1257057
      }, {
        lng: -75.6311703,
        lat: 6.1280099
      }, {
        lng: -75.6315994,
        lat: 6.1303994
      }, {
        lng: -75.6316852,
        lat: 6.1322769
      }, {
        lng: -75.6320286,
        lat: 6.1361172
      }, {
        lng: -75.630312,
        lat: 6.1379946
      }, {
        lng: -75.6291103,
        lat: 6.13936
      }, {
        lng: -75.6300545,
        lat: 6.1407255
      }, {
        lng: -75.632801,
        lat: 6.1414082
      }, {
        lng: -75.6329727,
        lat: 6.1431149
      }, {
        lng: -75.6330585,
        lat: 6.1456751
      }, {
        lng: -75.633831,
        lat: 6.1474671
      }, {
        lng: -75.6341743,
        lat: 6.1487472
      }, {
        lng: -75.633831,
        lat: 6.1504539
      }, {
        lng: -75.633316,
        lat: 6.1515633
      }, {
        lng: -75.6322861,
        lat: 6.1501979
      }, {
        lng: -75.6299686,
        lat: 6.1494299
      }, {
        lng: -75.6279087,
        lat: 6.1484058
      }, {
        lng: -75.6262779,
        lat: 6.1470404
      }, {
        lng: -75.6255054,
        lat: 6.1455897
      }, {
        lng: -75.6232738,
        lat: 6.1439683
      }, {
        lng: -75.6204414,
        lat: 6.1421762
      }, {
        lng: -75.6183815,
        lat: 6.1421762
      }, {
        lng: -75.6171799,
        lat: 6.1408961
      }, {
        lng: -75.6162357,
        lat: 6.1389334
      }, {
        lng: -75.6159782,
        lat: 6.1398721
      }, {
        lng: -75.6149483,
        lat: 6.1398721
      }, {
        lng: -75.6142616,
        lat: 6.1384213
      }, {
        lng: -75.6132317,
        lat: 6.1384213
      }, {
        lng: -75.6134033,
        lat: 6.1410668
      }, {
        lng: -75.6144333,
        lat: 6.1434563
      }, {
        lng: -75.6151199,
        lat: 6.145163
      }, {
        lng: -75.6150341,
        lat: 6.1471258
      }, {
        lng: -75.6129742,
        lat: 6.1464431
      }, {
        lng: -75.6109142,
        lat: 6.1465284
      }, {
        lng: -75.6084251,
        lat: 6.1474671
      }, {
        lng: -75.606966,
        lat: 6.1496006
      }, {
        lng: -75.6061077,
        lat: 6.151222
      }, {
        lng: -75.6052494,
        lat: 6.152758
      }, {
        lng: -75.6062794,
        lat: 6.153526
      }, {
        lng: -75.6079102,
        lat: 6.1543794
      }, {
        lng: -75.6067085,
        lat: 6.1552328
      }, {
        lng: -75.6051636,
        lat: 6.1558301
      }, {
        lng: -75.6041336,
        lat: 6.1547207
      }, {
        lng: -75.6036186,
        lat: 6.1536114
      }, {
        lng: -75.6037903,
        lat: 6.1523313
      }, {
        lng: -75.6022453,
        lat: 6.1508806
      }, {
        lng: -75.6002712,
        lat: 6.1499419
      }, {
        lng: -75.5979538,
        lat: 6.1484058
      }, {
        lng: -75.595808,
        lat: 6.1484912
      }, {
        lng: -75.595808,
        lat: 6.1501979
      }, {
        lng: -75.5961514,
        lat: 6.1519046
      }, {
        lng: -75.5952072,
        lat: 6.1523313
      }, {
        lng: -75.5936623,
        lat: 6.1506246
      }, {
        lng: -75.5916023,
        lat: 6.1500272
      }, {
        lng: -75.5890274,
        lat: 6.1505393
      }, {
        lng: -75.5881691,
        lat: 6.1513073
      }, {
        lng: -75.5866241,
        lat: 6.1506246
      }, {
        lng: -75.5855083,
        lat: 6.1495152
      }, {
        lng: -75.586195,
        lat: 6.1484058
      }, {
        lng: -75.5855942,
        lat: 6.1467844
      }, {
        lng: -75.5842209,
        lat: 6.1463578
      }, {
        lng: -75.5821609,
        lat: 6.1459311
      }, {
        lng: -75.5802727,
        lat: 6.1462724
      }, {
        lng: -75.5794144,
        lat: 6.1478938
      }, {
        lng: -75.5779552,
        lat: 6.1473818
      }, {
        lng: -75.5764961,
        lat: 6.1467844
      }, {
        lng: -75.5749512,
        lat: 6.1467844
      }, {
        lng: -75.5744362,
        lat: 6.1490032
      }, {
        lng: -75.5746078,
        lat: 6.1504539
      }, {
        lng: -75.5735779,
        lat: 6.1519046
      }, {
        lng: -75.574522,
        lat: 6.1531847
      }, {
        lng: -75.5746937,
        lat: 6.1542941
      }, {
        lng: -75.5732346,
        lat: 6.1551474
      }, {
        lng: -75.5735779,
        lat: 6.1564275
      }, {
        lng: -75.5746078,
        lat: 6.1562568
      }, {
        lng: -75.5740929,
        lat: 6.1582195
      }, {
        lng: -75.5734062,
        lat: 6.1595849
      }, {
        lng: -75.5717754,
        lat: 6.1599262
      }, {
        lng: -75.569973,
        lat: 6.1611209
      }, {
        lng: -75.5690289,
        lat: 6.1613769
      }, {
        lng: -75.5680847,
        lat: 6.1606089
      }, {
        lng: -75.5671406,
        lat: 6.1594995
      }, {
        lng: -75.5659389,
        lat: 6.1589875
      }, {
        lng: -75.564909,
        lat: 6.1607795
      }, {
        lng: -75.5656815,
        lat: 6.1622302
      }, {
        lng: -75.5656815,
        lat: 6.1639369
      }, {
        lng: -75.5642223,
        lat: 6.1633396
      }, {
        lng: -75.562849,
        lat: 6.1641076
      }, {
        lng: -75.5630207,
        lat: 6.1650463
      }, {
        lng: -75.5637073,
        lat: 6.167265
      }, {
        lng: -75.5623341,
        lat: 6.1687156
      }, {
        lng: -75.5619049,
        lat: 6.1704223
      }, {
        lng: -75.5602741,
        lat: 6.1728116
      }, {
        lng: -75.5584717,
        lat: 6.1743476
      }, {
        lng: -75.5569267,
        lat: 6.1756276
      }, {
        lng: -75.5554676,
        lat: 6.1777609
      }, {
        lng: -75.553236,
        lat: 6.1805769
      }, {
        lng: -75.5524635,
        lat: 6.1839902
      }, {
        lng: -75.5525494,
        lat: 6.1871474
      }, {
        lng: -75.5533218,
        lat: 6.1885127
      }, {
        lng: -75.5540943,
        lat: 6.1917553
      }, {
        lng: -75.5535793,
        lat: 6.1933765
      }, {
        lng: -75.552721,
        lat: 6.1955098
      }, {
        lng: -75.5513477,
        lat: 6.1989229
      }, {
        lng: -75.5506611,
        lat: 6.2011415
      }, {
        lng: -75.5505753,
        lat: 6.203104
      }, {
        lng: -75.5480003,
        lat: 6.2043839
      }, {
        lng: -75.5480862,
        lat: 6.2067731
      }, {
        lng: -75.5479145,
        lat: 6.208565
      }, {
        lng: -75.5473137,
        lat: 6.2097596
      }, {
        lng: -75.5475712,
        lat: 6.2107835
      }, {
        lng: -75.5474853,
        lat: 6.2122341
      }, {
        lng: -75.5461979,
        lat: 6.2141966
      }, {
        lng: -75.5451679,
        lat: 6.2153911
      }, {
        lng: -75.5455112,
        lat: 6.217183
      }, {
        lng: -75.5467129,
        lat: 6.2182922
      }, {
        lng: -75.5484295,
        lat: 6.2199134
      }, {
        lng: -75.5506611,
        lat: 6.2205107
      }, {
        lng: -75.5528927,
        lat: 6.2200841
      }, {
        lng: -75.5548668,
        lat: 6.2207667
      }, {
        lng: -75.5565834,
        lat: 6.2211933
      }, {
        lng: -75.5582142,
        lat: 6.2215346
      }, {
        lng: -75.5597591,
        lat: 6.2228998
      }, {
        lng: -75.5607891,
        lat: 6.2213639
      }, {
        lng: -75.5625915,
        lat: 6.220596
      }, {
        lng: -75.5636215,
        lat: 6.2199134
      }, {
        lng: -75.564909,
        lat: 6.2191455
      }, {
        lng: -75.5653381,
        lat: 6.22034
      }, {
        lng: -75.5651987,
        lat: 6.2225052
      }, {
        lng: -75.5651665,
        lat: 6.2247663
      }, {
        lng: -75.5640507,
        lat: 6.2253742
      }, {
        lng: -75.5623341,
        lat: 6.2253742
      }, {
        lng: -75.5617332,
        lat: 6.2254595
      }, {
        lng: -75.5604458,
        lat: 6.2246063
      }, {
        lng: -75.5597591,
        lat: 6.2255448
      }, {
        lng: -75.5583,
        lat: 6.2256302
      }, {
        lng: -75.55727,
        lat: 6.2268247
      }, {
        lng: -75.5583,
        lat: 6.2286165
      }, {
        lng: -75.5584717,
        lat: 6.2310909
      }, {
        lng: -75.55727,
        lat: 6.230579
      }, {
        lng: -75.5559826,
        lat: 6.2294698
      }, {
        lng: -75.5540085,
        lat: 6.2281046
      }, {
        lng: -75.5518627,
        lat: 6.2275926
      }, {
        lng: -75.5510044,
        lat: 6.2289578
      }, {
        lng: -75.5503178,
        lat: 6.230067
      }, {
        lng: -75.548687,
        lat: 6.2298964
      }, {
        lng: -75.5495453,
        lat: 6.2283606
      }, {
        lng: -75.5490303,
        lat: 6.2264834
      }, {
        lng: -75.5477428,
        lat: 6.2263981
      }, {
        lng: -75.5463695,
        lat: 6.2254595
      }, {
        lng: -75.5437088,
        lat: 6.2252036
      }, {
        lng: -75.5418205,
        lat: 6.2252889
      }, {
        lng: -75.5404472,
        lat: 6.2275926
      }, {
        lng: -75.5412197,
        lat: 6.2292138
      }, {
        lng: -75.5403614,
        lat: 6.2316029
      }, {
        lng: -75.5398464,
        lat: 6.2306643
      }, {
        lng: -75.5395031,
        lat: 6.2288725
      }, {
        lng: -75.5376148,
        lat: 6.2286165
      }, {
        lng: -75.5369282,
        lat: 6.2279339
      }, {
        lng: -75.537014,
        lat: 6.2263981
      }, {
        lng: -75.535984,
        lat: 6.2239237
      }, {
        lng: -75.5328083,
        lat: 6.2239237
      }, {
        lng: -75.5333233,
        lat: 6.2250329
      }, {
        lng: -75.5341816,
        lat: 6.22691
      }, {
        lng: -75.5332375,
        lat: 6.2277633
      }, {
        lng: -75.5318642,
        lat: 6.2269954
      }, {
        lng: -75.5307484,
        lat: 6.2273367
      }, {
        lng: -75.5293751,
        lat: 6.2272513
      }, {
        lng: -75.5275726,
        lat: 6.227422
      }, {
        lng: -75.5259418,
        lat: 6.2287018
      }, {
        lng: -75.5261993,
        lat: 6.2299817
      }, {
        lng: -75.5269718,
        lat: 6.2316882
      }, {
        lng: -75.525856,
        lat: 6.2328827
      }, {
        lng: -75.524826,
        lat: 6.2342479
      }, {
        lng: -75.5249119,
        lat: 6.2360397
      }, {
        lng: -75.526886,
        lat: 6.235869
      }, {
        lng: -75.5267143,
        lat: 6.2369782
      }, {
        lng: -75.526371,
        lat: 6.2383434
      }, {
        lng: -75.526886,
        lat: 6.2389406
      }, {
        lng: -75.5268002,
        lat: 6.2397939
      }, {
        lng: -75.5275726,
        lat: 6.2395379
      }, {
        lng: -75.5291176,
        lat: 6.2388553
      }, {
        lng: -75.5306625,
        lat: 6.240903
      }, {
        lng: -75.53092,
        lat: 6.2397085
      }, {
        lng: -75.5321217,
        lat: 6.2391113
      }, {
        lng: -75.5332375,
        lat: 6.2386847
      }, {
        lng: -75.5342674,
        lat: 6.2376608
      }, {
        lng: -75.5352974,
        lat: 6.2380021
      }, {
        lng: -75.5364132,
        lat: 6.2381727
      }, {
        lng: -75.5372715,
        lat: 6.2396232
      }, {
        lng: -75.538044,
        lat: 6.241415
      }, {
        lng: -75.5386448,
        lat: 6.2428654
      }, {
        lng: -75.5397606,
        lat: 6.2446572
      }, {
        lng: -75.5396748,
        lat: 6.2470462
      }, {
        lng: -75.5386448,
        lat: 6.2473875
      }, {
        lng: -75.5377006,
        lat: 6.2489232
      }, {
        lng: -75.5374432,
        lat: 6.2514829
      }, {
        lng: -75.537529,
        lat: 6.2541278
      }, {
        lng: -75.5370998,
        lat: 6.2562608
      }, {
        lng: -75.5377006,
        lat: 6.2576259
      }, {
        lng: -75.5386448,
        lat: 6.2566874
      }, {
        lng: -75.541563,
        lat: 6.2561755
      }, {
        lng: -75.543623,
        lat: 6.2545544
      }, {
        lng: -75.5462837,
        lat: 6.2529333
      }, {
        lng: -75.5480003,
        lat: 6.2538718
      }, {
        lng: -75.5479145,
        lat: 6.2556635
      }, {
        lng: -75.5462837,
        lat: 6.2569433
      }, {
        lng: -75.5445671,
        lat: 6.2577965
      }, {
        lng: -75.5430222,
        lat: 6.2588204
      }, {
        lng: -75.5429363,
        lat: 6.2606121
      }, {
        lng: -75.5408764,
        lat: 6.261124
      }, {
        lng: -75.5399322,
        lat: 6.2620625
      }, {
        lng: -75.5393314,
        lat: 6.2638542
      }, {
        lng: -75.538044,
        lat: 6.2635129
      }, {
        lng: -75.5371857,
        lat: 6.2620625
      }, {
        lng: -75.535469,
        lat: 6.2641101
      }, {
        lng: -75.5331516,
        lat: 6.2660724
      }, {
        lng: -75.5340958,
        lat: 6.2684613
      }, {
        lng: -75.5355549,
        lat: 6.2710208
      }, {
        lng: -75.5360699,
        lat: 6.273495
      }, {
        lng: -75.5377865,
        lat: 6.273751
      }, {
        lng: -75.537014,
        lat: 6.2744335
      }, {
        lng: -75.5340099,
        lat: 6.2752014
      }, {
        lng: -75.5349541,
        lat: 6.2759692
      }, {
        lng: -75.5358124,
        lat: 6.2781021
      }, {
        lng: -75.5371857,
        lat: 6.2798937
      }, {
        lng: -75.5366707,
        lat: 6.2817707
      }, {
        lng: -75.535984,
        lat: 6.2843301
      }, {
        lng: -75.5350399,
        lat: 6.2860364
      }, {
        lng: -75.5363274,
        lat: 6.2930322
      }, {
        lng: -75.5370998,
        lat: 6.2943972
      }, {
        lng: -75.5363274,
        lat: 6.2952503
      }, {
        lng: -75.5361557,
        lat: 6.2968713
      }, {
        lng: -75.5367565,
        lat: 6.2980657
      }, {
        lng: -75.5383015,
        lat: 6.3001985
      }, {
        lng: -75.5397606,
        lat: 6.3018194
      }, {
        lng: -75.541048,
        lat: 6.3025872
      }, {
        lng: -75.5426788,
        lat: 6.3037816
      }, {
        lng: -75.5437088,
        lat: 6.3039522
      }, {
        lng: -75.5455112,
        lat: 6.3049759
      }, {
        lng: -75.5477428,
        lat: 6.3054878
      }, {
        lng: -75.5491161,
        lat: 6.3063409
      }, {
        lng: -75.5475712,
        lat: 6.3069381
      }, {
        lng: -75.5460262,
        lat: 6.3067675
      }, {
        lng: -75.5441379,
        lat: 6.3064262
      }, {
        lng: -75.5437946,
        lat: 6.3080472
      }, {
        lng: -75.5432796,
        lat: 6.3094974
      }, {
        lng: -75.5443096,
        lat: 6.3111183
      }, {
        lng: -75.5467987,
        lat: 6.312398
      }, {
        lng: -75.5494595,
        lat: 6.3123127
      }, {
        lng: -75.5492878,
        lat: 6.3135923
      }, {
        lng: -75.5473137,
        lat: 6.3154692
      }, {
        lng: -75.5469704,
        lat: 6.3183697
      }, {
        lng: -75.5467129,
        lat: 6.3210143
      }, {
        lng: -75.5468845,
        lat: 6.3226351
      }, {
        lng: -75.5467129,
        lat: 6.3248532
      }, {
        lng: -75.5455971,
        lat: 6.3263887
      }, {
        lng: -75.5442238,
        lat: 6.326474
      }, {
        lng: -75.5423355,
        lat: 6.3249385
      }, {
        lng: -75.5404472,
        lat: 6.3255356
      }, {
        lng: -75.5387306,
        lat: 6.3265593
      }, {
        lng: -75.5390739,
        lat: 6.3277536
      }, {
        lng: -75.5368423,
        lat: 6.3286067
      }, {
        lng: -75.5347824,
        lat: 6.3282655
      }, {
        lng: -75.5350399,
        lat: 6.3295451
      }, {
        lng: -75.5334091,
        lat: 6.3303982
      }, {
        lng: -75.5313492,
        lat: 6.3311659
      }, {
        lng: -75.5298901,
        lat: 6.3311659
      }, {
        lng: -75.5292034,
        lat: 6.332019
      }, {
        lng: -75.5289459,
        lat: 6.3337251
      }, {
        lng: -75.5265427,
        lat: 6.3348341
      }, {
        lng: -75.5249977,
        lat: 6.3361137
      }, {
        lng: -75.5225086,
        lat: 6.3367109
      }, {
        lng: -75.5207062,
        lat: 6.3380758
      }, {
        lng: -75.5190754,
        lat: 6.3377345
      }, {
        lng: -75.5170155,
        lat: 6.3375639
      }, {
        lng: -75.5140114,
        lat: 6.3385023
      }, {
        lng: -75.5125523,
        lat: 6.3385023
      }, {
        lng: -75.511179,
        lat: 6.3393554
      }, {
        lng: -75.5098915,
        lat: 6.3402084
      }, {
        lng: -75.5084324,
        lat: 6.339526
      }, {
        lng: -75.5068016,
        lat: 6.3385876
      }, {
        lng: -75.5053425,
        lat: 6.3389288
      }, {
        lng: -75.5049133,
        lat: 6.3408055
      }, {
        lng: -75.5043125,
        lat: 6.3420851
      }, {
        lng: -75.5031967,
        lat: 6.3435353
      }, {
        lng: -75.5019093,
        lat: 6.3454973
      }, {
        lng: -75.500536,
        lat: 6.3469475
      }, {
        lng: -75.4991627,
        lat: 6.3478006
      }, {
        lng: -75.4971027,
        lat: 6.3483124
      }, {
        lng: -75.4973602,
        lat: 6.3498479
      }, {
        lng: -75.4965019,
        lat: 6.3507862
      }, {
        lng: -75.4953861,
        lat: 6.350445
      }, {
        lng: -75.4942703,
        lat: 6.3489948
      }, {
        lng: -75.4928112,
        lat: 6.3494213
      }, {
        lng: -75.4909229,
        lat: 6.3491654
      }, {
        lng: -75.4903221,
        lat: 6.3507862
      }, {
        lng: -75.4908371,
        lat: 6.3521511
      }, {
        lng: -75.4904938,
        lat: 6.3540278
      }, {
        lng: -75.4904938,
        lat: 6.3556485
      }, {
        lng: -75.4895496,
        lat: 6.3565015
      }, {
        lng: -75.4898071,
        lat: 6.358037
      }, {
        lng: -75.4890347,
        lat: 6.3594871
      }, {
        lng: -75.4879189,
        lat: 6.3612785
      }, {
        lng: -75.4867172,
        lat: 6.3628992
      }, {
        lng: -75.4877472,
        lat: 6.3634963
      }, {
        lng: -75.4892063,
        lat: 6.3648612
      }, {
        lng: -75.4886055,
        lat: 6.3659701
      }, {
        lng: -75.4875755,
        lat: 6.3669084
      }, {
        lng: -75.4880047,
        lat: 6.3697233
      }, {
        lng: -75.4876614,
        lat: 6.3716853
      }, {
        lng: -75.4866314,
        lat: 6.3728795
      }, {
        lng: -75.484314,
        lat: 6.3743296
      }, {
        lng: -75.4825115,
        lat: 6.3754385
      }, {
        lng: -75.4805374,
        lat: 6.3765474
      }, {
        lng: -75.4776192,
        lat: 6.3746708
      }, {
        lng: -75.4759884,
        lat: 6.3753532
      }, {
        lng: -75.4747868,
        lat: 6.3763768
      }, {
        lng: -75.4764175,
        lat: 6.3772298
      }, {
        lng: -75.4783058,
        lat: 6.3780828
      }, {
        lng: -75.4803658,
        lat: 6.3789358
      }, {
        lng: -75.4770184,
        lat: 6.3799593
      }, {
        lng: -75.4710102,
        lat: 6.3814094
      }, {
        lng: -75.4671478,
        lat: 6.3820918
      }, {
        lng: -75.4631996,
        lat: 6.3829448
      }, {
        lng: -75.4571915,
        lat: 6.3827742
      }, {
        lng: -75.4565048,
        lat: 6.3799593
      }, {
        lng: -75.4579639,
        lat: 6.3791916
      }, {
        lng: -75.460453,
        lat: 6.3789358
      }, {
        lng: -75.4635429,
        lat: 6.378424
      }, {
        lng: -75.4634571,
        lat: 6.3768886
      }, {
        lng: -75.4619122,
        lat: 6.3739031
      }, {
        lng: -75.4596806,
        lat: 6.3692115
      }, {
        lng: -75.4581356,
        lat: 6.3688703
      }, {
        lng: -75.455904,
        lat: 6.3682732
      }, {
        lng: -75.4533291,
        lat: 6.3682732
      }, {
        lng: -75.4532433,
        lat: 6.3664819
      }, {
        lng: -75.4524708,
        lat: 6.3644347
      }, {
        lng: -75.450325,
        lat: 6.3655436
      }, {
        lng: -75.4483509,
        lat: 6.3663113
      }, {
        lng: -75.4463768,
        lat: 6.3652024
      }, {
        lng: -75.4443169,
        lat: 6.3691262
      }, {
        lng: -75.4427719,
        lat: 6.3711735
      }, {
        lng: -75.4411411,
        lat: 6.374159
      }, {
        lng: -75.4419136,
        lat: 6.3760356
      }, {
        lng: -75.4415703,
        lat: 6.3782534
      }, {
        lng: -75.439682,
        lat: 6.3780828
      }, {
        lng: -75.4373646,
        lat: 6.3785946
      }, {
        lng: -75.4359055,
        lat: 6.3803858
      }, {
        lng: -75.4369354,
        lat: 6.380727
      }, {
        lng: -75.4377079,
        lat: 6.3845655
      }, {
        lng: -75.4370213,
        lat: 6.3914746
      }, {
        lng: -75.4374504,
        lat: 6.3968483
      }, {
        lng: -75.440712,
        lat: 6.3959953
      }, {
        lng: -75.4436302,
        lat: 6.3942894
      }, {
        lng: -75.4467201,
        lat: 6.3919864
      }, {
        lng: -75.4495525,
        lat: 6.3895981
      }, {
        lng: -75.4540157,
        lat: 6.3873803
      }, {
        lng: -75.4590797,
        lat: 6.3850773
      }],
      listPolyg: [],
      newUsers: [],
      mapaInstance: null
    };
  },
  created: function created() {
    var _this = this;

    if (localStorage.getItem('usuarios')) {
      this.usuarios = JSON.parse(localStorage.getItem('usuarios'));
      this.dibujarServicios();
      this.consultarAgregarDiferentes();
    } else {
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/metricas').then(function (response) {
        _this.usuarios = response.data;
        localStorage.setItem('usuarios', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.usuarios));
        _this.dibujarServicios();
      });
    }
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/primerTrimestre').then(function (response) {
      var fristDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(response.data[0].fechaRegistro);
      var difDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(fristDate, 'months');
      var trimestres = difDate / 3;
      _this.rangoTrimestres = Math.floor(trimestres);
      if (difDate % 3 > 0) {
        _this.rangoTrimestres += 1;
      }
      _this.rangoTrimestres += 1;
      _this.trimestre = _this.rangoTrimestres;
    });
    __WEBPACK_IMPORTED_MODULE_8_vue2_google_maps__["loaded"].then(function () {
      _this.$refs.myMapService.$mapCreated.then(function () {
        _this.mapaInstance = _this.$refs.myMapService.$mapObject;
        var src = 'http://storage.googleapis.com/gpds-geo-zonas/AreaMetroMensajeriaMapa.kml';
        _this.kmlAreaMetropolitana = new google.maps.KmlLayer(src, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: null
        });
      });
    });
  },
  mounted: function mounted() {
    this.agregarFechaUltimoServicio();
  },

  methods: {
    dibujarServicios: function dibujarServicios() {
      var _this2 = this;

      var totalFecha = this.usuarios.reduce(function (a, b) {
        if (b.fechaUltimoServicio !== '-') {
          return a + 1;
        }
        return a;
      }, 0);
      if (this.usuarios.length !== totalFecha) {
        this.todasFechas = false;
      }
      __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(this.usuarios, function (element) {
        var iconName = __webpack_require__(50);
        var fechaServicio = element.fechaUltimoServicio ? element.fechaUltimoServicio : '-';
        if (element.fechaRegistro) {
          if (_this2.diferenciaFecha(element.fechaRegistro) > 30) {
            iconName = __webpack_require__(31);
          }
        }
        if (element.geo) {
          _this2.markers.push({
            position: {
              lat: parseFloat(element.geo.lat),
              lng: parseFloat(element.geo.lng)
            },
            id: element.id,
            infoText: '<strong>Nombre: </strong>' + element.nombre + '<br><strong>Fecha registro: </strong>' + _this2.formatoFecha(element.fechaRegistro) + '<br><strong>Fecha ultimo servicio: </strong>' + fechaServicio,
            icon: iconName
          });
        }
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    diferenciaFecha: function diferenciaFecha(fecha) {
      var today = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
      return today.diff(fecha, 'days');
    },
    agregarFechaUltimoServicio: function agregarFechaUltimoServicio() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _loop, index;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop(index) {
                  var usuario, today, fechaUltimoServicio, indexUser, indexMarker, _fechaUltimoServicio, _indexUser, _indexMarker;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          usuario = _this3.usuarios[index];
                          today = __WEBPACK_IMPORTED_MODULE_5_moment___default()();

                          if (!usuario.fechaUltimoServicio) {
                            _context.next = 13;
                            break;
                          }

                          if (!(today.diff(usuario.fechaUltimoServicio, 'days') > 30)) {
                            _context.next = 11;
                            break;
                          }

                          _context.next = 6;
                          return _this3.getLastDate(usuario.id);

                        case 6:
                          fechaUltimoServicio = _context.sent;
                          indexUser = _this3.usuarios.findIndex(function (item) {
                            return item.id === usuario.id;
                          });

                          _this3.usuarios[indexUser].fechaUltimoServicio = fechaUltimoServicio;
                          indexMarker = _this3.markers.findIndex(function (item) {
                            return item.id === usuario.id;
                          });

                          if (indexMarker !== -1) {
                            _this3.markers[indexMarker].infoText = '<strong>Nombre: </strong>' + usuario.nombre + '<br><strong>Fecha registro: </strong>' + _this3.formatoFecha(usuario.fechaRegistro) + '<br><strong>Fecha ultimo servicio: </strong> ' + fechaUltimoServicio;
                          }

                        case 11:
                          _context.next = 21;
                          break;

                        case 13:
                          _context.next = 15;
                          return _this3.getLastDate(usuario.id);

                        case 15:
                          _fechaUltimoServicio = _context.sent;

                          _this3.$Progress.start();
                          _indexUser = _this3.usuarios.findIndex(function (item) {
                            return item.id === usuario.id;
                          });

                          _this3.usuarios[_indexUser].fechaUltimoServicio = _fechaUltimoServicio;
                          _indexMarker = _this3.markers.findIndex(function (item) {
                            return item.id === usuario.id;
                          });

                          if (_indexMarker !== -1) {
                            _this3.markers[_indexMarker].infoText = '<strong>Nombre: </strong>' + usuario.nombre + '<br><strong>Fecha registro: </strong>' + _this3.formatoFecha(usuario.fechaRegistro) + '<br><strong>Fecha ultimo servicio: </strong>' + _fechaUltimoServicio;
                          }

                        case 21:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _loop, _this3);
                });
                index = 0;

              case 2:
                if (!(index < _this3.usuarios.length)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.delegateYield(_loop(index), 't0', 4);

              case 4:
                index++;
                _context2.next = 2;
                break;

              case 7:
                console.log('finish');
                _this3.todasFechas = false;
                localStorage.setItem('usuarios', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this3.usuarios));
                _this3.$Progress.finish();

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getLastDate: function getLastDate(id) {
      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/ultimoServicio/' + id).then(function (response) {
        if (response.data.length > 0) {
          return response.data[0].fecha;
        } else {
          return '-';
        }
      });
    },
    formatoFecha: function formatoFecha(fecha) {
      if (fecha) {
        return __WEBPACK_IMPORTED_MODULE_5_moment___default()(fecha).format('DD-MM-YYYY HH:mm A');
      }
      return '-';
    },
    countdown: function countdown() {
      this.remainingCount = this.maxCount - this.message.length;
      this.hasError = this.remainingCount < 0;
    },
    consultarAgregarDiferentes: function consultarAgregarDiferentes() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://mensajeria.guepardos.co/api/v2/metricasMonth').then(function (response) {
        var _loop2 = function _loop2(index) {
          var element = response.data[index];
          var aux = _this4.usuarios.filter(function (usuario) {
            return usuario.id === element.id;
          });
          if (aux.length === 0) {
            _this4.usuarios.push(element);
            localStorage.setItem('usuarios', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this4.usuarios));
          }
        };

        for (var index = 0; index < response.data.length; index++) {
          _loop2(index);
        }
      });
    },
    examinarUsuarios: function examinarUsuarios() {
      var _this5 = this;

      if (this.prueba) {
        if (!this.celular) {
          this.notificacionCelular();
          return;
        }
        if (!this.message) {
          this.notificacionMessage();
          return;
        }
        var telefonos = this.celular.split(',');
        this.$Progress.start();
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('https://mensajeria.guepardos.co/api/v2/enviarSmsPrueba', { celulares: telefonos, mensaje: this.message }).then(function (response) {
          _this5.$Progress.finish();
          if (response.data.length === 0) {
            _this5.notificacionCError();
          }
          _this5.enviarNotificaciones(response.data);
        }).catch(function () {
          _this5.$Progress.finish();
          _this5.notificacionCError();
        });
        return;
      }
      if (this.zonasSelected.length === 0 || !this.message) {
        this.notificacionInvalido();
        return;
      }
      var usuariosPasan = [];

      var _loop3 = function _loop3(index) {
        var poli = _this5.listPolyg.find(function (o) {
          return o.numero === _this5.zonasSelected[index].value;
        });
        console.log(_this5.zonasSelected[index].value);
        for (var index2 = 0; index2 < _this5.newUsers.length; index2++) {
          var _element = _this5.newUsers[index2];
          if (_element.geo) {
            var lanLng = new google.maps.LatLng(_element.geo.lat, _element.geo.lng);
            var isOnZone = google.maps.geometry.poly.containsLocation(lanLng, poli);
            if (isOnZone) {
              usuariosPasan.push(_element);
            }
          }
        }
      };

      for (var index = 0; index < this.zonasSelected.length; index++) {
        _loop3(index);
      }
      usuariosPasan = usuariosPasan.map(function (item) {
        return item.id;
      });
      this.enviarNotificaciones(usuariosPasan);
      this.enviandoMensajes();
    },
    enviarNotificaciones: function enviarNotificaciones(ids) {
      var _this6 = this;

      this.$Progress.start();
      console.log(ids);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('https://mensajeria.guepardos.co/api/v2/enviarNotificacion', { usuarios: ids, mensaje: this.message }).then(function (response) {
        _this6.notificacionSuccess();
        _this6.$Progress.finish();
      }).catch(function () {
        console.log('error');
        _this6.$Progress.finish();
      });
    },
    filtrarUsuarios: function filtrarUsuarios(inicio, fin) {
      return this.usuarios.filter(function (usuario) {
        if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(usuario.fechaRegistro).isBetween(inicio, fin)) {
          return usuario;
        }
      });
    },
    filtrarUsuariosUltimo: function filtrarUsuariosUltimo(inicio, fin) {
      return this.usuarios.filter(function (usuario) {
        if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(usuario.fechaUltimoServicio).isBetween(inicio, fin)) {
          return usuario;
        }
      });
    },
    marcarZonas: function marcarZonas() {
      if (this.listPolyg.length === 0) {
        var laureles = new google.maps.Polygon({
          path: this.zonaLaureles,
          geodesic: true,
          strokeColor: '#0f9d58',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#0f9d58',
          fillOpacity: 0.35,
          numero: 1
        });
        var centro = new google.maps.Polygon({
          path: this.zonaCentro,
          geodesic: true,
          strokeColor: '#f57c00',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#f57c00',
          fillOpacity: 0.35,
          numero: 2
        });
        var envigado = new google.maps.Polygon({
          path: this.zonaEnvigado,
          geodesic: true,
          strokeColor: '#9c27b0',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#9c27b0',
          fillOpacity: 0.35,
          numero: 4
        });
        var poblado = new google.maps.Polygon({
          path: this.zonaPoblado,
          geodesic: true,
          strokeColor: '#0097a7',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#0097a7',
          fillOpacity: 0.35,
          numero: 3
        });
        var metro = new google.maps.Polygon({
          path: this.zonaMetro,
          geodesic: true,
          strokeColor: '#0097a7',
          strokeOpacity: 1.0,
          strokeWeight: 4,
          fillColor: '#0097a7',
          fillOpacity: 0.35,
          numero: 5
        });
        laureles.setMap(this.$refs.myMapService.$mapObject);
        centro.setMap(this.$refs.myMapService.$mapObject);
        envigado.setMap(this.$refs.myMapService.$mapObject);
        poblado.setMap(this.$refs.myMapService.$mapObject);
        metro.setMap(this.$refs.myMapService.$mapObject);
        this.listPolyg.push(laureles);
        this.listPolyg.push(centro);
        this.listPolyg.push(poblado);
        this.listPolyg.push(envigado);
        this.listPolyg.push(metro);
      }
      return;
    }
  },
  watch: {
    trimestre: function trimestre(value) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var trimestre, mes, mesInicial, mesFinal;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.trimestre = value;
                trimestre = (_this7.rangoTrimestres - 1) * 3;
                mes = _this7.trimestre * 3 - 3;

                mes = trimestre - mes;
                mesInicial = __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(mes, 'months').startOf('month');
                mesFinal = __WEBPACK_IMPORTED_MODULE_5_moment___default()(mesInicial).add(3, 'months').endOf('month');
                _context3.next = 8;
                return _this7.filtrarUsuarios(mesInicial, mesFinal);

              case 8:
                _this7.newUsers = _context3.sent;

                _this7.markers = [];

                if (!(Number(_this7.trimestre) === 0)) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt('return');

              case 12:
                if (Number(_this7.trimestre) === Number(_this7.rangoTrimestres)) {
                  _this7.newUsers = _this7.usuarios;
                }
                __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(_this7.newUsers, function (element) {
                  var fechaServicio = element.fechaUltimoServicio ? element.fechaUltimoServicio : '-';
                  var iconName = __webpack_require__(50);
                  if (element.fechaRegistro) {
                    if (_this7.diferenciaFecha(element.fechaRegistro) > 30) {
                      iconName = __webpack_require__(31);
                    }
                  }
                  if (element.geo) {
                    _this7.markers.push({
                      position: {
                        lat: parseFloat(element.geo.lat),
                        lng: parseFloat(element.geo.lng)
                      },
                      id: element.id,
                      infoText: '<strong>Nombre: </strong>' + element.nombre + '<br><strong>Fecha registro: </strong>' + _this7.formatoFecha(element.fechaRegistro) + '<br><strong>Fecha ultimo servicio: </strong>' + fechaServicio,
                      icon: iconName
                    });
                  }
                });

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    trimestreServicio: function trimestreServicio(value) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var trimestre, mes, mesInicial, mesFinal;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8.trimestreServicio = value;
                trimestre = (_this8.rangoTrimestres - 1) * 3;
                mes = _this8.trimestreServicio * 3 - 3;

                mes = trimestre - mes;
                mesInicial = __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(mes, 'months').startOf('month');
                mesFinal = __WEBPACK_IMPORTED_MODULE_5_moment___default()(mesInicial).add(3, 'months').endOf('month');
                _context4.next = 8;
                return _this8.filtrarUsuariosUltimo(mesInicial, mesFinal);

              case 8:
                _this8.newUsers = _context4.sent;

                _this8.markers = [];

                if (!(Number(_this8.trimestreServicio) === 0)) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt('return');

              case 12:
                if (Number(_this8.trimestreServicio) === Number(_this8.rangoTrimestres)) {
                  _this8.newUsers = _this8.usuarios;
                }
                __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(_this8.newUsers, function (element) {
                  var iconName = __webpack_require__(50);
                  if (element.fechaUltimoServicio) {
                    if (_this8.diferenciaFecha(element.fechaUltimoServicio) > 30) {
                      iconName = __webpack_require__(31);
                    }
                  }
                  if (element.geo) {
                    _this8.markers.push({
                      position: {
                        lat: parseFloat(element.geo.lat),
                        lng: parseFloat(element.geo.lng)
                      },
                      id: element.id,
                      infoText: '<strong>Nombre: </strong>' + element.nombre + '<br><strong>Fecha registro: </strong>' + _this8.formatoFecha(element.fechaRegistro) + '<br><strong>Fecha ultimo servicio: </strong>' + element.fechaUltimoServicio,
                      icon: iconName
                    });
                  }
                });

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    },
    zonasSelected: function zonasSelected(value) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var marcar, index, _element2, _index, _element3;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this9.marcarZonas();

              case 2:
                marcar = _context5.sent;

                for (index = 0; index < _this9.listPolyg.length; index++) {
                  _element2 = _this9.listPolyg[index];

                  _element2.setMap(null);
                }
                for (_index = 0; _index < _this9.zonasSelected.length; _index++) {
                  _element3 = _this9.zonasSelected[_index];

                  _this9.listPolyg[_element3.value - 1].setMap(_this9.$refs.myMapService.$mapObject);
                }

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    mensajePredefinido: function mensajePredefinido(value) {
      this.mensajePredefinido = value;
      this.message = 'Tenemos un Guepardo en tu zona. Tus vueltas de mensajeria HOY mismo, desde 5.800 COP, Programalo aqui: ';
    }
  },
  notifications: {
    notificacionCelular: {
      title: 'Celular Invalido',
      message: 'Introduce un número de celular valido.',
      type: 'info',
      timeout: 9000
    },
    notificacionCError: {
      title: 'Celular Invalido',
      message: 'No se encontro ningun usuario con ese número de celular.',
      type: 'error',
      timeout: 9000
    },
    notificacionMessage: {
      title: 'Mensaje Invalido',
      message: 'Introduce un mensaje valido.',
      type: 'info',
      timeout: 9000
    },
    notificacionSuccess: {
      title: 'Mensaje Enviado',
      message: 'Mensaje enviado correctamente.',
      type: 'info',
      timeout: 9000
    },
    enviandoMensajes: {
      title: 'Mensajes Enviados',
      message: 'Los mensajes serán enviados a los clientes filtrados.',
      type: 'success',
      timeout: 9000
    },
    notificacionInvalido: {
      title: 'Formulario invalido',
      message: 'Seleccione una zona y un mensaje valido.',
      type: 'error',
      timeout: 9000
    }
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'servicio',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      GET_SERVICE_URL: 'https://mensajeria.guepardos.co/api/v2/services/',
      Url_Mensajeros: 'https://mensajeria.guepardos.co/api/v2/messengersPositions',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 14,
      rating: 0,
      comentario: '',
      showDistancia: false,
      infoWinOpen: false,
      currentMidx: null,
      showPrecios: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      servicio: {},
      mensajero: {},
      mensajeroNombre: '',
      mensajeroCelular: '',
      noDibujar: false,
      recogido: [],
      entregas: [],
      finalizado: [],
      waypts: [],
      lastPosition: [],
      mensajeros: [],
      mensajerosData: [],
      makersToRemove: [],
      totalEntregas: 0,
      kilometrosCirculo: 2.5,
      entregasDirecciones: [],
      estado: '',
      id: '',
      infoText: '',
      dibujarCirculos: true,
      circles: [],
      mostrarMensajeRecogida: true,
      mostrarNav: true,
      marcarRuta: true,
      quitarRadios: false,
      valorRadios: 0,
      valorKm: 0,
      distancia: 0,
      showKm: false,
      showRd: false,
      conNav: false,
      sinNav: false,
      isAdmin: false,
      showComment: false,
      formatNumber: {
        separador: '.', // separador para los miles
        sepDecimal: ',', // separador para los decimales
        formatear: function formatear(num) {
          num += '';
          var splitStr = num.split('.');
          var splitLeft = splitStr[0];
          var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
          var regx = /(\d+)(\d{3})/;
          while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
          }
          return this.simbol + splitLeft + splitRight;
        },
        new: function _new(num, simbol) {
          this.simbol = simbol || '';
          return this.formatear(Math.round(num / 100) * 100);
        }
      }
    };
  },
  mounted: function mounted() {
    this.mensajero.nombre = '';
    if (this.$route.query.adm) {
      this.isAdmin = JSON.parse(this.$route.query.adm);
    }
    if (this.$route.query.nav) {
      this.mostrarNav = JSON.parse(this.$route.query.nav);
      this.sinNav = true;
      this.conNav = false;
    } else {
      this.sinNav = false;
      this.conNav = true;
    }
    this.getData();
    this.interval = setInterval(function () {
      this.getData();
    }.bind(this), 10000);
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var vm = this;
      vm.$http.get('https://mensajeria.guepardos.co/api/v2/services/' + vm.$route.params.id).then(function (data) {
        if (data.body.error) {
          vm.$http.get('https://mensajeria.guepardos.co/api/v2/servicio-ticket/' + vm.$route.params.id).then(function (data) {
            _this.getDataExtra(data);
          });
        } else {
          _this.getDataExtra(data);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getDataExtra: function getDataExtra(data) {
      var _this2 = this;

      var vm = this;
      vm.servicio = data.body;
      __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__["loaded"].then(function () {
        _this2.$refs.myMap.$mapCreated.then(function () {
          var src = 'http://storage.googleapis.com/gpds-geo-zonas/AreaMetroMensajeriaMapa.kml';
          if (vm.servicio.compartido || vm.servicio.agrupado) {
            src = 'https://storage.googleapis.com/gpds-geo-zonas/MunicipiosDelAreaMetro.kml';
            var MarkerWithLabel = __webpack_require__(68)(google.maps);
            var medellin = new google.maps.LatLng(6.247389415831316, -75.58053604236915);
            var markerPriceMedellin = new MarkerWithLabel({
              position: medellin,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(5800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var envigado = new google.maps.LatLng(6.171625973057168, -75.58403263540202);
            var markerPriceEnvigado = new MarkerWithLabel({
              position: envigado,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(5800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var itagui = new google.maps.LatLng(6.186495802555004, -75.6046181705226);
            var markerPriceItagui = new MarkerWithLabel({
              position: itagui,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(5800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var sabaneta = new google.maps.LatLng(6.152991088357088, -75.6167556269836);
            var markerPriceSabaneta = new MarkerWithLabel({
              position: sabaneta,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(6800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var estrella = new google.maps.LatLng(6.135811030451446, -75.63579718679);
            var markerPriceEstrella = new MarkerWithLabel({
              position: estrella,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var caldas = new google.maps.LatLng(6.088932375769244, -75.63519446322465);
            var markerPriceCaldas = new MarkerWithLabel({
              position: caldas,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var sanAntonio = new google.maps.LatLng(6.183530968697657, -75.65517574307182);
            var markerPriceSanAntonio = new MarkerWithLabel({
              position: sanAntonio,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var bello = new google.maps.LatLng(6.337490251683754, -75.5610933553238);
            var markerPriceBello = new MarkerWithLabel({
              position: bello,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(6800),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
            var copacabana = new google.maps.LatLng(6.354739962376049, -75.50292838529327);
            var markerPriceCopacabana = new MarkerWithLabel({
              position: copacabana,
              draggable: false,
              raiseOnDrag: false,
              map: vm.$refs.myMap.$mapObject,
              icon: ' ',
              labelContent: '$' + vm.formatNumber.new(11600),
              labelAnchor: new google.maps.Point(22, 0),
              labelClass: 'labelsMarker', // the CSS class for the label
              labelStyle: { opacity: 1 }
            });
          }
          var kmlLayer = new google.maps.KmlLayer(src, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: vm.$refs.myMap.$mapObject
          });
        });
      });
      vm.id = this.servicio.id.substr(-6);
      vm.finalizado = vm._.find(vm.servicio.fechaHoraEstados, function (o) {
        if (o.estado === 3) {
          return o;
        }
      });
      if (vm.finalizado) {
        clearInterval(vm.interval);
      }
      vm.dibujarPuntos();
      vm.$http.get('https://mensajeria.guepardos.co/api/v2/menssengerService/' + vm.$route.params.id).then(function (data) {
        vm.mensajero = data.body;
        vm.mensajeroNombre = vm.mensajero.nombre;
        vm.mensajeroCelular = vm.mensajero.celular;
        vm.$http.get('https://mensajeria.guepardos.co/api/v2/messengerPosition/' + vm.servicio.mensajeroId).then(function (data) {
          if (data.body.length > 0) {
            vm.lastPosition = data.body[0].metadata.coords;
          }
        });
      });
      vm.$http.get('https://mensajeria.guepardos.co/api/v2/messengersPositions').then(function (data) {
        console.log(data.body);
        vm.mensajerosData = data.body;
      });
    },
    dibujarPuntos: function dibujarPuntos() {
      var vm = this;
      vm.$refs.myMap.$mapCreated.then(function () {
        vm.markers = [];
        vm.dibujarRecogida(vm.servicio.geoR.lat, vm.servicio.geoR.lng);
        vm.recogido = vm._.find(vm.servicio.fechaHoraEstados, function (o) {
          if (o.estado === 1) {
            return o;
          }
        });
        vm.dibujarRegresos(vm._.filter(vm.servicio.fechaHoraEntregas, function (o) {
          return o.regreso;
        }));
        if (vm.servicio.calificacion) {
          vm.rating = vm.servicio.calificacion;
          vm.showComment = true;
          if (vm.servicio.comentarioCalificacion) {
            vm.comentario = vm.servicio.comentarioCalificacion;
          }
        }
        if (!vm.servicio.tarifa.distancias) {
          vm.servicio.tarifa.distancias = {
            usuario: 0,
            mensajero: 0,
            operador: 0
          };
        }
        vm.showDistancia = true;
        if (vm.servicio.distancia && vm.servicio.distancia !== 0) {
          vm.distancia = vm.servicio.distancia;
        } else {
          vm.showDistancia = true;
          if (vm.servicio.tarifa.distancias.usuario && vm.servicio.tarifa.distancias.usuario !== 0) {
            vm.distancia = vm.servicio.tarifa.distancias.usuario;
          } else {
            if (vm.servicio.tarifa.distancias.mensajero && vm.servicio.tarifa.distancias.mensajero !== 0) {
              vm.distancia = vm.servicio.tarifa.distancias.mensajero;
            } else {
              vm.distancia = 0;
            }
          }
        }
        if (vm.recogido) {
          vm.mostrarMensajeRecogida = false;
        }
        vm.entregasDirecciones = [];
        var entregas = [];
        if (vm.servicio.entregasMapa) {
          entregas = vm.servicio.entregasMapa;
        } else {
          entregas = vm.servicio.fechaHoraEntregas.filter(function (item) {
            return !item.regreso;
          });
        }
        vm._.forEach(vm.servicio.fechaHoraEntregas, function (entrega, index) {
          if (!entrega.regreso) {
            var fecha = __WEBPACK_IMPORTED_MODULE_3_moment___default()(entrega.fecha).format('HH:mm:ss');
            var valor = 0;
            if (entrega.valor) {
              valor = '$' + entrega.valor;
            }
            vm.markers.push({
              position: {
                lat: parseFloat(entrega.coordenadas.latitude),
                lng: parseFloat(entrega.coordenadas.longitude)
              },
              infoText: 'Entrega ' + (index + 1) + ' - ' + fecha + ' - ' + valor,
              icon: __webpack_require__(15)
            });
          }
        });
        vm._.forEach(vm.markers, function (marker, index) {
          if (index >= 1) {
            marker.direccion = 'Entrega ' + index;
            marker.index = index;
            vm.entregasDirecciones.push(marker);
          }
        });
        vm.distancia = vm.servicio.tarifa.distancia;
        vm.valorKm = vm.servicio.tarifa.valorKm;
        switch (vm.servicio.estadoServicio) {
          case 99:
            vm.estado = 'Pendiente';
            console.log('dsfsdfasdfsdfdsadfdsafdsa');
            vm.dibujarMensajeros();
            break;
          case 0:
            vm.estado = 'Asignado';
            vm.dibujarMensajeroAsignado();
            if (vm.mostrarMensajeRecogida) {
              vm.$notify({
                group: 'foo',
                title: 'Información',
                type: 'warning',
                text: 'El servicio ha sido asigando y está en proceso de ser recogido.',
                duration: -1
              });
            }
            vm.mostrarMensajeRecogida = false;
            break;
          case 1:
            vm.estado = 'Recogido';
            vm.dibujarMensajeroAsignado();
            vm.$notify({
              group: 'foo',
              clean: true
            });
            break;
          case 2:
            vm.estado = 'Entregado';
            vm.dibujarMensajeroAsignado();
            vm.$notify({
              group: 'foo',
              clean: true
            });
            break;
          case 3:
            vm.estado = 'Finalizado';
            vm.mensajeros = [];
            vm.showPrecios = true;
            if (vm.marcarRuta) {
              vm.getRoute();
              vm.obtenerDirecciones();
            }
            vm.$notify({
              group: 'foo',
              clean: true
            });
            break;
          case 4:
            vm.estado = 'Cancelado';
            vm.mensajeros = [];
            vm.$notify({
              group: 'foo',
              clean: true
            });
            break;
          default:
            vm.estado = 'Pendiente';
            break;
        }
      });
    },
    dibujarRegresos: function dibujarRegresos(regresos) {
      var vm = this;
      vm._.forEach(regresos, function (regreso, index) {
        vm.markers.push({
          position: {
            lat: regreso.coordenadas.latitude,
            lng: regreso.coordenadas.longitude
          },
          infoText: 'Regreso ' + (index + 1),
          icon: __webpack_require__(316)
        });
      });
    },
    dibujarRecogida: function dibujarRecogida(lat, lng, tipo, fecha) {
      var _this3 = this;

      var fechaFormat = __WEBPACK_IMPORTED_MODULE_3_moment___default()(fecha).format('HH:mm:ss');
      var vm = this;
      if (tipo) {
        vm.infoText = 'Punto de Recogida - ' + fechaFormat;
      } else {
        vm.infoText = 'Recogida - ' + fechaFormat;
      }
      vm.markers.push({
        position: {
          lat: lat,
          lng: lng
        },
        infoText: vm.infoText,
        icon: __webpack_require__(30)
      });
      var center = { lat: lat, lng: lng };
      if (!vm.mensajero) {
        vm.center = { lat: lat, lng: lng };
      }
      if (vm.dibujarCirculos && vm.noDibujar) {
        vm.dibujarCirculos = false;
        vm.$refs.myMap.resizePreserveCenter();
        if (!vm.servicio.compartido && !vm.servicio.agrupado && vm.quitarRadios) {
          vm.$http.get('https://mensajeria.guepardos.co/api/v2/franchises').then(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
              var valores, MarkerWithLabel;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return vm.valoresRadios();

                    case 2:
                      valores = _context.sent;

                      valores.distancias[0].maximoKilometros = response.body[0].radio3;
                      valores.distancias[1].minimoKilometros = response.body[0].radio3;
                      valores.distancias[1].maximoKilometros = response.body[0].radio4;
                      valores.distancias[2].minimoKilometros = response.body[0].radio4;
                      valores.distancias[2].maximoKilometros = response.body[0].radio5;
                      valores.distancias[3].minimoKilometros = response.body[0].radio5;
                      valores.distancias[3].maximoKilometros = response.body[0].radio6;
                      valores.distancias[4].minimoKilometros = response.body[0].radio6;
                      valores.distancias[4].maximoKilometros = response.body[0].radio7;
                      MarkerWithLabel = __webpack_require__(68)(google.maps);

                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio1, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio2, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio3, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio4, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio5, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio6, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio7, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);
                      vm.dibujarMarkadorValor(center.lat, center.lng, response.body[0].radio8, valores, vm.$refs.myMap.$mapObject, MarkerWithLabel);

                    case 21:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this3);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        }
      }
    },
    valoresRadios: function valoresRadios() {
      return this.$http.get('https://mensajeria.guepardos.co/api/v2/valorRadios/' + this.servicio.tarifa.numEntregas).then(function (response) {
        return response.data;
      });
    },
    dibujarMarkadorValor: function dibujarMarkadorValor(lat, lng, distancia, valores, mapa, MarkerWithLabel) {
      var vm = this;
      var meters = distancia * 1000;
      meters = meters - 700;
      var coef = meters * 0.0000089;
      var coefDown = (meters + 600) * 0.0000089;
      var newLng = lng + coef;
      var newLat = lat + coef / Math.cos(lat * 0.018);
      var newLatDown = lat - coefDown / Math.cos(lat * 0.018);
      var valor = valores.distancias.find(function (item) {
        if (item.minimoKilometros <= distancia && item.maximoKilometros >= distancia) {
          return item;
        }
      });
      valor = vm.servicio.idaVuelta ? valor.valorR : valor.valor;
      valor = vm.formatNumber.new(valor);
      var homeLatLng = new google.maps.LatLng(newLat, lng);
      var homeLatLngDown = new google.maps.LatLng(newLatDown, lng);
      if (distancia > 0) {
        var marker1 = new MarkerWithLabel({
          position: homeLatLng,
          draggable: false,
          raiseOnDrag: false,
          map: mapa,
          icon: ' ',
          labelContent: 'Max. $' + valor,
          labelClass: 'labelsMarker', // the CSS class for the label
          labelStyle: { opacity: 1 }
        });
        // vm.makersToRemove.push(marker1)
        var iw = new google.maps.InfoWindow({
          content: 'Entregas dentro del radio valen $' + valor
        });
        google.maps.event.addListener(marker1, 'click', function (e) {
          iw.open(mapa, this);
        });
        var marker2 = new MarkerWithLabel({
          position: homeLatLngDown,
          draggable: false,
          raiseOnDrag: false,
          map: mapa,
          icon: ' ',
          labelContent: 'Max. $' + valor,
          labelClass: 'labelsMarkerUp', // the CSS class for the label
          labelStyle: { opacity: 1 }
        });
        // vm.makersToRemove.push(marker1)
        var iw2 = new google.maps.InfoWindow({
          content: 'Entregas dentro del radio valen $' + valor
        });
        google.maps.event.addListener(marker2, 'click', function (e) {
          iw2.open(mapa, this);
        });
        this.circles.push({
          center: {
            lat: lat,
            lng: lng
          },
          radius: distancia * 1000,
          visible: true
        });
      }
    },
    dibujarEntrega: function dibujarEntrega(lat, lng) {
      var vm = this;
      this.markers.push({
        position: {
          lat: lat,
          lng: lng
        },
        infoText: 'Entrega',
        icon: __webpack_require__(15)
      });
      vm.distancia = vm.servicio.tarifa.distancia;
      vm.valorKm = vm.servicio.tarifa.valorKm;
      vm.showKm = true;
      vm.showRd = false;
      if (this.marcarRuta) {
        this.getRoute();
      }
    },
    dibujarMensajeros: function dibujarMensajeros() {
      var vm = this;
      vm.mensajeros = [];
      vm._.forEach(vm.mensajerosData, function (mensajero) {
        vm.mensajeros.push({
          position: {
            lat: parseFloat(mensajero.ultimaPosicion.point.lat),
            lng: parseFloat(mensajero.ultimaPosicion.point.lng)
          },
          infoText: mensajero.nombre + ' - Placa: ' + mensajero.placa + ' - Celular: ' + mensajero.celular,
          icon: __webpack_require__(19)
        });
      });
    },
    dibujarMensajeroAsignado: function dibujarMensajeroAsignado() {
      var vm = this;
      if (vm.lastPosition.latitude && vm.lastPosition.longitude) {
        var fotoUrl = vm.mensajero.imagenPerfil ? 'https://storage.googleapis.com/gpds-web-storage/' + vm.mensajero.imagenPerfil : vm.mensajero.foto;
        vm.mensajeros = [];
        /*         if (vm.mensajero.imagenProfile) {
                  vm.$http.get(`https://mensajeria.guepardos.co/api/v2/getImagenProfile/${vm.mensajero.imagenProfile}`)
                    .then(data => {
                      var icon = {
                        url: 'data:' + vm.mensajero.imagenTipo + ';base64,' + data.body, // url
                        scaledSize: new google.maps.Size(50, 50), // scaled size
                        origin: new google.maps.Point(0, 0), // origin
                        anchor: new google.maps.Point(0, 0) // anchor
                      }
                      vm.mensajeros.push({
                        position: {
                          lat: parseFloat(vm.lastPosition.latitude),
                          lng: parseFloat(vm.lastPosition.longitude)
                        },
                        infoText: `${mensajero.nombre} - Placa: ${mensajero.placa} - Celular: ${mensajero.celular}`,
                        icon: icon
                      })
                      vm.center = {
                        lat: parseFloat(vm.lastPosition.latitude),
                        lng: parseFloat(vm.lastPosition.longitude)
                      }
                      vm.zoom = 15
                    })
                } else { */
        vm.mensajeros.push({
          position: {
            lat: parseFloat(vm.lastPosition.latitude),
            lng: parseFloat(vm.lastPosition.longitude)
          },
          infoText: '<div><img src="' + fotoUrl + '" style="display: block; margin: 0 auto;" width="150"/></div><div><strong>Nombre: </strong>' + vm.mensajero.nombre + '<br><strong>Placa: </strong>' + vm.mensajero.placa + ' <br><strong>Celular: </strong>' + vm.mensajero.celular + '</div>',
          icon: __webpack_require__(19)
        });
        vm.center = {
          lat: parseFloat(vm.lastPosition.latitude),
          lng: parseFloat(vm.lastPosition.longitude)
        };
        vm.zoom = 15;
      }
    },
    obtenerDirecciones: function obtenerDirecciones() {
      var vm = this;
      vm.entregasDirecciones = [];
      if (vm.markers.length <= 10) {
        vm._.forEach(vm.markers, function (marker, index) {
          if (index >= 1) {
            var latlng = new google.maps.LatLng(marker.position.lat, marker.position.lng);
            var direccion = vm.googleDirecciones(latlng, index);
          }
        });
      } else {
        vm._.forEach(vm.markers, function (marker, index) {
          if (index >= 1) {
            marker.direccion = 'Enterga ' + (index + 1);
            marker.index = index + 1;
            vm.entregasDirecciones.push(marker);
          }
        });
      }
    },
    googleDirecciones: function googleDirecciones(latlng, index) {
      var vm = this;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'latLng': latlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          vm.markers[index].direccion = results[0].formatted_address;
          vm.markers[index].index = index + 1;
          vm.entregasDirecciones.push(vm.markers[index]);
        } else {
          vm.googleDirecciones(latlng, index);
        }
      });
    },
    roundFormat: function roundFormat(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    },
    currencyFormat: function currencyFormat(value, decimals) {
      var symbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '$ ';

      return symbol + this.roundFormat(value, 2);
    },
    getRoute: function getRoute() {
      var vm = this;
      vm.zoom = 13;
      vm.marcarRuta = false;
      vm.directionsService = new google.maps.DirectionsService();
      vm.directionsDisplay = new google.maps.DirectionsRenderer({
        'draggable': false,
        suppressMarkers: true
      });
      vm.directionsDisplay.setMap(vm.$refs.myMap.$mapObject);
      vm._.forEach(vm.markers, function (entrega, index) {
        vm.waypts.push({
          location: { 'lat': entrega.position.lat, 'lng': entrega.position.lng },
          stopover: true
        });
      });
      vm.directionsService.route({
        origin: new google.maps.LatLng(vm.markers[0].position.lat, vm.markers[0].position.lng),
        destination: new google.maps.LatLng(vm.markers[vm.markers.length - 1].position.lat, vm.markers[vm.markers.length - 1].position.lng),
        waypoints: vm.waypts,
        optimizeWaypoints: true,
        travelMode: 'DRIVING'
      }, function (response, status) {
        if (status === 'OK') {
          vm.directionsDisplay.setDirections(response);
          vm.$refs.myMap.resizePreserveCenter();
        } else {
          console.log('Directions request failed due to ' + status);
        }
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    setRating: function setRating() {
      var vm = this;
      var inf = {
        calificacion: vm.rating
        /* vm.$http.put(`https://evocloud-guepardos.appspot.com/api/servicios/${vm.servicio.id}`, inf)
            .then(data => {
              vm.showComment = true
            }) */
      };
    }
  },
  computed: {
    tiempoServicio: function tiempoServicio() {
      if (this.servicio.estadoServicio === 3) {
        var finalizado = this._.find(this.servicio.fechaHoraEstados, { 'estado': 3 });
        var a = __WEBPACK_IMPORTED_MODULE_3_moment___default()(finalizado.fecha);
        var b = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.servicio.fecha);
        var diff = a.diff(b, 'minutes');
        return diff + ' Minutos';
      } else {
        var _a = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
        var _b = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.servicio.fecha);
        var _diff = _a.diff(_b, 'minutes');
        return _diff + ' Minutos';
      }
    },
    entregasSinRegresos: function entregasSinRegresos() {
      var entregas = 0;
      if (this.servicio.entregasMapa) {
        entregas = this.servicio.entregasMapa;
      } else {
        entregas = this._.filter(this.servicio.fechaHoraEntregas, function (entrega) {
          return !entrega.regreso;
        });
      }
      return entregas.length;
    }
  },
  notifications: {
    notificacionRecogido: {
      title: 'Información',
      message: 'El servicio ha sido asigando y está en proceso de ser recogido.',
      type: 'info',
      timeout: 9000
    },
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    },
    notificacionBadPosition: {
      title: 'Información',
      message: 'El servicio cuenta con problemas en la geolocalización.',
      type: 'info',
      timeout: 9000
    }
  },
  watch: {
    comentario: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      var vm = this;
      var inf = {
        comentarioCalificacion: vm.comentario
        /* vm.$http.put(`hhttps://evocloud-guepardos.appspot.com/api/servicios/${vm.servicio.id}`, inf)
            .then(data => {
              vm.servicio = data.body
            }) */
      };
    }, 3000)
  },
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_5_vue_star_rating___default.a
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'servicio',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      GET_SERVICE_URL: 'https://mensajeria.guepardos.co/api/v2/services/',
      Url_Mensajeros: 'https://mensajeria.guepardos.co/api/v2/messengersPositions',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 13,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajeros: [],
      servicios: [],
      user: {}
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    http.get('servicesUser/' + this.$route.params.id).then(function (res) {
      _this.servicios = res.data;
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(_this.servicios) === 0) {
        _this.dibujarDireccion();
      } else {
        _this.dibujarServicios();
        _this.dibujarMensajeros();
      }
    });
    this.interval = setInterval(function () {
      var _this2 = this;

      http.get('servicesUser/' + this.$route.params.id).then(function (res) {
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(_this2.servicios) === 0) {
          _this2.dibujarDireccion();
        } else {
          _this2.dibujarServicios();
          _this2.dibujarMensajeros();
        }
      });
    }.bind(this), 10000);
  },
  mounted: function mounted() {
    var _this3 = this;

    var vm = this;
    __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__["loaded"].then(function () {
      _this3.$refs.myMapService.$mapCreated.then(function () {
        var src = 'http://storage.googleapis.com/gpds-geo-zonas/AreaMetroMensajeriaMapa.kml';
        var kmlLayer = new google.maps.KmlLayer(src, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: vm.$refs.myMapService.$mapObject
        });
      });
    });
  },

  methods: {
    dibujarServicios: function dibujarServicios() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(this.servicios, function (element) {
        _this4.markers.push({
          position: {
            lat: parseFloat(element.geoR.lat),
            lng: parseFloat(element.geoR.lng)
          },
          infoText: element.descripcion + ' - ' + element.recogida,
          icon: __webpack_require__(30)
        });
        _this4.dibujarEntregas(element.fechaHoraEntregas, element.recogida, element.mensajero.nombre);
      });
    },
    dibujarEntregas: function dibujarEntregas(entregas, servicio, mensajero) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(entregas, function (entrega, index) {
        _this5.markers.push({
          position: {
            lat: entrega.coordenadas.latitude,
            lng: entrega.coordenadas.longitude
          },
          infoText: 'Entrega ' + (index + 1) + ' - servicio: ' + servicio + ' - mensajero: ' + mensajero,
          icon: __webpack_require__(15)
        });
      });
    },
    dibujarMensajeros: function dibujarMensajeros() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(this.servicios, function (element) {
        _this6.mensajeros.push({
          position: {
            lat: parseFloat(element.ultimaPosicion[0].point.lat),
            lng: parseFloat(element.ultimaPosicion[0].point.lng)
          },
          infoText: element.mensajero.nombre + ' - Placa: ' + element.mensajero.placa + ' - Celular: ' + element.mensajero.celular,
          icon: __webpack_require__(19)
        });
      });
    },
    dibujarDireccion: function dibujarDireccion() {
      var _this7 = this;

      http.get('userData/' + this.$route.params.id).then(function (res) {
        _this7.user = res.data;
        _this7.markers.push({
          position: {
            lat: parseFloat(_this7.user.geo.lat),
            lng: parseFloat(_this7.user.geo.lng)
          },
          infoText: 'Mi Direcci\xF3n',
          icon: __webpack_require__(30)
        });
        _this7.center = {
          lat: parseFloat(_this7.user.geo.lat),
          lng: parseFloat(_this7.user.geo.lng)
        };
        _this7.zoom = 14;
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapa',
  data: function data() {
    return {
      nav: {
        edge: 'right'
      },
      URL: 'https://mensajeros.guepardos.co/api/v2',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajero: {},
      puntos: []
    };
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      var vm = this;
      vm.$http.get(vm.URL + '/userData/' + vm.$route.params.id).then(function (data) {
        vm.usuario = data.body;
        if (vm.usuario.geo) {
          vm.dibujarPuntos();
          vm.dibujarCirculos();
        } else {
          console.log('no tiene puntos de localizacion');
        }
      });
    },
    dibujarPuntos: function dibujarPuntos() {
      var vm = this;
      vm.markers = [];
      vm.center = new google.maps.LatLng(parseFloat(vm.usuario.geo.lat), parseFloat(vm.usuario.geo.lng));
      vm.markers.push({
        position: {
          lat: parseFloat(vm.usuario.geo.lat),
          lng: parseFloat(vm.usuario.geo.lng)
        },
        infoText: '<i class="fa fa-user-circle-o" aria-hidden="true"></i> ' + vm.usuario.nombre + ' <br> <i class="fa fa-home" aria-hidden="true"></i> ' + vm.usuario.direccion,
        icon: __webpack_require__(204)
      });
    },
    dibujarCirculos: function dibujarCirculos() {
      var vm = this;
      vm.$refs.myMap.resizePreserveCenter();
      var center = { lat: vm.usuario.geo.lat, lng: vm.usuario.geo.lng };
      vm.$http.get('https://mensajeros.guepardos.co/api/v2/franchises').then(function (response) {
        var cityCircle1 = new google.maps.Circle({
          strokeColor: '#02C3BD',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#02C3BD',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio1 * 1000
        });
        var cityCircle2 = new google.maps.Circle({
          strokeColor: '#00B9AE',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#00B9AE',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio2 * 1000
        });
        var cityCircle3 = new google.maps.Circle({
          strokeColor: '#009F93',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#009F93',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio3 * 1000
        });
        var cityCircle4 = new google.maps.Circle({
          strokeColor: '#037171',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#037171',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio4 * 1000
        });
        var cityCircle5 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio5 * 1000
        });
        var cityCircle6 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio6 * 1000
        });
        var cityCircle7 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio7 * 1000
        });
        var cityCircle8 = new google.maps.Circle({
          strokeColor: '#03312E',
          strokeOpacity: 1,
          strokeWeight: 2,
          fillColor: '#03312E',
          fillOpacity: 0.0,
          map: vm.$refs.myMap.$mapObject,
          center: center,
          radius: response.body[0].radio8 * 1000
        });
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  },
  notifications: {
    notificacionMensajero: {
      title: 'Información',
      message: 'El mensajero tiene problemas de geolocalización.',
      type: 'info',
      timeout: 9000
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAA2CAMAAAAMJmLIAAAAq1BMVEUAAADqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTrqpTr8/PzqpToAAAA/Pz9+fn7X1tbr6+vW0MnSv6bkrVfg39/oqETy8vLUzcXv7+/Rx7qenp7at4XhsWfWvJjYuY3mqk6Ojo7es3L39fXj4+Ld3d3PycK9vb3ay7nSw7HdtHtfX19PT08vLy8gICAQEBDm5uXNzc2tra1ubm6b7A5qAAAAEHRSTlMAgEDvYBCf3yDPv3Awj1Cv0rlsyAAAAa1JREFUOMu9k9d2gzAQRCnGYFzCBtPBmOYa97T//7IsEliADI+ZFw7nntnVrFbCf0iRxFIL7QWT3qCWPuowTYfg4jqWb1luXsBEasKFHCSRbVDZVlbAlMEReDFlVKsohfHTCZ6zM1qytrVbkT2nSShOgfYewznE//WSaH2gOCrUEs4g+TJQ5nulNe2dwYhYI6OiD9P8RPxBaxcTpHLq13SJcR74ocFy0LBwFjJafYjOWFoC12jQDVb+ro4NoiCCU1MiamXUatNNHXkPc5zi6UmvP3jku828nb5rNN8q6iBVIFkxalxZ7aycpe75zUT3ehz2RSbXFxP6a5rlDA+mad7ssnBALlHeopmTnQBZMBHcFQd3MVrp/QbHsEsdj1iJ2Tu23aGTYpx6OSBwm733sQeqIlSaAsA29kPq86MkAGjstAooL3dPVuTmKdl4BjFzVzMKanNbmKbfLHde2qRFxe4TbFkVoSOdt/JmZuU781b+2BoPMTPLOmCWXlJFJlAVXmtM6LyHzrj5c6H4ws0tmPdSDemih9HSSj8VYSL0S8JBDQimQ1SVhqiuDNFO2j9bBDuNJ2fs6AAAAABJRU5ErkJggg=="

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAKJSURBVHjaVJLNa1xlGMV/7/s8996ZzMetaevYzkJKpNDYIl2kX4gLoVAEF0IEwZ3iRhH8DxS6K10KFlG7q5suuih0XQi0pWQRaxdpmwlYzTC2oJPOTO698364CBni2R2eAwee8zMxRmba6gurjxxPevD3JjjHNLOYo/No960P+ejj2+yT3W9+X1n5dHNtjVf9PkynoIqqMhgMeLq+fmnz1xvL+/Nmr7m6cu3H7d7GuXbCKRGhrAkxRtTv3oM1/DuaPGweX7jT+ubrb2fN92/dXO73+8fb7faptNHAGIOIYK3FGIMxBlUlz/OlwWCw+Oz6L58DyHfvLH0mq78tv15OLqV1IZQjjJ+i04Sk8AgGCRHnCuqJkI0ni/MvJ3VbDw/UP3/+s/ceEYGdHbz3JKJQTiEEfIjIXB3BszMeY62gqhd7vd66ytYGXeco6nOApT40UHmmtQJVBefBj1CfoTT4pwmTUHBs9TEWYzAiOOeYzWYMSZZRliXGGGII4D0AzjnSNMWmKTpqWEIARpHUQ5BA5StqTqlpAj4ChmAsNoG2Zkwrx6SZYJsHDjAej1HV2WdrrRauqgghQJIQQ8BaC8bszlpVzOU5Wh5bZGscaI8drigpYkmOoK4OqlAFnKkRs0hUT1U5srnX+PO9JWx24kTa6XSuDofDbWMMrVYL7xyIQIyEEEiaTdIsA6AoChqdzkq32z08I+zxD9e+lz/++qr7agKAHGpRVRUpFu89k50ClRovFt+8deT9d7/MF072dY/Tty9cuFzYh06e9j4JIXRcjLuURUNZluR5/rJ26MjGwbNnLrNwsv8/tve0fe/uuXLt0b3DTzYBiJkQ3sgZnjn9xfz5D37an/1vAPrEI7LrjyxoAAAAAElFTkSuQmCC"

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 69,
	"./af.js": 69,
	"./ar": 76,
	"./ar-dz": 70,
	"./ar-dz.js": 70,
	"./ar-kw": 71,
	"./ar-kw.js": 71,
	"./ar-ly": 72,
	"./ar-ly.js": 72,
	"./ar-ma": 73,
	"./ar-ma.js": 73,
	"./ar-sa": 74,
	"./ar-sa.js": 74,
	"./ar-tn": 75,
	"./ar-tn.js": 75,
	"./ar.js": 76,
	"./az": 77,
	"./az.js": 77,
	"./be": 78,
	"./be.js": 78,
	"./bg": 79,
	"./bg.js": 79,
	"./bm": 80,
	"./bm.js": 80,
	"./bn": 82,
	"./bn-bd": 81,
	"./bn-bd.js": 81,
	"./bn.js": 82,
	"./bo": 83,
	"./bo.js": 83,
	"./br": 84,
	"./br.js": 84,
	"./bs": 85,
	"./bs.js": 85,
	"./ca": 86,
	"./ca.js": 86,
	"./cs": 87,
	"./cs.js": 87,
	"./cv": 88,
	"./cv.js": 88,
	"./cy": 89,
	"./cy.js": 89,
	"./da": 90,
	"./da.js": 90,
	"./de": 93,
	"./de-at": 91,
	"./de-at.js": 91,
	"./de-ch": 92,
	"./de-ch.js": 92,
	"./de.js": 93,
	"./dv": 94,
	"./dv.js": 94,
	"./el": 95,
	"./el.js": 95,
	"./en-au": 96,
	"./en-au.js": 96,
	"./en-ca": 97,
	"./en-ca.js": 97,
	"./en-gb": 98,
	"./en-gb.js": 98,
	"./en-ie": 99,
	"./en-ie.js": 99,
	"./en-il": 100,
	"./en-il.js": 100,
	"./en-in": 101,
	"./en-in.js": 101,
	"./en-nz": 102,
	"./en-nz.js": 102,
	"./en-sg": 103,
	"./en-sg.js": 103,
	"./eo": 104,
	"./eo.js": 104,
	"./es": 108,
	"./es-do": 105,
	"./es-do.js": 105,
	"./es-mx": 106,
	"./es-mx.js": 106,
	"./es-us": 107,
	"./es-us.js": 107,
	"./es.js": 108,
	"./et": 109,
	"./et.js": 109,
	"./eu": 110,
	"./eu.js": 110,
	"./fa": 111,
	"./fa.js": 111,
	"./fi": 112,
	"./fi.js": 112,
	"./fil": 113,
	"./fil.js": 113,
	"./fo": 114,
	"./fo.js": 114,
	"./fr": 117,
	"./fr-ca": 115,
	"./fr-ca.js": 115,
	"./fr-ch": 116,
	"./fr-ch.js": 116,
	"./fr.js": 117,
	"./fy": 118,
	"./fy.js": 118,
	"./ga": 119,
	"./ga.js": 119,
	"./gd": 120,
	"./gd.js": 120,
	"./gl": 121,
	"./gl.js": 121,
	"./gom-deva": 122,
	"./gom-deva.js": 122,
	"./gom-latn": 123,
	"./gom-latn.js": 123,
	"./gu": 124,
	"./gu.js": 124,
	"./he": 125,
	"./he.js": 125,
	"./hi": 126,
	"./hi.js": 126,
	"./hr": 127,
	"./hr.js": 127,
	"./hu": 128,
	"./hu.js": 128,
	"./hy-am": 129,
	"./hy-am.js": 129,
	"./id": 130,
	"./id.js": 130,
	"./is": 131,
	"./is.js": 131,
	"./it": 133,
	"./it-ch": 132,
	"./it-ch.js": 132,
	"./it.js": 133,
	"./ja": 134,
	"./ja.js": 134,
	"./jv": 135,
	"./jv.js": 135,
	"./ka": 136,
	"./ka.js": 136,
	"./kk": 137,
	"./kk.js": 137,
	"./km": 138,
	"./km.js": 138,
	"./kn": 139,
	"./kn.js": 139,
	"./ko": 140,
	"./ko.js": 140,
	"./ku": 141,
	"./ku.js": 141,
	"./ky": 142,
	"./ky.js": 142,
	"./lb": 143,
	"./lb.js": 143,
	"./lo": 144,
	"./lo.js": 144,
	"./lt": 145,
	"./lt.js": 145,
	"./lv": 146,
	"./lv.js": 146,
	"./me": 147,
	"./me.js": 147,
	"./mi": 148,
	"./mi.js": 148,
	"./mk": 149,
	"./mk.js": 149,
	"./ml": 150,
	"./ml.js": 150,
	"./mn": 151,
	"./mn.js": 151,
	"./mr": 152,
	"./mr.js": 152,
	"./ms": 154,
	"./ms-my": 153,
	"./ms-my.js": 153,
	"./ms.js": 154,
	"./mt": 155,
	"./mt.js": 155,
	"./my": 156,
	"./my.js": 156,
	"./nb": 157,
	"./nb.js": 157,
	"./ne": 158,
	"./ne.js": 158,
	"./nl": 160,
	"./nl-be": 159,
	"./nl-be.js": 159,
	"./nl.js": 160,
	"./nn": 161,
	"./nn.js": 161,
	"./oc-lnc": 162,
	"./oc-lnc.js": 162,
	"./pa-in": 163,
	"./pa-in.js": 163,
	"./pl": 164,
	"./pl.js": 164,
	"./pt": 166,
	"./pt-br": 165,
	"./pt-br.js": 165,
	"./pt.js": 166,
	"./ro": 167,
	"./ro.js": 167,
	"./ru": 168,
	"./ru.js": 168,
	"./sd": 169,
	"./sd.js": 169,
	"./se": 170,
	"./se.js": 170,
	"./si": 171,
	"./si.js": 171,
	"./sk": 172,
	"./sk.js": 172,
	"./sl": 173,
	"./sl.js": 173,
	"./sq": 174,
	"./sq.js": 174,
	"./sr": 176,
	"./sr-cyrl": 175,
	"./sr-cyrl.js": 175,
	"./sr.js": 176,
	"./ss": 177,
	"./ss.js": 177,
	"./sv": 178,
	"./sv.js": 178,
	"./sw": 179,
	"./sw.js": 179,
	"./ta": 180,
	"./ta.js": 180,
	"./te": 181,
	"./te.js": 181,
	"./tet": 182,
	"./tet.js": 182,
	"./tg": 183,
	"./tg.js": 183,
	"./th": 184,
	"./th.js": 184,
	"./tk": 185,
	"./tk.js": 185,
	"./tl-ph": 186,
	"./tl-ph.js": 186,
	"./tlh": 187,
	"./tlh.js": 187,
	"./tr": 188,
	"./tr.js": 188,
	"./tzl": 189,
	"./tzl.js": 189,
	"./tzm": 191,
	"./tzm-latn": 190,
	"./tzm-latn.js": 190,
	"./tzm.js": 191,
	"./ug-cn": 192,
	"./ug-cn.js": 192,
	"./uk": 193,
	"./uk.js": 193,
	"./ur": 194,
	"./ur.js": 194,
	"./uz": 196,
	"./uz-latn": 195,
	"./uz-latn.js": 195,
	"./uz.js": 196,
	"./vi": 197,
	"./vi.js": 197,
	"./x-pseudo": 198,
	"./x-pseudo.js": 198,
	"./yo": 199,
	"./yo.js": 199,
	"./zh-cn": 200,
	"./zh-cn.js": 200,
	"./zh-hk": 201,
	"./zh-hk.js": 201,
	"./zh-mo": 202,
	"./zh-mo.js": 202,
	"./zh-tw": 203,
	"./zh-tw.js": 203
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 310;

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loader.edf4241.gif";

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAcVQTFRFAAAAAAACoB0ToR0SIxuKIhmEIhmBIRh7IRh3IxuIIhmBHxZyHRRtHRZrHRRpHRRoHxZzIhmDIxqEIBd3HRVsHRVrJRWAIRd6HRZwGxRmJB1+GxWBHxd1HRRpHBRpIBZ0JBWBIhd6IxiDGBRlGBNoFhRsEhRzFhRuHxZwFBNrCxNyCRR4ARV8BhR4FBRrIhl/EhNuAxJ6/y8k8C4r4iwr4Cwu4ywrAhJ6ERNuIxmGFBNqAxJ54ywr3CwsySgsxCcs2iot5SwrFBNrHhZzIhuFIhmCHhZtDBNx/y4o2youxSct2yot/y4jCxNxHRZtIhmAIhmAFhNpCRR57i4q7S4qChR5IRh5FhRvARJ84SsrxSct5SwsCBR5GhduIhh44Cwv6S4wGxZ1xictBxJ6IRh4GBNpBhR57C4qCxNx2iouxCct2yosIRmCJRmGHRZz3CosxScsExNrIhh/EhNt/y8q8S4r5y0s5i0sERNtIxl/FBRqBxR5CBaBBRaBDRNyGhdvGRdwFxNoIBd6JRWBHhd1JRWGIxuFIxiGIxmJIhmGIxuJGxRkGxRjGhRkGRRlGRRkGxRlwycswCctwSctxSctGxRm////l/G6qQAAAIt0Uk5TAAAAAAELHy04ARVlqtft9WUVGXvt7QE8v/kBATng4DkBPBn306eHp7/fbhkCGd8VviYCOHypfCa+AeAmD3bn/XYP4GUBC6ptAnb4dgJuqgsf0hk4OBktpwJ9/X0Cpy2pqYf9Ai3SGThtdvh2CwFldv3gFb4COHx8vhXfGQICbqen0zwBOQEZGQELAe+l1WUAAAABYktHRJaRaSs5AAAACXBIWXMAAA7DAAAOwwHHb6hkAAABuklEQVQoz2NgIBawsLKxc3Cws7FyYpFk5OLm4eXj5+fj5REQxJAVEhbp7unp6QYTosJCKJJi4hKS3UhAUkJcCiErLSPbjQbk5BXg0oqyPRDB3r6+XgirR04cJqskAZFTVlFVU1NXUYao0FCCulkYbG+/ppa2DhOzjq6WXj/YfmGItL4oWNbA0MjYxNTUzNjI3AIsL6oPkrUUmAAy2craxtbOfuJEezsHR2snkPkTnF2A0q5uIHcpu3t4ek2aNHnypEle3j6+yiDX+fkDpQN4QYERGBRsB5QEgUl2IaEqIGneAKB0GB9Qujc8IjIKJh0VHRMLkuaLA0pz8AOZfWpM8RMnQ8GUBIbEqUBBfg4kaVPs0piGJ0UnQwxPgTstNS0dyWnaCKe5+oE9luGRmQXxWFa2B9RjOUDp3DxosDjm2xVMmVJgl+9oXYgIFoYiSKAWG5aUliUklBuXmFdAArUSEujQKKnSqq5hYKitrqtCiRKkCK1PTGxoRItQBgZxWHLonjoVyuiRbYKnluYWOYzE1NKMnBQ1UJOihngrSlptQ07IIsLtGCldUMAPkg38sGQDIOiAZqLOLqLzHQCbB/UcH6GV2gAAAGJ0RVh0Y29tbWVudABib3JkZXIgYnM6MCBiYzojMDAwMDAwIHBzOjAgcGM6I2VlZWVlZSBlczowIGVjOiMwMDAwMDAgY2s6NTAwZDAyYTRmMWYxZDc0OTczNDBjYzU4Njg5NmJmMTGEn9AAAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTAxLTE3VDE3OjA2OjE2KzAwOjAwLJ9obAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wMS0xN1QxNzowNjoxNiswMDowMF3C0NAAAAAASUVORK5CYII="

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAYAAAD6xArmAAADYUlEQVR42q2X20tUURTGN13GpLw0TpL3NLKbFyyo8DI2Opr1UBmlYdpF7CKa5JhjzSRjckoqIbTETK1MISjCkiioh6Qk0kqYiB76G3rsIYRcnW/LGZ05e67Ogg/2nLPWbzZr7b32Poy5MYstPqO5IWTsSg373VHFZjvKGXHJYzzDO/gwX02SouIsdZppQIYao+mVlEFTfcX0/fFBLozxDO/gA1/EeISaWnWGthNsZrA+kqYH99HPJ4c9Cj7wRQxihdAWa2y2VMn+PW9N9Qp0FWIQC4YT1GYL09mq2Z+nlhT6MXIoICEWDLAc4ObzK971ntE48hiowACLQ5uk5CRUeuJOPtmHDjip/1I2Saez6Ebtdq7uCzvpdadR5acIDLDAZObGVSN950LJ/mi/SqX6RJL/WyXbqUyhP4RZg8mwJl+0beYVdtXRwiTSZ0bT1P0SmuwrodFr+bQhPoy04Roa7y4SxoAFJlPS8G1gr0oK+IsMVp5Zq7Zy8PsuozBGSQfDIsei9wT+2j8PNpVv8gj+3GvkG8cBFqnMkEhpKRE0bN1FA+YdZCrbyHNctWcdTd4rEsY4gTF9OLqqzJCgKlxlcZLQV9H47Zw5sO0k+4u9j39y1ZHdCZSboaOJuwX05qaekmNW0uowDY1dzxX6Q2CBySx1y+3DTTEewZ96CvnvUSmHzzpOF0pvO/OFMQ8boghMZrJoq29VzKXDVaV5sZSTFkUfuvSOZw/M2zg8PSVcGAMWmHO9Qt7jz6zrVU7HjAlUkLXGCQx11qZzuKs/GGDNt8sW7UV3s/ZVKBqfrcxy6nDYLch1oGDklu84VZO3rDVgmaCq/kIRg1gwxM2+PuRjT81Sv8GIQazbowlNGseMqJDuxAt2nM04NXiRmc2RDSgCiuFLwZACxPh0UmOBo0d7A8OHbwZfzWSLS5Uq2OxYe5q8hvOEenl1C8EHvswfw4UERXEHxjv4MH8NxVBmjVwulDJbrwVzZ1hCyKMrGM88Li+vubZqs1F1VzDfDPI7thhTGpQCVTWaQA0FWpgOjAMqmuiiqGwYRxrcXQD9tXb5wofVgdWAMQuWXT675BdaKlojxkEDmxsj+rEhIIyDBkZOlU+FoOVXMf4dgqtTsA3HjvDoWXQBa5fZoaCDcVN33NZ9sP9Ti89RLZ8kgwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(339),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(348),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(340),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(346),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(349),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(341),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(347),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(350),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(343),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "myMapService",
    staticClass: "sinNav",
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": _vm.zoom
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.mensajeros), function(m, i) {
    return _c('gmap-marker', {
      key: i + 'mensajero',
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "marker"
  }, [_c('ul', {
    staticClass: "rigth"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "side-nav",
      rawName: "v-side-nav:demo",
      value: (_vm.nav),
      expression: "nav",
      arg: "demo"
    }],
    staticClass: "sizeA stroke",
    attrs: {
      "href": "#!"
    }
  }, [_c('i', {
    staticClass: "material-icons dp48 fa-3x"
  }, [_vm._v("apps")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Menu")])])])])]), _vm._v(" "), _c('div', [_c('v-side-nav', {
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("Cliente")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cliente),
      expression: "cliente"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cliente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cliente = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.mostrarClientes) ? _c('transition-group', {
    staticClass: "Results",
    attrs: {
      "name": "fade",
      "tag": "ul"
    }
  }, _vm._l((_vm.clientes), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.seleccionarCliente(item)
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(item.nombre))]), _c('br')])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("Fecha Inicio")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Fecha Fin")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Mensajeros")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "select",
      "id": "select",
      "select-text": "Seleccionar Mensajero",
      "preselect-first": true,
      "items": _vm.messengers
    },
    model: {
      value: (_vm.messengerSelected),
      callback: function($$v) {
        _vm.messengerSelected = $$v
      },
      expression: "messengerSelected"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Entregas")]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minEntries),
      expression: "minEntries"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.minEntries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minEntries = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "for": "regreso"
    }
  }, [_vm._v("Ida y Regreso")]), _vm._v(" "), _c('div', {
    staticClass: "switch"
  }, [_c('label', [_vm._v("\n            No\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regreso),
      expression: "regreso"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.regreso) ? _vm._i(_vm.regreso, null) > -1 : (_vm.regreso)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.regreso,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.regreso = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.regreso = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.regreso = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lever"
  }), _vm._v("\n            Si\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-info",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.generarReporte
    }
  }, [_vm._v("Generar")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.mostrarLoader) ? _c('div', {
    staticClass: "center-align"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": __webpack_require__(314)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mostrarTabla) ? _c('div', {
    staticClass: "row"
  }, [_c('p', [_c('strong', [_vm._v("Total Servicios: ")]), _vm._v(_vm._s(_vm.muestras.length))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Eficiencia (media): ")]), _vm._v(_vm._s(parseFloat(_vm.grandTotal).toFixed(2)))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Desviación Estandar: ")]), _vm._v(_vm._s(parseFloat(_vm.devEst).toFixed(2)))]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "center-align"
  }, [_vm._v("Optimo")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Deficiente")]), _vm._v(" "), _c('th', {
    staticClass: "center-align"
  }, [_vm._v("Ineficiente")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.optimo)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.normal)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.ineficiente)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.optimoEntrega)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.normalEntrega)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("$ " + _vm._s(_vm.formatNumber.new(_vm.ineficienteEntrega)))]), _vm._v(" "), _c('td', {
    staticClass: "center-align"
  }, [_vm._v("-")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosOptimos), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosNormales), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosIneficientes), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col s3"
  }, _vm._l((_vm.serviciosDeficientes), function(item, index) {
    return (index <= 15) ? _c('a', {
      key: item.id,
      attrs: {
        "href": ("https://my.guepardos.co/tracking/" + (item.id) + "?nav=false"),
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(_vm.lastFive(item.id)) + " "), _c('br')]) : _vm._e()
  }), 0)])]) : _vm._e()], 1)]), _vm._v(" "), _c('gmap-map', {
    ref: "mapEficiencia",
    staticClass: "sinNav",
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": _vm.zoom
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo",
      "position": "bottom left"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "myMap",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": 14
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo",
      "position": "bottom left"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "marker"
  }, [_c('ul', {
    staticClass: "rigth"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "side-nav",
      rawName: "v-side-nav:demo",
      value: (_vm.nav),
      expression: "nav",
      arg: "demo"
    }],
    staticClass: "sizeA stroke",
    attrs: {
      "href": "#!"
    }
  }, [_c('i', {
    staticClass: "material-icons dp48 fa-3x"
  }, [_vm._v("apps")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Menu")])])])])]), _vm._v(" "), _c('div', [_c('v-side-nav', {
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("Antiguedad "), _c('small', [_vm._v("Trimeste no. " + _vm._s(_vm.trimestre))])]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trimestre),
      expression: "trimestre"
    }],
    attrs: {
      "type": "range",
      "id": "test5",
      "min": "0",
      "max": _vm.rangoTrimestres
    },
    domProps: {
      "value": (_vm.trimestre)
    },
    on: {
      "__r": function($event) {
        _vm.trimestre = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Último servicio "), _c('small', [_vm._v("Trimeste no. " + _vm._s(_vm.trimestreServicio))])]), _vm._v(" "), _c('p', {
    staticClass: "range-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trimestreServicio),
      expression: "trimestreServicio"
    }],
    attrs: {
      "type": "range",
      "id": "test5",
      "min": "0",
      "max": _vm.rangoTrimestres,
      "disabled": _vm.todasFechas
    },
    domProps: {
      "value": (_vm.trimestreServicio)
    },
    on: {
      "__r": function($event) {
        _vm.trimestreServicio = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "zonas"
    }
  }, [_vm._v("Zonas")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "selectedLabel": "seleccionado",
      "selectLabel": "Seleccionar",
      "options": _vm.itemsZonas,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Seleccionar Zona",
      "label": "name",
      "track-by": "name",
      "preselect-first": false
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "custom__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.name) + " ")]), _c('span', {
          staticClass: "custom__remove",
          staticStyle: {
            "font-size": "9px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])]), _c('br')]
      }
    }]),
    model: {
      value: (_vm.zonasSelected),
      callback: function($$v) {
        _vm.zonasSelected = $$v
      },
      expression: "zonasSelected"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Mensaje predefinido")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "select",
      "id": "select",
      "select-text": "Seleccionar Mensaje",
      "preselect-first": true,
      "items": _vm.itemsPredefinido
    },
    model: {
      value: (_vm.mensajePredefinido),
      callback: function($$v) {
        _vm.mensajePredefinido = $$v
      },
      expression: "mensajePredefinido"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ta"
    }
  }, [_vm._v("Mensaje")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "border": "1px solid #26a69a"
    },
    attrs: {
      "rows": "10",
      "name": "ta",
      "id": "ta"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": _vm.countdown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "right-align"
  }, [_vm._v(_vm._s(_vm.remainingCount))]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "prueba"
    }
  }, [_vm._v("Es una prueba")]), _vm._v(" "), _c('div', {
    staticClass: "switch"
  }, [_c('label', [_vm._v("\n              No\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prueba),
      expression: "prueba"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.prueba) ? _vm._i(_vm.prueba, null) > -1 : (_vm.prueba)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prueba,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.prueba = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.prueba = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.prueba = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lever"
  }), _vm._v("\n              Si\n            ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "celular"
    }
  }, [_vm._v("# celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.celular),
      expression: "celular"
    }],
    attrs: {
      "name": "celular",
      "type": "text",
      "id": "celular"
    },
    domProps: {
      "value": (_vm.celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.celular = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-info",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.examinarUsuarios
    }
  }, [_vm._v("Enviar")])], 1)]), _vm._v(" "), _c('gmap-map', {
    ref: "myMapService",
    staticClass: "sinNav",
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": _vm.zoom
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.mensajeros), function(m, i) {
    return _c('gmap-marker', {
      key: i + 'mensajero',
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo",
      "position": "bottom left"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "myMap",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": 14
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('vue-progress-bar')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "myMap",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": 14
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mostrarNav) ? _c('v-nav', {
    attrs: {
      "nav-class": "purple darken-4"
    }
  }, [_c('a', {
    staticClass: "brand-logo",
    attrs: {
      "slot": "logo",
      "href": "https://pedidos.guepardos.co"
    },
    slot: "logo"
  }, [_c('img', {
    staticClass: "responsive-img",
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "src": __webpack_require__(49),
      "width": "55"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "left hide-on-small-only"
  }, [_c('li', [_c('a', {
    staticClass: "hide-on-small-only",
    staticStyle: {
      "padding-left": "75px",
      "font-size": "29px"
    },
    attrs: {
      "href": "https://pedidos.guepardos.co"
    }
  }, [_vm._v("Guepardos")])])]), _vm._v(" "), _c('ul', {
    staticClass: "right"
  }, [_c('li', [(_vm.mostrarNav) ? _c('a', {
    directives: [{
      name: "side-nav",
      rawName: "v-side-nav:demo",
      value: (_vm.nav),
      expression: "nav",
      arg: "demo"
    }],
    attrs: {
      "href": "#!"
    }
  }, [_c('i', {
    staticClass: "material-icons dp48"
  }, [_vm._v("apps")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.mostrarNav) ? _c('div', {
    staticClass: "marker"
  }, [_c('ul', {
    staticClass: "rigth"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "side-nav",
      rawName: "v-side-nav:demo",
      value: (_vm.nav),
      expression: "nav",
      arg: "demo"
    }],
    staticClass: "sizeA stroke",
    attrs: {
      "href": "#!"
    }
  }, [_c('i', {
    staticClass: "material-icons dp48 fa-3x"
  }, [_vm._v("apps")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "-30px"
    }
  }, [_vm._v("Detalle Servicio")])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-side-nav', {
    attrs: {
      "id": "demo"
    }
  }, [_c('h5', {
    staticClass: "center-align"
  }, [_vm._v("¡Detalles del Servicio!")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "collection"
  }, [_c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Estado: ")]), _vm._v(" " + _vm._s(_vm.estado))]), _vm._v(" "), (_vm.servicio.estadoServicio === 3) ? _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_vm._v("Calificación: ")]), _c('star-rating', {
    attrs: {
      "star-size": 20
    },
    on: {
      "rating-selected": _vm.setRating
    },
    model: {
      value: (_vm.rating),
      callback: function($$v) {
        _vm.rating = $$v
      },
      expression: "rating"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showComment && _vm.servicio.estadoServicio === 3) ? _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_vm._v("Comentario:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comentario),
      expression: "comentario"
    }],
    attrs: {
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.comentario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comentario = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" ID: ")]), _vm._v(" " + _vm._s(_vm.id))]), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nombre: ")]), _vm._v(" " + _vm._s(_vm.servicio.nombre))]), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Recogida: ")]), _vm._v(" " + _vm._s(_vm.servicio.recogida))]), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-retweet",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ida y Regreso: ")]), _vm._v(" "), (_vm.servicio.idaVuelta) ? _c('span', [_vm._v("Si")]) : _vm._e(), _vm._v(" "), (!_vm.servicio.idaVuelta) ? _c('span', [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Descripción: ")]), _vm._v(" " + _vm._s(_vm.servicio.descripcion))]), _vm._v(" "), (!_vm.isAdmin) ? _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distancia: ")]), _vm._v(" " + _vm._s(_vm.distancia) + " Km")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.showDistancia) ? _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distancia Operador: ")]), _vm._v(" " + _vm._s(_vm.servicio.tarifa.distancias.operador) + " Km")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.showDistancia) ? _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distancia Usuario: ")]), _vm._v(" " + _vm._s(_vm.servicio.tarifa.distancias.usuario) + " Km")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.showDistancia) ? _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distancia Mensajero: ")]), _vm._v(" " + _vm._s(_vm.servicio.tarifa.distancias.mensajero) + " Km")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Valor: ")]), _vm._v("$ " + _vm._s(parseInt(_vm.servicio.valor)))]), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    staticClass: "collection-item",
    class: {
      'colorVerde': _vm.showKm
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Valor Km: ")]), _vm._v("$ " + _vm._s(parseInt(_vm.valorKm)))]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    staticClass: "collection-item",
    class: {
      'colorVerde': _vm.showRd
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Valor Radios: ")]), _vm._v("$ " + _vm._s(parseInt(_vm.valorRadios)))]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Tiempo: ")]), _vm._v(" " + _vm._s(_vm.tiempoServicio))]), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-motorcycle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mensajero: ")]), _vm._v(" " + _vm._s(_vm.mensajeroNombre) + " - " + _vm._s(_vm.mensajeroCelular))]), _vm._v(" "), _c('li', {
    staticClass: "collection-item"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Entregas: " + _vm._s(_vm.entregasSinRegresos))]), _vm._v(" "), (_vm.servicio.entrega == 'Multientrega') ? _c('ul', {
    staticClass: "collection"
  }, _vm._l((_vm.entregasDirecciones), function(item) {
    return _c('li', {
      key: item.index,
      staticClass: "collection-item",
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(item, item.index)
        }
      }
    }, [_vm._v(_vm._s(item.direccion))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.servicio.entrega != 'Multientrega') ? _c('ul', {
    staticClass: "collection"
  }, [_c('li', {
    staticClass: "collection-item"
  }, [_vm._v(_vm._s(_vm.servicio.entrega))])]) : _vm._e()])])])]), _vm._v(" "), _c('gmap-map', {
    ref: "myMap",
    class: {
      'conNav': _vm.conNav, 'sinNav': _vm.sinNav
    },
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": _vm.zoom
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.mensajeros), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.circles), function(c, i) {
    return _c('gmap-circle', {
      key: i + 'circle',
      attrs: {
        "center": c.center,
        "radius": c.radius,
        "options": {
          fillOpacity: 0.0,
          strokeColor: '#F26E64',
          fillColor: '#F26E64'
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo",
      "position": "bottom left"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-nav', {
    attrs: {
      "nav-class": "purple darken-4"
    }
  }, [_c('a', {
    staticClass: "brand-logo",
    attrs: {
      "slot": "logo",
      "href": "https://pedidos.guepardos.co/"
    },
    slot: "logo"
  }, [_c('img', {
    staticClass: "responsive-img",
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "src": __webpack_require__(49),
      "width": "55"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "left hide-on-small-only"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "padding-left": "75px",
      "font-size": "29px"
    },
    attrs: {
      "href": "https://pedidos.guepardos.co/"
    }
  }, [_vm._v("Guepardos")])])]), _vm._v(" "), _c('v-side-nav', {
    attrs: {
      "slot": "side-nav",
      "id": "side"
    },
    slot: "side-nav"
  })], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 card-content valign center"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": __webpack_require__(49),
      "width": "300"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col s12"
  }, [_c('h1', {
    staticClass: "center-align"
  }, [_vm._v("¡El servicio que intentas rastrear no se encuentra disponible!")])]), _vm._v(" "), _c('h3', {
    staticClass: "center-align"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://pedidos.guepardos.co/"
    }
  }, [_vm._v("Ir a Guepardos.co")])])])
}]}

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "myMap",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": 14
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

module.exports = [{"lng":-75.4590797,"lat":6.3850773},{"lng":-75.4607105,"lat":6.3853332},{"lng":-75.4627705,"lat":6.3853332},{"lng":-75.4658604,"lat":6.384992},{"lng":-75.4694653,"lat":6.3843096},{"lng":-75.4722977,"lat":6.3840537},{"lng":-75.4751301,"lat":6.383286},{"lng":-75.4780483,"lat":6.3823477},{"lng":-75.4807949,"lat":6.3822624},{"lng":-75.481739,"lat":6.3831154},{"lng":-75.4825115,"lat":6.3843949},{"lng":-75.482769,"lat":6.3855038},{"lng":-75.4826832,"lat":6.386442},{"lng":-75.4839706,"lat":6.3874656},{"lng":-75.4855156,"lat":6.3866979},{"lng":-75.4866314,"lat":6.3855038},{"lng":-75.4877472,"lat":6.384139},{"lng":-75.489378,"lat":6.3834566},{"lng":-75.4909229,"lat":6.3836272},{"lng":-75.4904938,"lat":6.3825183},{"lng":-75.4905796,"lat":6.3809829},{"lng":-75.4909229,"lat":6.3797887},{"lng":-75.492382,"lat":6.3796181},{"lng":-75.4940128,"lat":6.3796181},{"lng":-75.492897,"lat":6.3782534},{"lng":-75.4921246,"lat":6.3772298},{"lng":-75.4927254,"lat":6.3764621},{"lng":-75.4936695,"lat":6.3751826},{"lng":-75.4946995,"lat":6.3757797},{"lng":-75.4953003,"lat":6.3745855},{"lng":-75.4982185,"lat":6.3757797},{"lng":-75.500021,"lat":6.3746708},{"lng":-75.5021667,"lat":6.3734766},{"lng":-75.5031967,"lat":6.3726236},{"lng":-75.50457,"lat":6.3719412},{"lng":-75.5044842,"lat":6.3700645},{"lng":-75.5031967,"lat":6.3689556},{"lng":-75.5044842,"lat":6.3673349},{"lng":-75.5059433,"lat":6.3663113},{"lng":-75.5073166,"lat":6.3656289},{"lng":-75.5079174,"lat":6.3646906},{"lng":-75.5087757,"lat":6.3633257},{"lng":-75.5104065,"lat":6.3618756},{"lng":-75.5123806,"lat":6.3609373},{"lng":-75.5135822,"lat":6.3612785},{"lng":-75.5148697,"lat":6.3600843},{"lng":-75.5158138,"lat":6.360852},{"lng":-75.5163288,"lat":6.3592312},{"lng":-75.516758,"lat":6.3563309},{"lng":-75.5171871,"lat":6.3534306},{"lng":-75.5182171,"lat":6.3511274},{"lng":-75.5176163,"lat":6.3485683},{"lng":-75.5177021,"lat":6.346521},{"lng":-75.5201054,"lat":6.3456679},{"lng":-75.5219078,"lat":6.3440472},{"lng":-75.5235386,"lat":6.3432794},{"lng":-75.5254269,"lat":6.342341},{"lng":-75.5241394,"lat":6.3401231},{"lng":-75.5255988,"lat":6.3386736},{"lng":-75.5272293,"lat":6.3382464},{"lng":-75.5303192,"lat":6.3383317},{"lng":-75.5328083,"lat":6.3387582},{"lng":-75.5340958,"lat":6.3390141},{"lng":-75.5337524,"lat":6.340379},{"lng":-75.5326366,"lat":6.3415733},{"lng":-75.5325508,"lat":6.3427676},{"lng":-75.5336666,"lat":6.3439618},{"lng":-75.5338383,"lat":6.3452414},{"lng":-75.5351257,"lat":6.3464357},{"lng":-75.5368423,"lat":6.3479712},{"lng":-75.5374432,"lat":6.3492507},{"lng":-75.5384731,"lat":6.3490801},{"lng":-75.5383015,"lat":6.3468622},{"lng":-75.5387306,"lat":6.3454973},{"lng":-75.5392456,"lat":6.3464357},{"lng":-75.5404472,"lat":6.3469475},{"lng":-75.541563,"lat":6.3474593},{"lng":-75.542078,"lat":6.3489948},{"lng":-75.5428505,"lat":6.3477153},{"lng":-75.544138,"lat":6.3483124},{"lng":-75.5462837,"lat":6.3489095},{"lng":-75.548172,"lat":6.349592},{"lng":-75.5493736,"lat":6.3500185},{"lng":-75.5504036,"lat":6.3507862},{"lng":-75.5511761,"lat":6.3518099},{"lng":-75.5520344,"lat":6.3518099},{"lng":-75.5530643,"lat":6.3501038},{"lng":-75.5546093,"lat":6.3496773},{"lng":-75.5555534,"lat":6.3499332},{"lng":-75.5558109,"lat":6.3507862},{"lng":-75.5573559,"lat":6.3510421},{"lng":-75.558815,"lat":6.3511274},{"lng":-75.5592442,"lat":6.3496773},{"lng":-75.5606174,"lat":6.3501891},{"lng":-75.5606174,"lat":6.3515539},{"lng":-75.559845,"lat":6.3530041},{"lng":-75.5604458,"lat":6.3553073},{"lng":-75.5619049,"lat":6.3538571},{"lng":-75.5626774,"lat":6.3522364},{"lng":-75.5644798,"lat":6.3518099},{"lng":-75.5661106,"lat":6.3523217},{"lng":-75.5664539,"lat":6.3537718},{"lng":-75.5661964,"lat":6.356075},{"lng":-75.5668831,"lat":6.3572693},{"lng":-75.5690289,"lat":6.3573546},{"lng":-75.5710888,"lat":6.3566722},{"lng":-75.5725479,"lat":6.355222},{"lng":-75.5712605,"lat":6.3528335},{"lng":-75.5701447,"lat":6.3509568},{"lng":-75.5692005,"lat":6.3487389},{"lng":-75.5698872,"lat":6.3472887},{"lng":-75.5718613,"lat":6.347374},{"lng":-75.5736637,"lat":6.3477153},{"lng":-75.5749512,"lat":6.3468622},{"lng":-75.574522,"lat":6.3458386},{"lng":-75.5742645,"lat":6.3449002},{"lng":-75.5757236,"lat":6.3444737},{"lng":-75.5769253,"lat":6.3436206},{"lng":-75.5777836,"lat":6.341488},{"lng":-75.5773544,"lat":6.3393554},{"lng":-75.5718613,"lat":6.3391847},{"lng":-75.5711746,"lat":6.3379905},{"lng":-75.5722046,"lat":6.3368815},{"lng":-75.5740929,"lat":6.3364549},{"lng":-75.5764103,"lat":6.3358578},{"lng":-75.5746937,"lat":6.3344076},{"lng":-75.5726337,"lat":6.3334692},{"lng":-75.5687714,"lat":6.3319337},{"lng":-75.5667114,"lat":6.3317631},{"lng":-75.5659389,"lat":6.3305688},{"lng":-75.5655098,"lat":6.3286067},{"lng":-75.5661964,"lat":6.3280095},{"lng":-75.5683422,"lat":6.3269005},{"lng":-75.5700588,"lat":6.3263034},{"lng":-75.5704021,"lat":6.3246825},{"lng":-75.5697155,"lat":6.3229764},{"lng":-75.5691147,"lat":6.3216967},{"lng":-75.5685139,"lat":6.3205024},{"lng":-75.5673981,"lat":6.3210143},{"lng":-75.5661964,"lat":6.3205877},{"lng":-75.5673981,"lat":6.3191375},{"lng":-75.5681705,"lat":6.3162369},{"lng":-75.5702305,"lat":6.3160663},{"lng":-75.5705738,"lat":6.3147014},{"lng":-75.5728912,"lat":6.3142748},{"lng":-75.5746078,"lat":6.3147867},{"lng":-75.5776119,"lat":6.3153838},{"lng":-75.5805302,"lat":6.3163223},{"lng":-75.5849934,"lat":6.317346},{"lng":-75.5867958,"lat":6.3169194},{"lng":-75.5886841,"lat":6.3154692},{"lng":-75.5891991,"lat":6.3143601},{"lng":-75.5879116,"lat":6.3128245},{"lng":-75.58671,"lat":6.3117155},{"lng":-75.5873108,"lat":6.3104359},{"lng":-75.5862808,"lat":6.3094974},{"lng":-75.5859375,"lat":6.3070234},{"lng":-75.5849075,"lat":6.3052319},{"lng":-75.5837059,"lat":6.3041228},{"lng":-75.5845642,"lat":6.3026725},{"lng":-75.5869675,"lat":6.3025872},{"lng":-75.5885124,"lat":6.3029285},{"lng":-75.5890274,"lat":6.3015635},{"lng":-75.5877399,"lat":6.3000279},{"lng":-75.5866241,"lat":6.2980657},{"lng":-75.5863667,"lat":6.2964447},{"lng":-75.5876541,"lat":6.2949091},{"lng":-75.5885983,"lat":6.2941413},{"lng":-75.5896282,"lat":6.2952503},{"lng":-75.5909157,"lat":6.2961888},{"lng":-75.5923748,"lat":6.2961888},{"lng":-75.5941772,"lat":6.2967007},{"lng":-75.5950356,"lat":6.2972125},{"lng":-75.5964088,"lat":6.2967007},{"lng":-75.5977821,"lat":6.2957622},{"lng":-75.5975246,"lat":6.2949944},{"lng":-75.596838,"lat":6.2933734},{"lng":-75.5969238,"lat":6.2918378},{"lng":-75.5990696,"lat":6.2906434},{"lng":-75.6000996,"lat":6.289449},{"lng":-75.6013012,"lat":6.2883399},{"lng":-75.6031895,"lat":6.2882546},{"lng":-75.6043053,"lat":6.2892784},{"lng":-75.6053352,"lat":6.2914965},{"lng":-75.6062794,"lat":6.29107},{"lng":-75.6078243,"lat":6.2900462},{"lng":-75.6082535,"lat":6.2909847},{"lng":-75.6088543,"lat":6.2920084},{"lng":-75.6091976,"lat":6.2936294},{"lng":-75.6098843,"lat":6.2956769},{"lng":-75.6119442,"lat":6.2948238},{"lng":-75.6123734,"lat":6.2932881},{"lng":-75.6155491,"lat":6.2906434},{"lng":-75.6154633,"lat":6.2898756},{"lng":-75.6151199,"lat":6.2888518},{"lng":-75.6150341,"lat":6.2876574},{"lng":-75.613575,"lat":6.2862924},{"lng":-75.6124592,"lat":6.2870602},{"lng":-75.6108284,"lat":6.2876574},{"lng":-75.6103134,"lat":6.2868043},{"lng":-75.6102276,"lat":6.2854392},{"lng":-75.6097984,"lat":6.2841595},{"lng":-75.6091976,"lat":6.2828798},{"lng":-75.6102276,"lat":6.2827945},{"lng":-75.6121159,"lat":6.2827092},{"lng":-75.6134033,"lat":6.2831357},{"lng":-75.61409,"lat":6.2845008},{"lng":-75.6150341,"lat":6.2844155},{"lng":-75.6152058,"lat":6.2827945},{"lng":-75.6164932,"lat":6.2826238},{"lng":-75.6175232,"lat":6.2835623},{"lng":-75.6189823,"lat":6.2835623},{"lng":-75.6213856,"lat":6.2839889},{"lng":-75.6224155,"lat":6.2836476},{"lng":-75.624733,"lat":6.2828798},{"lng":-75.6269646,"lat":6.2824532},{"lng":-75.6291103,"lat":6.2819413},{"lng":-75.630827,"lat":6.282112},{"lng":-75.630827,"lat":6.2831357},{"lng":-75.6302261,"lat":6.2847567},{"lng":-75.6307411,"lat":6.2858658},{"lng":-75.633316,"lat":6.2844155},{"lng":-75.6347752,"lat":6.2829651},{"lng":-75.6367493,"lat":6.2820266},{"lng":-75.6375217,"lat":6.2827945},{"lng":-75.63941,"lat":6.2833064},{"lng":-75.6408691,"lat":6.2827092},{"lng":-75.6419849,"lat":6.2819413},{"lng":-75.643959,"lat":6.2822826},{"lng":-75.6448174,"lat":6.2810882},{"lng":-75.6432724,"lat":6.2792112},{"lng":-75.6415558,"lat":6.2773343},{"lng":-75.6402683,"lat":6.2762252},{"lng":-75.6388092,"lat":6.2752014},{"lng":-75.6370926,"lat":6.2744335},{"lng":-75.6363201,"lat":6.2729831},{"lng":-75.633831,"lat":6.2726419},{"lng":-75.6321144,"lat":6.2719593},{"lng":-75.6312561,"lat":6.2706796},{"lng":-75.6299686,"lat":6.268376},{"lng":-75.6275654,"lat":6.2675228},{"lng":-75.6267929,"lat":6.2681201},{"lng":-75.6266212,"lat":6.2711062},{"lng":-75.6279945,"lat":6.2723859},{"lng":-75.6279945,"lat":6.2735804},{"lng":-75.6261921,"lat":6.2748601},{"lng":-75.6248188,"lat":6.2745188},{"lng":-75.6224155,"lat":6.2750307},{"lng":-75.6217289,"lat":6.2760545},{"lng":-75.6203556,"lat":6.2757986},{"lng":-75.6197548,"lat":6.2748601},{"lng":-75.6195831,"lat":6.2732391},{"lng":-75.617609,"lat":6.2724712},{"lng":-75.618124,"lat":6.2713621},{"lng":-75.6194115,"lat":6.2705943},{"lng":-75.6188107,"lat":6.2692292},{"lng":-75.619669,"lat":6.2677788},{"lng":-75.6193256,"lat":6.2665843},{"lng":-75.6178665,"lat":6.2654752},{"lng":-75.6164074,"lat":6.2643661},{"lng":-75.6163216,"lat":6.2632569},{"lng":-75.6169224,"lat":6.2620625},{"lng":-75.618124,"lat":6.2621478},{"lng":-75.619669,"lat":6.2626597},{"lng":-75.6211281,"lat":6.2624037},{"lng":-75.6219864,"lat":6.2635129},{"lng":-75.6231022,"lat":6.2636835},{"lng":-75.6243038,"lat":6.2624891},{"lng":-75.6238747,"lat":6.2606974},{"lng":-75.6230164,"lat":6.2590763},{"lng":-75.6233597,"lat":6.2575406},{"lng":-75.6246471,"lat":6.2582231},{"lng":-75.6263638,"lat":6.2600148},{"lng":-75.6272221,"lat":6.2614652},{"lng":-75.6286812,"lat":6.2630863},{"lng":-75.628767,"lat":6.2612946},{"lng":-75.629282,"lat":6.2601001},{"lng":-75.6302261,"lat":6.2596735},{"lng":-75.6319427,"lat":6.2594176},{"lng":-75.6315136,"lat":6.2575406},{"lng":-75.6293678,"lat":6.2566874},{"lng":-75.6297112,"lat":6.2557489},{"lng":-75.6312561,"lat":6.2557489},{"lng":-75.6322861,"lat":6.2550663},{"lng":-75.6322002,"lat":6.2537012},{"lng":-75.6311703,"lat":6.2525067},{"lng":-75.6294537,"lat":6.252592},{"lng":-75.6289387,"lat":6.2513975},{"lng":-75.6312561,"lat":6.250715},{"lng":-75.6334877,"lat":6.2510563},{"lng":-75.6355476,"lat":6.2512269},{"lng":-75.6370068,"lat":6.2503737},{"lng":-75.6372643,"lat":6.2487526},{"lng":-75.6355476,"lat":6.2482407},{"lng":-75.635376,"lat":6.2473022},{"lng":-75.6364059,"lat":6.2464489},{"lng":-75.6352901,"lat":6.2449985},{"lng":-75.6337452,"lat":6.245681},{"lng":-75.6315136,"lat":6.2466196},{"lng":-75.6300545,"lat":6.2465343},{"lng":-75.628252,"lat":6.2449132},{"lng":-75.6261921,"lat":6.2454251},{"lng":-75.6244755,"lat":6.2445719},{"lng":-75.6229305,"lat":6.2432067},{"lng":-75.6219006,"lat":6.2415003},{"lng":-75.6208706,"lat":6.2427801},{"lng":-75.6190681,"lat":6.2430361},{"lng":-75.6182098,"lat":6.2420122},{"lng":-75.6166649,"lat":6.2426095},{"lng":-75.6164074,"lat":6.2417563},{"lng":-75.6160641,"lat":6.239026},{"lng":-75.6137466,"lat":6.2386847},{"lng":-75.61203,"lat":6.2369782},{"lng":-75.6119442,"lat":6.2354424},{"lng":-75.6129742,"lat":6.2357837},{"lng":-75.6164074,"lat":6.2368929},{"lng":-75.6194115,"lat":6.2372342},{"lng":-75.6227589,"lat":6.2366369},{"lng":-75.6250763,"lat":6.235613},{"lng":-75.6279945,"lat":6.2345892},{"lng":-75.6302261,"lat":6.2343332},{"lng":-75.6329727,"lat":6.2353571},{"lng":-75.6347752,"lat":6.2349305},{"lng":-75.6337452,"lat":6.2343332},{"lng":-75.6342602,"lat":6.233224},{"lng":-75.6365776,"lat":6.23348},{"lng":-75.6382942,"lat":6.2328827},{"lng":-75.6370068,"lat":6.2319441},{"lng":-75.6340027,"lat":6.2321148},{"lng":-75.6310844,"lat":6.2322001},{"lng":-75.6300545,"lat":6.2319441},{"lng":-75.6275654,"lat":6.2314322},{"lng":-75.6261921,"lat":6.2317735},{"lng":-75.6239605,"lat":6.2321148},{"lng":-75.6229305,"lat":6.2333093},{"lng":-75.6208706,"lat":6.2350158},{"lng":-75.6177807,"lat":6.2348451},{"lng":-75.6174374,"lat":6.2337359},{"lng":-75.6168365,"lat":6.2320295},{"lng":-75.6159782,"lat":6.2304083},{"lng":-75.6152916,"lat":6.2289578},{"lng":-75.6145191,"lat":6.2275926},{"lng":-75.6131458,"lat":6.2265687},{"lng":-75.6123734,"lat":6.2246916},{"lng":-75.6128025,"lat":6.2229851},{"lng":-75.6148624,"lat":6.2226438},{"lng":-75.6170082,"lat":6.2228998},{"lng":-75.6198406,"lat":6.2234117},{"lng":-75.6223297,"lat":6.223753},{"lng":-75.624733,"lat":6.2246063},{"lng":-75.6260204,"lat":6.2253742},{"lng":-75.6274796,"lat":6.2250329},{"lng":-75.629282,"lat":6.2243503},{"lng":-75.6320286,"lat":6.2241797},{"lng":-75.6329727,"lat":6.2244356},{"lng":-75.634346,"lat":6.2244356},{"lng":-75.6344318,"lat":6.2232411},{"lng":-75.6360626,"lat":6.2226438},{"lng":-75.6369209,"lat":6.2231558},{"lng":-75.6383801,"lat":6.2225585},{"lng":-75.6392384,"lat":6.2218759},{"lng":-75.6405258,"lat":6.2223878},{"lng":-75.6408691,"lat":6.221108},{"lng":-75.6401825,"lat":6.2195721},{"lng":-75.6386375,"lat":6.2199987},{"lng":-75.6372643,"lat":6.22034},{"lng":-75.6378651,"lat":6.2190601},{"lng":-75.6372643,"lat":6.2176096},{"lng":-75.6354618,"lat":6.2176949},{"lng":-75.633831,"lat":6.2187188},{"lng":-75.6335735,"lat":6.2201694},{"lng":-75.6325436,"lat":6.2209373},{"lng":-75.6310844,"lat":6.2217052},{"lng":-75.6293678,"lat":6.2215346},{"lng":-75.627737,"lat":6.2210226},{"lng":-75.6259346,"lat":6.2213639},{"lng":-75.6241322,"lat":6.2223878},{"lng":-75.6230164,"lat":6.2209373},{"lng":-75.6220722,"lat":6.2211933},{"lng":-75.6219864,"lat":6.2221319},{"lng":-75.6198406,"lat":6.2219612},{"lng":-75.6200123,"lat":6.22034},{"lng":-75.6176949,"lat":6.2197427},{"lng":-75.6160641,"lat":6.2199987},{"lng":-75.6134892,"lat":6.2195721},{"lng":-75.6109142,"lat":6.2190601},{"lng":-75.6096268,"lat":6.2186335},{"lng":-75.6091118,"lat":6.216671},{"lng":-75.6077385,"lat":6.2159031},{"lng":-75.6061935,"lat":6.2161591},{"lng":-75.6047344,"lat":6.2155618},{"lng":-75.6052494,"lat":6.2141112},{"lng":-75.6059361,"lat":6.2131726},{"lng":-75.6067085,"lat":6.2123194},{"lng":-75.6068802,"lat":6.2110395},{"lng":-75.6057644,"lat":6.2101009},{"lng":-75.6067944,"lat":6.209077},{"lng":-75.6086826,"lat":6.2095036},{"lng":-75.6102276,"lat":6.2100156},{"lng":-75.6095409,"lat":6.2082237},{"lng":-75.6073093,"lat":6.2074557},{"lng":-75.6061935,"lat":6.2064318},{"lng":-75.6083393,"lat":6.2063465},{"lng":-75.6095409,"lat":6.2052372},{"lng":-75.6073093,"lat":6.2044693},{"lng":-75.6060219,"lat":6.202848},{"lng":-75.6036186,"lat":6.2022507},{"lng":-75.6031895,"lat":6.2011415},{"lng":-75.6018162,"lat":6.1996056},{"lng":-75.6017303,"lat":6.2002882},{"lng":-75.6006145,"lat":6.2005442},{"lng":-75.5997562,"lat":6.2016534},{"lng":-75.5983829,"lat":6.2030187},{"lng":-75.597353,"lat":6.2026774},{"lng":-75.5956364,"lat":6.2015681},{"lng":-75.5950356,"lat":6.2004588},{"lng":-75.5961514,"lat":6.1996909},{"lng":-75.5967522,"lat":6.1982403},{"lng":-75.597353,"lat":6.1967044},{"lng":-75.597868,"lat":6.1954244},{"lng":-75.5994129,"lat":6.1950831},{"lng":-75.600872,"lat":6.1949125},{"lng":-75.6025887,"lat":6.1945711},{"lng":-75.6042194,"lat":6.1939738},{"lng":-75.6055927,"lat":6.1940592},{"lng":-75.606966,"lat":6.1949125},{"lng":-75.6084251,"lat":6.1949125},{"lng":-75.6086826,"lat":6.1935472},{"lng":-75.609026,"lat":6.1922672},{"lng":-75.6101418,"lat":6.1914139},{"lng":-75.6121159,"lat":6.1909873},{"lng":-75.6141758,"lat":6.1913286},{"lng":-75.6163216,"lat":6.1922672},{"lng":-75.6174374,"lat":6.1933765},{"lng":-75.6182957,"lat":6.1918406},{"lng":-75.6176949,"lat":6.1902193},{"lng":-75.6179523,"lat":6.1890247},{"lng":-75.6175232,"lat":6.1873181},{"lng":-75.6153774,"lat":6.1864648},{"lng":-75.6128883,"lat":6.1830515},{"lng":-75.6134892,"lat":6.1805769},{"lng":-75.613575,"lat":6.1778463},{"lng":-75.6153774,"lat":6.1747743},{"lng":-75.6187253,"lat":6.1736647},{"lng":-75.6213856,"lat":6.1729823},{"lng":-75.6236172,"lat":6.1727263},{"lng":-75.6262779,"lat":6.1735797},{"lng":-75.6302261,"lat":6.1753716},{"lng":-75.6345177,"lat":6.1760543},{"lng":-75.6351185,"lat":6.1774196},{"lng":-75.6361485,"lat":6.1783583},{"lng":-75.6370068,"lat":6.1799796},{"lng":-75.6376934,"lat":6.1820275},{"lng":-75.6390667,"lat":6.1835635},{"lng":-75.6392384,"lat":6.1848435},{"lng":-75.639925,"lat":6.1865501},{"lng":-75.6413841,"lat":6.1866354},{"lng":-75.643959,"lat":6.1881714},{"lng":-75.6441307,"lat":6.18911},{"lng":-75.6453323,"lat":6.1900487},{"lng":-75.6469631,"lat":6.1894513},{"lng":-75.6486797,"lat":6.1894513},{"lng":-75.6501389,"lat":6.190134},{"lng":-75.6519413,"lat":6.190646},{"lng":-75.6535721,"lat":6.1909873},{"lng":-75.6546021,"lat":6.1914993},{"lng":-75.6564903,"lat":6.1912433},{"lng":-75.6559753,"lat":6.1889394},{"lng":-75.6565762,"lat":6.1877447},{"lng":-75.6580353,"lat":6.1879154},{"lng":-75.6591511,"lat":6.1887687},{"lng":-75.6618977,"lat":6.1887687},{"lng":-75.6629276,"lat":6.1877447},{"lng":-75.6619835,"lat":6.1861234},{"lng":-75.6625843,"lat":6.1853555},{"lng":-75.6626701,"lat":6.1839902},{"lng":-75.662756,"lat":6.1828809},{"lng":-75.6618118,"lat":6.1804062},{"lng":-75.6593227,"lat":6.1796383},{"lng":-75.661726,"lat":6.174689},{"lng":-75.6599236,"lat":6.1738357},{"lng":-75.6576061,"lat":6.172897},{"lng":-75.6540871,"lat":6.172641},{"lng":-75.651083,"lat":6.173665},{"lng":-75.6488514,"lat":6.1727263},{"lng":-75.6474781,"lat":6.1717023},{"lng":-75.645504,"lat":6.1714463},{"lng":-75.6443024,"lat":6.170849},{"lng":-75.6456757,"lat":6.1699957},{"lng":-75.6454182,"lat":6.169057},{"lng":-75.6445599,"lat":6.1679476},{"lng":-75.6443024,"lat":6.1663263},{"lng":-75.6446457,"lat":6.1650463},{"lng":-75.6457615,"lat":6.1663263},{"lng":-75.6464481,"lat":6.167521},{"lng":-75.6486797,"lat":6.1682037},{"lng":-75.6497955,"lat":6.1665823},{"lng":-75.6491089,"lat":6.1645343},{"lng":-75.6491089,"lat":6.1625716},{"lng":-75.6488514,"lat":6.1602675},{"lng":-75.6493664,"lat":6.1578782},{"lng":-75.6498814,"lat":6.1555741},{"lng":-75.6513405,"lat":6.1540381},{"lng":-75.6533146,"lat":6.1529287},{"lng":-75.6552029,"lat":6.152758},{"lng":-75.656662,"lat":6.1524167},{"lng":-75.6570911,"lat":6.1508806},{"lng":-75.6558895,"lat":6.1500272},{"lng":-75.6532287,"lat":6.151478},{"lng":-75.6504822,"lat":6.1519046},{"lng":-75.6473064,"lat":6.1519046},{"lng":-75.6454182,"lat":6.1505393},{"lng":-75.6430149,"lat":6.1499419},{"lng":-75.6418133,"lat":6.1490032},{"lng":-75.6408691,"lat":6.1496859},{"lng":-75.6387234,"lat":6.1492592},{"lng":-75.6381225,"lat":6.1480645},{"lng":-75.6360626,"lat":6.1474671},{"lng":-75.6365776,"lat":6.1463578},{"lng":-75.6377792,"lat":6.1450777},{"lng":-75.638895,"lat":6.1435416},{"lng":-75.6385517,"lat":6.1419202},{"lng":-75.6372642,"lat":6.1410668},{"lng":-75.6362343,"lat":6.1392747},{"lng":-75.6371784,"lat":6.1387627},{"lng":-75.6388092,"lat":6.1392747},{"lng":-75.6401825,"lat":6.1389334},{"lng":-75.6403541,"lat":6.1375679},{"lng":-75.6398392,"lat":6.1359465},{"lng":-75.6388092,"lat":6.1343251},{"lng":-75.6371784,"lat":6.1331303},{"lng":-75.6370926,"lat":6.1304848},{"lng":-75.6364918,"lat":6.1281806},{"lng":-75.6371784,"lat":6.1263031},{"lng":-75.6363201,"lat":6.1248523},{"lng":-75.6363201,"lat":6.1233162},{"lng":-75.6354618,"lat":6.1224628},{"lng":-75.6352043,"lat":6.1199879},{"lng":-75.6362343,"lat":6.1189638},{"lng":-75.6375217,"lat":6.1189638},{"lng":-75.6388092,"lat":6.1200732},{"lng":-75.6397533,"lat":6.1210973},{"lng":-75.6407833,"lat":6.1203292},{"lng":-75.6398392,"lat":6.1192198},{"lng":-75.6389809,"lat":6.1184517},{"lng":-75.6373501,"lat":6.1162329},{"lng":-75.6380367,"lat":6.1155501},{"lng":-75.6378651,"lat":6.1144407},{"lng":-75.6371784,"lat":6.1129045},{"lng":-75.6381225,"lat":6.1127338},{"lng":-75.6392383,"lat":6.1132459},{"lng":-75.6402683,"lat":6.1128192},{"lng":-75.6413841,"lat":6.1128192},{"lng":-75.6418991,"lat":6.111795},{"lng":-75.6433582,"lat":6.1118804},{"lng":-75.6432724,"lat":6.1106002},{"lng":-75.6427574,"lat":6.108808},{"lng":-75.6425857,"lat":6.1059917},{"lng":-75.6432724,"lat":6.1047969},{"lng":-75.6451607,"lat":6.1047969},{"lng":-75.6454182,"lat":6.1036874},{"lng":-75.6442165,"lat":6.1031753},{"lng":-75.6431866,"lat":6.1018952},{"lng":-75.6434441,"lat":6.1001883},{"lng":-75.6443882,"lat":6.0989081},{"lng":-75.6452465,"lat":6.0977133},{"lng":-75.6451607,"lat":6.0967745},{"lng":-75.644989,"lat":6.0952383},{"lng":-75.6462765,"lat":6.0933607},{"lng":-75.6468773,"lat":6.0916537},{"lng":-75.6468773,"lat":6.0893494},{"lng":-75.6453323,"lat":6.0875571},{"lng":-75.644474,"lat":6.0861916},{"lng":-75.6425857,"lat":6.0857648},{"lng":-75.6426716,"lat":6.0834605},{"lng":-75.6435299,"lat":6.0805586},{"lng":-75.6430149,"lat":6.0787663},{"lng":-75.6416416,"lat":6.0775715},{"lng":-75.6389809,"lat":6.0784249},{"lng":-75.6365776,"lat":6.0797905},{"lng":-75.6347752,"lat":6.0802172},{"lng":-75.6346893,"lat":6.0790224},{"lng":-75.634861,"lat":6.0765473},{"lng":-75.6337452,"lat":6.0751817},{"lng":-75.6314278,"lat":6.0755231},{"lng":-75.6297111,"lat":6.0776568},{"lng":-75.6290245,"lat":6.0799612},{"lng":-75.6295395,"lat":6.0818389},{"lng":-75.629797,"lat":6.0831191},{"lng":-75.629282,"lat":6.0841432},{"lng":-75.6294536,"lat":6.0857648},{"lng":-75.627737,"lat":6.0851674},{"lng":-75.6254196,"lat":6.0851674},{"lng":-75.623703,"lat":6.0841432},{"lng":-75.6240463,"lat":6.0856795},{"lng":-75.6234455,"lat":6.0867036},{"lng":-75.6212997,"lat":6.0865329},{"lng":-75.6212139,"lat":6.0874718},{"lng":-75.6241321,"lat":6.0886666},{"lng":-75.6252479,"lat":6.0903735},{"lng":-75.6264496,"lat":6.0925925},{"lng":-75.6261063,"lat":6.0937874},{"lng":-75.6249046,"lat":6.0949822},{"lng":-75.6238747,"lat":6.0961771},{"lng":-75.6215572,"lat":6.0963477},{"lng":-75.6219005,"lat":6.0977986},{"lng":-75.6210422,"lat":6.098396},{"lng":-75.6213856,"lat":6.0996762},{"lng":-75.619154,"lat":6.1007003},{"lng":-75.6190681,"lat":6.1019805},{"lng":-75.6204414,"lat":6.1020659},{"lng":-75.6222439,"lat":6.1024926},{"lng":-75.6243038,"lat":6.1005297},{"lng":-75.6267929,"lat":6.0990788},{"lng":-75.6300545,"lat":6.0971159},{"lng":-75.6328869,"lat":6.0960917},{"lng":-75.6350326,"lat":6.0955796},{"lng":-75.6352043,"lat":6.0977986},{"lng":-75.6354618,"lat":6.0995909},{"lng":-75.635891,"lat":6.1024072},{"lng":-75.6356335,"lat":6.1052236},{"lng":-75.6351185,"lat":6.1071865},{"lng":-75.6347752,"lat":6.1110269},{"lng":-75.6340027,"lat":6.1137579},{"lng":-75.6321144,"lat":6.11427},{"lng":-75.6299686,"lat":6.1146113},{"lng":-75.630312,"lat":6.1162328},{"lng":-75.6307411,"lat":6.1181957},{"lng":-75.6309128,"lat":6.1193905},{"lng":-75.6300545,"lat":6.1222067},{"lng":-75.6302261,"lat":6.1257057},{"lng":-75.6311703,"lat":6.1280099},{"lng":-75.6315994,"lat":6.1303994},{"lng":-75.6316852,"lat":6.1322769},{"lng":-75.6320286,"lat":6.1361172},{"lng":-75.630312,"lat":6.1379946},{"lng":-75.6291103,"lat":6.13936},{"lng":-75.6300545,"lat":6.1407255},{"lng":-75.632801,"lat":6.1414082},{"lng":-75.6329727,"lat":6.1431149},{"lng":-75.6330585,"lat":6.1456751},{"lng":-75.633831,"lat":6.1474671},{"lng":-75.6341743,"lat":6.1487472},{"lng":-75.633831,"lat":6.1504539},{"lng":-75.633316,"lat":6.1515633},{"lng":-75.6322861,"lat":6.1501979},{"lng":-75.6299686,"lat":6.1494299},{"lng":-75.6279087,"lat":6.1484058},{"lng":-75.6262779,"lat":6.1470404},{"lng":-75.6255054,"lat":6.1455897},{"lng":-75.6232738,"lat":6.1439683},{"lng":-75.6204414,"lat":6.1421762},{"lng":-75.6183815,"lat":6.1421762},{"lng":-75.6171799,"lat":6.1408961},{"lng":-75.6162357,"lat":6.1389334},{"lng":-75.6159782,"lat":6.1398721},{"lng":-75.6149483,"lat":6.1398721},{"lng":-75.6142616,"lat":6.1384213},{"lng":-75.6132317,"lat":6.1384213},{"lng":-75.6134033,"lat":6.1410668},{"lng":-75.6144333,"lat":6.1434563},{"lng":-75.6151199,"lat":6.145163},{"lng":-75.6150341,"lat":6.1471258},{"lng":-75.6129742,"lat":6.1464431},{"lng":-75.6109142,"lat":6.1465284},{"lng":-75.6084251,"lat":6.1474671},{"lng":-75.606966,"lat":6.1496006},{"lng":-75.6061077,"lat":6.151222},{"lng":-75.6052494,"lat":6.152758},{"lng":-75.6062794,"lat":6.153526},{"lng":-75.6079102,"lat":6.1543794},{"lng":-75.6067085,"lat":6.1552328},{"lng":-75.6051636,"lat":6.1558301},{"lng":-75.6041336,"lat":6.1547207},{"lng":-75.6036186,"lat":6.1536114},{"lng":-75.6037903,"lat":6.1523313},{"lng":-75.6022453,"lat":6.1508806},{"lng":-75.6002712,"lat":6.1499419},{"lng":-75.5979538,"lat":6.1484058},{"lng":-75.595808,"lat":6.1484912},{"lng":-75.595808,"lat":6.1501979},{"lng":-75.5961514,"lat":6.1519046},{"lng":-75.5952072,"lat":6.1523313},{"lng":-75.5936623,"lat":6.1506246},{"lng":-75.5916023,"lat":6.1500272},{"lng":-75.5890274,"lat":6.1505393},{"lng":-75.5881691,"lat":6.1513073},{"lng":-75.5866241,"lat":6.1506246},{"lng":-75.5855083,"lat":6.1495152},{"lng":-75.586195,"lat":6.1484058},{"lng":-75.5855942,"lat":6.1467844},{"lng":-75.5842209,"lat":6.1463578},{"lng":-75.5821609,"lat":6.1459311},{"lng":-75.5802727,"lat":6.1462724},{"lng":-75.5794144,"lat":6.1478938},{"lng":-75.5779552,"lat":6.1473818},{"lng":-75.5764961,"lat":6.1467844},{"lng":-75.5749512,"lat":6.1467844},{"lng":-75.5744362,"lat":6.1490032},{"lng":-75.5746078,"lat":6.1504539},{"lng":-75.5735779,"lat":6.1519046},{"lng":-75.574522,"lat":6.1531847},{"lng":-75.5746937,"lat":6.1542941},{"lng":-75.5732346,"lat":6.1551474},{"lng":-75.5735779,"lat":6.1564275},{"lng":-75.5746078,"lat":6.1562568},{"lng":-75.5740929,"lat":6.1582195},{"lng":-75.5734062,"lat":6.1595849},{"lng":-75.5717754,"lat":6.1599262},{"lng":-75.569973,"lat":6.1611209},{"lng":-75.5690289,"lat":6.1613769},{"lng":-75.5680847,"lat":6.1606089},{"lng":-75.5671406,"lat":6.1594995},{"lng":-75.5659389,"lat":6.1589875},{"lng":-75.564909,"lat":6.1607795},{"lng":-75.5656815,"lat":6.1622302},{"lng":-75.5656815,"lat":6.1639369},{"lng":-75.5642223,"lat":6.1633396},{"lng":-75.562849,"lat":6.1641076},{"lng":-75.5630207,"lat":6.1650463},{"lng":-75.5637073,"lat":6.167265},{"lng":-75.5623341,"lat":6.1687156},{"lng":-75.5619049,"lat":6.1704223},{"lng":-75.5602741,"lat":6.1728116},{"lng":-75.5584717,"lat":6.1743476},{"lng":-75.5569267,"lat":6.1756276},{"lng":-75.5554676,"lat":6.1777609},{"lng":-75.553236,"lat":6.1805769},{"lng":-75.5524635,"lat":6.1839902},{"lng":-75.5525494,"lat":6.1871474},{"lng":-75.5533218,"lat":6.1885127},{"lng":-75.5540943,"lat":6.1917553},{"lng":-75.5535793,"lat":6.1933765},{"lng":-75.552721,"lat":6.1955098},{"lng":-75.5513477,"lat":6.1989229},{"lng":-75.5506611,"lat":6.2011415},{"lng":-75.5505753,"lat":6.203104},{"lng":-75.5480003,"lat":6.2043839},{"lng":-75.5480862,"lat":6.2067731},{"lng":-75.5479145,"lat":6.208565},{"lng":-75.5473137,"lat":6.2097596},{"lng":-75.5475712,"lat":6.2107835},{"lng":-75.5474853,"lat":6.2122341},{"lng":-75.5461979,"lat":6.2141966},{"lng":-75.5451679,"lat":6.2153911},{"lng":-75.5455112,"lat":6.217183},{"lng":-75.5467129,"lat":6.2182922},{"lng":-75.5484295,"lat":6.2199134},{"lng":-75.5506611,"lat":6.2205107},{"lng":-75.5528927,"lat":6.2200841},{"lng":-75.5548668,"lat":6.2207667},{"lng":-75.5565834,"lat":6.2211933},{"lng":-75.5582142,"lat":6.2215346},{"lng":-75.5597591,"lat":6.2228998},{"lng":-75.5607891,"lat":6.2213639},{"lng":-75.5625915,"lat":6.220596},{"lng":-75.5636215,"lat":6.2199134},{"lng":-75.564909,"lat":6.2191455},{"lng":-75.5653381,"lat":6.22034},{"lng":-75.5651987,"lat":6.2225052},{"lng":-75.5651665,"lat":6.2247663},{"lng":-75.5640507,"lat":6.2253742},{"lng":-75.5623341,"lat":6.2253742},{"lng":-75.5617332,"lat":6.2254595},{"lng":-75.5604458,"lat":6.2246063},{"lng":-75.5597591,"lat":6.2255448},{"lng":-75.5583,"lat":6.2256302},{"lng":-75.55727,"lat":6.2268247},{"lng":-75.5583,"lat":6.2286165},{"lng":-75.5584717,"lat":6.2310909},{"lng":-75.55727,"lat":6.230579},{"lng":-75.5559826,"lat":6.2294698},{"lng":-75.5540085,"lat":6.2281046},{"lng":-75.5518627,"lat":6.2275926},{"lng":-75.5510044,"lat":6.2289578},{"lng":-75.5503178,"lat":6.230067},{"lng":-75.548687,"lat":6.2298964},{"lng":-75.5495453,"lat":6.2283606},{"lng":-75.5490303,"lat":6.2264834},{"lng":-75.5477428,"lat":6.2263981},{"lng":-75.5463695,"lat":6.2254595},{"lng":-75.5437088,"lat":6.2252036},{"lng":-75.5418205,"lat":6.2252889},{"lng":-75.5404472,"lat":6.2275926},{"lng":-75.5412197,"lat":6.2292138},{"lng":-75.5403614,"lat":6.2316029},{"lng":-75.5398464,"lat":6.2306643},{"lng":-75.5395031,"lat":6.2288725},{"lng":-75.5376148,"lat":6.2286165},{"lng":-75.5369282,"lat":6.2279339},{"lng":-75.537014,"lat":6.2263981},{"lng":-75.535984,"lat":6.2239237},{"lng":-75.5328083,"lat":6.2239237},{"lng":-75.5333233,"lat":6.2250329},{"lng":-75.5341816,"lat":6.22691},{"lng":-75.5332375,"lat":6.2277633},{"lng":-75.5318642,"lat":6.2269954},{"lng":-75.5307484,"lat":6.2273367},{"lng":-75.5293751,"lat":6.2272513},{"lng":-75.5275726,"lat":6.227422},{"lng":-75.5259418,"lat":6.2287018},{"lng":-75.5261993,"lat":6.2299817},{"lng":-75.5269718,"lat":6.2316882},{"lng":-75.525856,"lat":6.2328827},{"lng":-75.524826,"lat":6.2342479},{"lng":-75.5249119,"lat":6.2360397},{"lng":-75.526886,"lat":6.235869},{"lng":-75.5267143,"lat":6.2369782},{"lng":-75.526371,"lat":6.2383434},{"lng":-75.526886,"lat":6.2389406},{"lng":-75.5268002,"lat":6.2397939},{"lng":-75.5275726,"lat":6.2395379},{"lng":-75.5291176,"lat":6.2388553},{"lng":-75.5306625,"lat":6.240903},{"lng":-75.53092,"lat":6.2397085},{"lng":-75.5321217,"lat":6.2391113},{"lng":-75.5332375,"lat":6.2386847},{"lng":-75.5342674,"lat":6.2376608},{"lng":-75.5352974,"lat":6.2380021},{"lng":-75.5364132,"lat":6.2381727},{"lng":-75.5372715,"lat":6.2396232},{"lng":-75.538044,"lat":6.241415},{"lng":-75.5386448,"lat":6.2428654},{"lng":-75.5397606,"lat":6.2446572},{"lng":-75.5396748,"lat":6.2470462},{"lng":-75.5386448,"lat":6.2473875},{"lng":-75.5377006,"lat":6.2489232},{"lng":-75.5374432,"lat":6.2514829},{"lng":-75.537529,"lat":6.2541278},{"lng":-75.5370998,"lat":6.2562608},{"lng":-75.5377006,"lat":6.2576259},{"lng":-75.5386448,"lat":6.2566874},{"lng":-75.541563,"lat":6.2561755},{"lng":-75.543623,"lat":6.2545544},{"lng":-75.5462837,"lat":6.2529333},{"lng":-75.5480003,"lat":6.2538718},{"lng":-75.5479145,"lat":6.2556635},{"lng":-75.5462837,"lat":6.2569433},{"lng":-75.5445671,"lat":6.2577965},{"lng":-75.5430222,"lat":6.2588204},{"lng":-75.5429363,"lat":6.2606121},{"lng":-75.5408764,"lat":6.261124},{"lng":-75.5399322,"lat":6.2620625},{"lng":-75.5393314,"lat":6.2638542},{"lng":-75.538044,"lat":6.2635129},{"lng":-75.5371857,"lat":6.2620625},{"lng":-75.535469,"lat":6.2641101},{"lng":-75.5331516,"lat":6.2660724},{"lng":-75.5340958,"lat":6.2684613},{"lng":-75.5355549,"lat":6.2710208},{"lng":-75.5360699,"lat":6.273495},{"lng":-75.5377865,"lat":6.273751},{"lng":-75.537014,"lat":6.2744335},{"lng":-75.5340099,"lat":6.2752014},{"lng":-75.5349541,"lat":6.2759692},{"lng":-75.5358124,"lat":6.2781021},{"lng":-75.5371857,"lat":6.2798937},{"lng":-75.5366707,"lat":6.2817707},{"lng":-75.535984,"lat":6.2843301},{"lng":-75.5350399,"lat":6.2860364},{"lng":-75.5363274,"lat":6.2930322},{"lng":-75.5370998,"lat":6.2943972},{"lng":-75.5363274,"lat":6.2952503},{"lng":-75.5361557,"lat":6.2968713},{"lng":-75.5367565,"lat":6.2980657},{"lng":-75.5383015,"lat":6.3001985},{"lng":-75.5397606,"lat":6.3018194},{"lng":-75.541048,"lat":6.3025872},{"lng":-75.5426788,"lat":6.3037816},{"lng":-75.5437088,"lat":6.3039522},{"lng":-75.5455112,"lat":6.3049759},{"lng":-75.5477428,"lat":6.3054878},{"lng":-75.5491161,"lat":6.3063409},{"lng":-75.5475712,"lat":6.3069381},{"lng":-75.5460262,"lat":6.3067675},{"lng":-75.5441379,"lat":6.3064262},{"lng":-75.5437946,"lat":6.3080472},{"lng":-75.5432796,"lat":6.3094974},{"lng":-75.5443096,"lat":6.3111183},{"lng":-75.5467987,"lat":6.312398},{"lng":-75.5494595,"lat":6.3123127},{"lng":-75.5492878,"lat":6.3135923},{"lng":-75.5473137,"lat":6.3154692},{"lng":-75.5469704,"lat":6.3183697},{"lng":-75.5467129,"lat":6.3210143},{"lng":-75.5468845,"lat":6.3226351},{"lng":-75.5467129,"lat":6.3248532},{"lng":-75.5455971,"lat":6.3263887},{"lng":-75.5442238,"lat":6.326474},{"lng":-75.5423355,"lat":6.3249385},{"lng":-75.5404472,"lat":6.3255356},{"lng":-75.5387306,"lat":6.3265593},{"lng":-75.5390739,"lat":6.3277536},{"lng":-75.5368423,"lat":6.3286067},{"lng":-75.5347824,"lat":6.3282655},{"lng":-75.5350399,"lat":6.3295451},{"lng":-75.5334091,"lat":6.3303982},{"lng":-75.5313492,"lat":6.3311659},{"lng":-75.5298901,"lat":6.3311659},{"lng":-75.5292034,"lat":6.332019},{"lng":-75.5289459,"lat":6.3337251},{"lng":-75.5265427,"lat":6.3348341},{"lng":-75.5249977,"lat":6.3361137},{"lng":-75.5225086,"lat":6.3367109},{"lng":-75.5207062,"lat":6.3380758},{"lng":-75.5190754,"lat":6.3377345},{"lng":-75.5170155,"lat":6.3375639},{"lng":-75.5140114,"lat":6.3385023},{"lng":-75.5125523,"lat":6.3385023},{"lng":-75.511179,"lat":6.3393554},{"lng":-75.5098915,"lat":6.3402084},{"lng":-75.5084324,"lat":6.339526},{"lng":-75.5068016,"lat":6.3385876},{"lng":-75.5053425,"lat":6.3389288},{"lng":-75.5049133,"lat":6.3408055},{"lng":-75.5043125,"lat":6.3420851},{"lng":-75.5031967,"lat":6.3435353},{"lng":-75.5019093,"lat":6.3454973},{"lng":-75.500536,"lat":6.3469475},{"lng":-75.4991627,"lat":6.3478006},{"lng":-75.4971027,"lat":6.3483124},{"lng":-75.4973602,"lat":6.3498479},{"lng":-75.4965019,"lat":6.3507862},{"lng":-75.4953861,"lat":6.350445},{"lng":-75.4942703,"lat":6.3489948},{"lng":-75.4928112,"lat":6.3494213},{"lng":-75.4909229,"lat":6.3491654},{"lng":-75.4903221,"lat":6.3507862},{"lng":-75.4908371,"lat":6.3521511},{"lng":-75.4904938,"lat":6.3540278},{"lng":-75.4904938,"lat":6.3556485},{"lng":-75.4895496,"lat":6.3565015},{"lng":-75.4898071,"lat":6.358037},{"lng":-75.4890347,"lat":6.3594871},{"lng":-75.4879189,"lat":6.3612785},{"lng":-75.4867172,"lat":6.3628992},{"lng":-75.4877472,"lat":6.3634963},{"lng":-75.4892063,"lat":6.3648612},{"lng":-75.4886055,"lat":6.3659701},{"lng":-75.4875755,"lat":6.3669084},{"lng":-75.4880047,"lat":6.3697233},{"lng":-75.4876614,"lat":6.3716853},{"lng":-75.4866314,"lat":6.3728795},{"lng":-75.484314,"lat":6.3743296},{"lng":-75.4825115,"lat":6.3754385},{"lng":-75.4805374,"lat":6.3765474},{"lng":-75.4776192,"lat":6.3746708},{"lng":-75.4759884,"lat":6.3753532},{"lng":-75.4747868,"lat":6.3763768},{"lng":-75.4764175,"lat":6.3772298},{"lng":-75.4783058,"lat":6.3780828},{"lng":-75.4803658,"lat":6.3789358},{"lng":-75.4770184,"lat":6.3799593},{"lng":-75.4710102,"lat":6.3814094},{"lng":-75.4671478,"lat":6.3820918},{"lng":-75.4631996,"lat":6.3829448},{"lng":-75.4571915,"lat":6.3827742},{"lng":-75.4565048,"lat":6.3799593},{"lng":-75.4579639,"lat":6.3791916},{"lng":-75.460453,"lat":6.3789358},{"lng":-75.4635429,"lat":6.378424},{"lng":-75.4634571,"lat":6.3768886},{"lng":-75.4619122,"lat":6.3739031},{"lng":-75.4596806,"lat":6.3692115},{"lng":-75.4581356,"lat":6.3688703},{"lng":-75.455904,"lat":6.3682732},{"lng":-75.4533291,"lat":6.3682732},{"lng":-75.4532433,"lat":6.3664819},{"lng":-75.4524708,"lat":6.3644347},{"lng":-75.450325,"lat":6.3655436},{"lng":-75.4483509,"lat":6.3663113},{"lng":-75.4463768,"lat":6.3652024},{"lng":-75.4443169,"lat":6.3691262},{"lng":-75.4427719,"lat":6.3711735},{"lng":-75.4411411,"lat":6.374159},{"lng":-75.4419136,"lat":6.3760356},{"lng":-75.4415703,"lat":6.3782534},{"lng":-75.439682,"lat":6.3780828},{"lng":-75.4373646,"lat":6.3785946},{"lng":-75.4359055,"lat":6.3803858},{"lng":-75.4369354,"lat":6.380727},{"lng":-75.4377079,"lat":6.3845655},{"lng":-75.4370213,"lat":6.3914746},{"lng":-75.4374504,"lat":6.3968483},{"lng":-75.440712,"lat":6.3959953},{"lng":-75.4436302,"lat":6.3942894},{"lng":-75.4467201,"lat":6.3919864},{"lng":-75.4495525,"lat":6.3895981},{"lng":-75.4540157,"lat":6.3873803},{"lng":-75.4590797,"lat":6.3850773}]

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-nuevo.923438a.png";

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAJJSURBVHjaZJLLalVZEIa/qrX22uccc1FjSCBoC7akob2h6MiZU8eCDpx0z/IC5gUaH0BQ8AF64My5jgSbVoJBRZ0LipeTyznx7MtatRzsGGJ3TYpa/FWLv+qTnDP/jcmzf1Z64+pOSglU8SHAwpEznFx+uV/n9xdf3r1eqr8OV8um+S2Y7L3XkwnbHz/e0qa6Pff72b0B8uPnzedrN/PG1kp/0l4qC0FUwQycQs5UTSSX/S09NL1aXjx/F0ABPrx9vbS9vX1TRC71+n3Eua5RpMveU5Ylqjo7Ho9vbKy/vAwg6c2rpeFwuNofVSsHpIRkUNdkn5GiwFJEvYc6gu9h1tIM+k96xxev+tFo9D7njHMOmggxgQiiAjF22awzuWuxbdvL9ebmpp/dqUkp4doE2cABztEUEGPEOUVECOohR8QyB2JD3BihMUbMDFQhBBDB2pacMyEEAMyMnBKWEuI92uuRc0aTAN5BNqxtQAWcEmMkpUQbI857EMUyIEKqKooQ0HIw6CbnjHrPj9MVRYGqEkIgxthBURSQ855G2/nDU597xV9bIkBATFFTQgKpWlyV8LUh4sAKYptppmbuxWOLR7X4dXlnZmbmoXPuESl1W1XtNi6CqlKUZXfzuial9HUwPT0Jv5x4v0fY57UX12248cegsStlTjhh1+su761RIRQLc9emLpx78BPb8+fP/d2urSNbO5+ovp3Olk4hgllCRCjLcr0/e/Api/NP/8f2/hg///fP/k5938xQ51BVbGHuiju5/Hi/7vsAZ8kdRHC1yC4AAAAASUVORK5CYII="

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Servicio__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Servicio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Servicio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Mapa__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Mapa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Mapa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Mensajero__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Mensajero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Mensajero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Mensajeros__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Mensajeros___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Mensajeros__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UserMap__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UserMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_UserMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Servicios__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Servicios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Servicios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Metrics__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Metrics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Metrics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Eficiencia__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Eficiencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Eficiencia__);
/* eslint-disable */












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/tracking/:id',
    name: 'Servicio',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Servicio___default.a,
    props: function props(route) {
      return { query: [route.query.nav, route.query.adm] };
    }
  }, {
    path: '/servicios/:id',
    name: 'Servicios',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Servicios___default.a
  }, {
    path: '/map/:id',
    name: 'Mapa',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Mapa___default.a
  }, {
    path: '/mensajero/:id',
    name: 'Mensajero',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Mensajero___default.a,
    props: function props(route) {
      return { query: [route.query.inicio, route.query.fin] };
    }
  }, {
    path: '/mensajeros',
    name: 'Mensajeros',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Mensajeros___default.a
  }, {
    path: '/user/:id',
    name: 'Mensajeros',
    component: __WEBPACK_IMPORTED_MODULE_7__components_UserMap___default.a
  }, {
    path: '/mapa-clientes',
    name: 'Metrics',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Metrics___default.a
  }, {
    path: '/eficiencia',
    name: 'Eficiencia',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Eficiencia___default.a
    /*     {
          path: "*",
          redirect: '/'
        } */
  }]
}));

/***/ })

},[232]);


// WEBPACK FOOTER //
// static/js/app.02d2d2ab907b8ab77abf.js